(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],2:[function(require,module,exports){
"use strict";

/*
 * jQuery Tabs plugin
 */
(function ($, $win) {
  'use strict';

  function Tabset($holder, options) {
    this.$holder = $holder;
    this.options = options;
    this.init();
  }

  Tabset.prototype = {
    init: function init() {
      this.$tabLinks = this.$holder.find(this.options.tabLinks);
      this.setStartActiveIndex();
      this.setActiveTab();

      if (this.options.autoHeight) {
        this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attrib)).parent();
      }
    },
    setStartActiveIndex: function setStartActiveIndex() {
      var $classTargets = this.getClassTarget(this.$tabLinks);
      var $activeLink = $classTargets.filter('.' + this.options.activeClass);
      var $hashLink = this.$tabLinks.filter('[' + this.options.attrib + '="' + location.hash + '"]');
      var activeIndex;

      if (this.options.checkHash && $hashLink.length) {
        $activeLink = $hashLink;
      }

      activeIndex = $classTargets.index($activeLink);
      this.activeTabIndex = this.prevTabIndex = activeIndex === -1 ? this.options.defaultTab ? 0 : null : activeIndex;
    },
    setActiveTab: function setActiveTab() {
      var self = this;
      this.$tabLinks.each(function (i, link) {
        var $link = $(link);
        var $classTarget = self.getClassTarget($link);
        var $tab = $($link.attr(self.options.attrib));

        if (i !== self.activeTabIndex) {
          $classTarget.removeClass(self.options.activeClass);
          $tab.addClass(self.options.tabHiddenClass).removeClass(self.options.activeClass);
        } else {
          $classTarget.addClass(self.options.activeClass);
          $tab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
        }

        self.attachTabLink($link, i);
      });
    },
    attachTabLink: function attachTabLink($link, i) {
      var self = this;
      $link.on(this.options.event + '.tabset', function (e) {
        e.preventDefault();

        if (self.activeTabIndex === self.prevTabIndex && self.activeTabIndex !== i) {
          self.activeTabIndex = i;
          self.switchTabs();
        }
      });
    },
    resizeHolder: function resizeHolder(height) {
      var self = this;

      if (height) {
        this.$tabHolder.height(height);
        setTimeout(function () {
          self.$tabHolder.addClass('transition');
        }, 10);
      } else {
        self.$tabHolder.removeClass('transition').height('');
      }
    },
    switchTabs: function switchTabs() {
      var self = this;
      var $prevLink = this.$tabLinks.eq(this.prevTabIndex);
      var $nextLink = this.$tabLinks.eq(this.activeTabIndex);
      var $prevTab = this.getTab($prevLink);
      var $nextTab = this.getTab($nextLink);
      $prevTab.removeClass(this.options.activeClass);

      if (self.haveTabHolder()) {
        this.resizeHolder($prevTab.outerHeight());
      }

      setTimeout(function () {
        self.getClassTarget($prevLink).removeClass(self.options.activeClass);
        $prevTab.addClass(self.options.tabHiddenClass);
        $nextTab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
        self.getClassTarget($nextLink).addClass(self.options.activeClass);

        if (self.haveTabHolder()) {
          self.resizeHolder($nextTab.outerHeight());
          setTimeout(function () {
            self.resizeHolder();
            self.prevTabIndex = self.activeTabIndex;
            self.makeCallback('onChange', $nextLink);
          }, self.options.animSpeed);
        } else {
          self.prevTabIndex = self.activeTabIndex;
          self.makeCallback('onChange', $nextLink);
        }
      }, this.options.autoHeight ? this.options.animSpeed : 1);
    },
    getClassTarget: function getClassTarget($link) {
      return this.options.addToParent ? $link.parent() : $link;
    },
    getActiveTab: function getActiveTab() {
      return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
    },
    getTab: function getTab($link) {
      return $($link.attr(this.options.attrib));
    },
    haveTabHolder: function haveTabHolder() {
      return this.$tabHolder && this.$tabHolder.length;
    },
    destroy: function destroy() {
      var self = this;
      this.$tabLinks.off('.tabset').each(function () {
        var $link = $(this);
        self.getClassTarget($link).removeClass(self.options.activeClass);
        $($link.attr(self.options.attrib)).removeClass(self.options.activeClass + ' ' + self.options.tabHiddenClass);
      });
      this.$holder.removeData('Tabset');
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  };

  $.fn.tabset = function (options) {
    options = $.extend({
      activeClass: 'active',
      addToParent: false,
      autoHeight: false,
      checkHash: false,
      defaultTab: true,
      animSpeed: 500,
      tabLinks: 'a',
      attrib: 'href',
      event: 'click',
      tabHiddenClass: 'js-tab-hidden'
    }, options);
    options.autoHeight = options.autoHeight && $.support.opacity;
    return this.each(function () {
      var $holder = $(this);

      if (!$holder.data('Tabset')) {
        $holder.data('Tabset', new Tabset($holder, options));
      }
    });
  };
})(jQuery, jQuery(window));

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var makeRowFromColumns = function makeRowFromColumns(columns) {
  var cellSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.cell';
  var rows = [];

  if (columns && cellSelector) {
    _toConsumableArray(columns).forEach(function (col) {
      var cells = col.querySelectorAll(cellSelector);

      _toConsumableArray(cells).forEach(function (cell, i) {
        if (typeof rows[i] === 'undefined') {
          rows[i] = [];
        }

        rows[i].push(cell);
      });
    });
  }

  return rows;
};

var _default = makeRowFromColumns;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _makeRowsFromColumns = _interopRequireDefault(require("./make-rows-from-columns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RowHoverHelper =
/*#__PURE__*/
function () {
  function RowHoverHelper(holder, opts) {
    _classCallCheck(this, RowHoverHelper);

    if (holder) {
      this.opts = Object.assign({
        holderSelector: '.table-body',
        hoverClass: 'highlited',
        columns: '.table-cell',
        cellsClass: 'cell'
      }, opts);
      this.holder = holder;
      this.init();
    }
  }

  _createClass(RowHoverHelper, [{
    key: "init",
    value: function init() {
      this.rows = [];
      this.findElements();
      this.updateRows();
      this.attachEvents();
      this.isInited = true;
    }
  }, {
    key: "findElements",
    value: function findElements() {
      this.columns = this.holder.querySelectorAll(this.opts.columns);
      this.allCells = this.holder.querySelectorAll(".".concat(this.opts.cellsClass));
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.onMouseOver = function (e) {
        var t = e.target;
        var cell = null;
        var parent = t.closest(".".concat(_this.opts.cellsClass));

        if (t.classList.contains(_this.opts.cellsClass)) {
          cell = t;
        } else if (parent) {
          cell = parent;
        }

        if (cell) {
          _this.makeHighlight(cell);
        }
      };

      this.onMouseOut = function (e) {
        var currentTarget = e.currentTarget,
            relatedTarget = e.relatedTarget;

        if (!relatedTarget || relatedTarget !== currentTarget && !relatedTarget.closest(_this.opts.holderSelector)) {
          _this.removeHighlight();
        }
      };

      this.holder.addEventListener('mouseover', this.onMouseOver);
      this.holder.addEventListener('mouseout', this.onMouseOut);
    }
  }, {
    key: "makeHighlight",
    value: function makeHighlight(activeCell) {
      var _this2 = this;

      if (activeCell) {
        this.rows.forEach(function (row) {
          row.forEach(function (cell) {
            if (row.indexOf(activeCell) > -1) {
              cell.classList.add(_this2.opts.hoverClass);
            } else {
              cell.classList.remove(_this2.opts.hoverClass);
            }
          });
        });
      }
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      var _this3 = this;

      _toConsumableArray(this.allCells).forEach(function (cell) {
        cell.classList.remove(_this3.opts.hoverClass);
      });
    }
  }, {
    key: "updateRows",
    value: function updateRows() {
      this.rows = (0, _makeRowsFromColumns["default"])(this.columns, ".".concat(this.opts.cellsClass)) || [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isInited) {
        this.holder.removeEventListener('mouseover', this.onMouseOver);
        this.holder.removeEventListener('mouseout', this.onMouseOut);
        this.removeHighlight();
      }
    }
  }]);

  return RowHoverHelper;
}();

var _default = RowHoverHelper;
exports["default"] = _default;

},{"./make-rows-from-columns":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _makeRowsFromColumns = _interopRequireDefault(require("./make-rows-from-columns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SameHeightCell =
/*#__PURE__*/
function () {
  function SameHeightCell(holder, opts) {
    _classCallCheck(this, SameHeightCell);

    if (holder) {
      this.opts = Object.assign({
        columns: '.table-cell',
        cells: '.cell',
        propName: 'min-height'
      }, opts);
      this.holder = holder;
      this.init();
    }
  }

  _createClass(SameHeightCell, [{
    key: "init",
    value: function init() {
      this.rows = [];
      this.findElements();
      this.updateRows();
      this.attachEvents();
      this.addSameHeight();
      this.isInited = true;
    }
  }, {
    key: "findElements",
    value: function findElements() {
      this.columns = this.holder.querySelectorAll(this.opts.columns);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.resizeTimer = null;

      this.onResize = function (e) {
        clearTimeout(_this.resizeTimer);
        _this.resizeTimer = setTimeout(function () {
          _this.updateRows();

          _this.addSameHeight();

          $(window).trigger('resize');
        }, 200);
      };

      window.addEventListener('resize', this.onResize);
      window.addEventListener('orientationchange', this.onResize);
    }
  }, {
    key: "updateRows",
    value: function updateRows() {
      this.rows = (0, _makeRowsFromColumns["default"])(this.columns) || [];
    }
  }, {
    key: "addSameHeight",
    value: function addSameHeight() {
      var _this2 = this;

      this.rows.forEach(function (row) {
        var rowMaxHeight = 0;
        row.forEach(function (cell) {
          var h = cell.offsetHeight;

          if (h > rowMaxHeight) {
            rowMaxHeight = h;
          }
        });
        row.forEach(function (cell) {
          cell.style[_this2.opts.propName] = "".concat(rowMaxHeight, "px");
        });
      });
    }
  }, {
    key: "removeSameHeight",
    value: function removeSameHeight() {
      var _this3 = this;

      _toConsumableArray(this.columns).forEach(function (col) {
        var cells = col.querySelectorAll(_this3.opts.cells);

        _toConsumableArray(cells).forEach(function (cell) {
          cell.style[_this3.opts.propName] = null;
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isInited) {
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('orientationchange', this.onResize);
        this.removeSameHeight();
        this.rows = [];
      }
    }
  }]);

  return SameHeightCell;
}();

var _default = SameHeightCell;
exports["default"] = _default;

},{"./make-rows-from-columns":3}],6:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _filters = _interopRequireDefault(require("./filters"));

var _partnersService = _interopRequireDefault(require("../services/partners-service"));

var _detectScreenMode = _interopRequireWildcard(require("impv/src/js/main/detect-screen-mode"));

var _translateService = require("impv/src/js/services/translate-service");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TABS = {
  CHANNEL_PARTNERS: 'channel_partner',
  TA_PARTNERS: 'ta_partner'
};

var FindAPartnerDashboard =
/*#__PURE__*/
function () {
  /** TODO: load paging setting from admin UI */
  function FindAPartnerDashboard(pageContainer) {
    var _this = this;

    _classCallCheck(this, FindAPartnerDashboard);

    _defineProperty(this, "numItemsInRow", {
      platinum: 21,
      gold: 6,
      silver: 6,
      ta: 9
    });

    _defineProperty(this, "initialState", {
      filter: {
        selectedLevel: '',
        selectedCountry: '',
        selectedRegion: '',
        selectedCategory: '',
        search: '',
        taSearch: ''
      },
      paged: {
        gold: 0,
        platinum: 0,
        silver: 0,
        ta: 0
      }
    });

    _defineProperty(this, "state", {});

    this.pageContainer = pageContainer;
    this.channelPartnersTab = $('[tab-target="channel-partners-tab"]', document);
    this.taPartnersTab = $('[tab-target="technology-alliance-partners-tab"]', document);
    this.filterContainer = $('.filter-container', this.pageContainer);
    this.goldContainer = $('#gold-partners', this.pageContainer);
    this.platinumContainer = $('#platinum-partners', this.pageContainer);
    this.silverContainer = $('#silver-partners', this.pageContainer);
    this.TAPartnersContainer = $('#ta-partners', this.pageContainer);
    this.goldLoadMoreBtn = $('.gold-partners-section .load-more-btn', this.pageContainer);
    this.platinumLoadMoreBtn = $('.platinum-partners-section .load-more-btn', this.pageContainer);
    this.silverLoadMoreBtn = $('.silver-partners-section .load-more-btn', this.pageContainer);
    this.taPartnersLoadMoreBtn = $('.ta-partners-section .load-more-btn', this.pageContainer);
    this.findAPartnerFilters = new _filters["default"](this.filterContainer);
    this.partnerService = new _partnersService["default"]();
    this.doFilter = this.doFilter.bind(this);
    this.numItemsInRow = this.getNumItemsInRow((0, _detectScreenMode.getScreenMode)());

    _detectScreenMode["default"].register(function (screenMode) {
      _this.numItemsInRow = _this.getNumItemsInRow(screenMode);
    });
  }

  _createClass(FindAPartnerDashboard, [{
    key: "getNumItemsInRow",
    value: function getNumItemsInRow(screenMode) {
      if (screenMode <= _detectScreenMode.MOBILE_SCREEN_MODE) {
        return {
          platinum: 21,
          gold: 4,
          silver: 4,
          ta: 9
        };
      } else if (screenMode <= _detectScreenMode.TABLET_SCREEN_MODE) {
        return {
          platinum: 21,
          gold: 6,
          silver: 6,
          ta: 9
        };
      } else {
        return {
          platinum: 21,
          gold: 6,
          silver: 6,
          ta: 9
        };
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.setVersion();
      this.findAPartnerFilters.onFilter(this.doFilter);
      this.setState(this.initialState);
      this.registerEvents();
      var hold_ta_partners = document.querySelector('#technology-alliance-partners-tab');

      if (hold_ta_partners) {
        this.setCurrentTab(TABS.TA_PARTNERS);
      }

      var hold_partners = document.querySelector('#channel-partners-tab');

      if (hold_partners) {
        this.setCurrentTab(TABS.CHANNEL_PARTNERS);
      }
    }
  }, {
    key: "ellipsisHover",
    value: function ellipsisHover() {
      var ta_desc = document.getElementsByClassName('js-description'),
          card = document.getElementsByClassName('js-card-img'); // Text section

      for (var i = 0; i < ta_desc.length; i++) {
        var ta_el = ta_desc[i];

        if (ta_el.getAttribute('style') == null) {
          var h = ta_el.offsetHeight;
          ta_el.style.height = h + 'px';
          ta_el.classList.add('closed');
          ta_el.addEventListener('mouseover', function (event) {
            event.target.classList.remove('closed');
          });
          ta_el.addEventListener('mouseout', function (event) {
            event.target.classList.add('closed');
          });
        }
      } // Image section


      for (var _i = 0; _i < card.length; _i++) {
        card[_i].addEventListener('mouseover', function (event) {
          event.target.parentElement.parentElement.querySelectorAll('.ta-description')[0].classList.remove('closed');
        });

        card[_i].addEventListener('mouseout', function (event) {
          event.target.parentElement.parentElement.querySelectorAll('.ta-description')[0].classList.add('closed');
        });
      }
    }
  }, {
    key: "setCurrentTab",
    value: function setCurrentTab(tab) {
      if (this.currentTab != tab) {
        this.currentTab = tab;
        this.resetState();
        this.updateUI(this.currentTab);
      }
    }
  }, {
    key: "setVersion",
    value: function setVersion(version) {
      this.version = version || Math.random();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _this2 = this;

      this.goldLoadMoreBtn.on('click', function (_) {
        return _this2.loadPage('gold');
      });
      this.platinumLoadMoreBtn.on('click', function (_) {
        return _this2.loadPage('platinum');
      });
      this.silverLoadMoreBtn.on('click', function (_) {
        return _this2.loadPage('silver');
      });
      this.taPartnersLoadMoreBtn.on('click', function (_) {
        return _this2.loadPage('ta');
      });
      this.channelPartnersTab.on('click', function (_) {
        return _this2.setCurrentTab(TABS.CHANNEL_PARTNERS);
      });
      this.taPartnersTab.on('click', function (_) {
        return _this2.setCurrentTab(TABS.TA_PARTNERS);
      });
    }
  }, {
    key: "setLoadingStateOn",
    value: function setLoadingStateOn(btn) {
      btn.show();
      btn.html("".concat((0, _translateService.translate)('buttons.loading_buttons_text', 'loading...'), "\n      <i class=\"fa fa-spinner loading-icon\"></i>"));
      btn.addClass('loading');
    }
  }, {
    key: "setLoadingStateOff",
    value: function setLoadingStateOff(btn) {
      btn.html((0, _translateService.translate)('buttons.show_all', 'Show All'));
      btn.removeClass('loading');
    }
  }, {
    key: "hideShowMoreBtn",
    value: function hideShowMoreBtn(btn, flag) {
      if (flag) {
        btn.hide();
      } else {
        btn.show();
      }
    }
  }, {
    key: "loadPage",
    value: function loadPage(level) {
      var _this3 = this;

      this.state.paged[level] = this.state.paged[level] + 1;
      var filters = {
        level: level
      }; // show rest result if page > 1

      if (this.state.paged[level] > 1) {
        filters['get_rest_result'] = true;
      }

      var _this$state$filter = this.state.filter,
          selectedCategory = _this$state$filter.selectedCategory,
          selectedLevel = _this$state$filter.selectedLevel,
          selectedCountry = _this$state$filter.selectedCountry,
          selectedRegion = _this$state$filter.selectedRegion,
          search = _this$state$filter.search,
          taSearch = _this$state$filter.taSearch;

      if (selectedCategory) {
        filters['category'] = selectedCategory;
      }

      if (level || selectedLevel) {
        filters['level'] = level || selectedLevel;
      }

      if (selectedCountry) {
        filters['country'] = selectedCountry;
      }

      if (selectedRegion) {
        filters['region'] = selectedRegion;
      }

      if (this.currentTab == TABS.CHANNEL_PARTNERS) {
        if (search) {
          filters['search'] = search;
        }
      } else {
        if (taSearch) {
          filters['search'] = taSearch;
        }
      }

      if (level == 'gold') {
        this.setLoadingStateOn(this.goldLoadMoreBtn);
        this.partnerService.getPartnerByFilters(filters, this.state.paged[level], this.numItemsInRow[level], this.version).then(function (_ref) {
          var partners = _ref.partners,
              version = _ref.version;

          if (version != _this3.version) {
            // avoid late response when application state is changed
            return;
          }

          _this3.goldContainer.append(partners.map(function (p) {
            return HTMLTemplate.getGoldTemplate(p);
          }).join('\n'));

          _this3.setLoadingStateOff(_this3.goldLoadMoreBtn);

          _this3.hideShowMoreBtn(_this3.goldLoadMoreBtn, !partners || partners.length < _this3.numItemsInRow[level] || filters['get_rest_result']);

          if (partners.length == 0 && _this3.state.paged[level] == 1) {
            _this3.goldContainer.empty();

            _this3.goldContainer.append(HTMLTemplate.getNoDataTemplate());
          }
        }, function (err) {
          // eslint-disable-next-line no-console
          console.error("Something when wrong to fecth partners level ".concat(level), err);

          _this3.hideShowMoreBtn(_this3.goldLoadMoreBtn, true);
        });
      } else if (level == 'platinum') {
        this.setLoadingStateOn(this.platinumLoadMoreBtn);
        this.partnerService.getPartnerByFilters(filters, this.state.paged[level], this.numItemsInRow[level], this.version).then(function (_ref2) {
          var partners = _ref2.partners,
              version = _ref2.version;

          if (version != _this3.version) {
            // avoid late response when application state is changed
            return;
          }

          _this3.platinumContainer.append(partners.map(function (p) {
            return HTMLTemplate.getPlatinumTemplate(p);
          }).join('\n'));

          _this3.setLoadingStateOff(_this3.platinumLoadMoreBtn);

          _this3.hideShowMoreBtn(_this3.platinumLoadMoreBtn, !partners || partners.length < _this3.numItemsInRow[level] || filters['get_rest_result']);

          if (partners.length == 0 && _this3.state.paged[level] == 1) {
            _this3.platinumContainer.empty();

            _this3.platinumContainer.append(HTMLTemplate.getNoDataTemplate());
          }
        }, function (err) {
          // eslint-disable-next-line no-console
          console.error("Something when wrong to fecth partners level ".concat(level), err);

          _this3.hideShowMoreBtn(_this3.platinumLoadMoreBtn, true);
        });
      } else if (level == 'silver') {
        this.setLoadingStateOn(this.silverLoadMoreBtn);
        this.partnerService.getPartnerByFilters(filters, this.state.paged[level], this.numItemsInRow[level], this.version).then(function (_ref3) {
          var partners = _ref3.partners,
              version = _ref3.version;

          if (version != _this3.version) {
            // avoid late response when application state is changed
            return;
          }

          _this3.silverContainer.append(partners.map(function (p) {
            return HTMLTemplate.getSilverTemplate(p);
          }).join('\n'));

          _this3.setLoadingStateOff(_this3.silverLoadMoreBtn);

          _this3.hideShowMoreBtn(_this3.silverLoadMoreBtn, !partners || partners.length < _this3.numItemsInRow[level] || filters['get_rest_result']);

          if (partners.length == 0 && _this3.state.paged[level] == 1) {
            _this3.silverContainer.empty();

            _this3.silverContainer.append(HTMLTemplate.getNoDataTemplate());
          }
        }, function (err) {
          // eslint-disable-next-line no-console
          console.error("Something when wrong to fecth partners level ".concat(level), err);

          _this3.hideShowMoreBtn(_this3.silverLoadMoreBtn, true);
        });
      } else if (level == 'ta') {
        this.setLoadingStateOn(this.taPartnersLoadMoreBtn);
        this.partnerService.getPartnerByFilters(filters, this.state.paged[level], this.numItemsInRow[level], this.version).then(function (_ref4) {
          var partners = _ref4.partners,
              version = _ref4.version;

          if (version != _this3.version) {
            // avoid late response when application state is changed
            return;
          }

          var leftContainer = _this3.TAPartnersContainer.find('>.left');

          var centerContainer = _this3.TAPartnersContainer.find('>.center');

          var rightContainer = _this3.TAPartnersContainer.find('>.right');

          if (_this3.state.paged[level] == 1) {
            _this3.side = 0;
          }

          partners.map(function (p) {
            return HTMLTemplate.getTATemplate(p);
          }).forEach(function (html) {
            switch (_this3.side) {
              case 0:
                leftContainer.append(html);
                _this3.side = 1;
                break;

              case 1:
                centerContainer.append(html);
                _this3.side = 2;
                break;

              case 2:
                rightContainer.append(html);
                _this3.side = 0;
                break;
            }
          });

          _this3.setLoadingStateOff(_this3.taPartnersLoadMoreBtn);

          _this3.hideShowMoreBtn(_this3.taPartnersLoadMoreBtn, !partners || partners.length < _this3.numItemsInRow[level] || filters['get_rest_result']);

          if (partners.length == 0 && _this3.state.paged[level] == 1) {
            leftContainer.empty();
            centerContainer.empty();
            rightContainer.empty();
            leftContainer.append(HTMLTemplate.getNoDataTemplate());
          }

          if (window.innerWidth > 1199.98) {
            _this3.ellipsisHover();
          }
        }, function (err) {
          // eslint-disable-next-line no-console
          console.error("Something when wrong to fecth tap partners", err);

          _this3.hideShowMoreBtn(_this3.taPartnersLoadMoreBtn, true);
        });
      }
    }
  }, {
    key: "doFilter",
    value: function doFilter(filterState) {
      this.setState({
        filter: filterState,
        paged: {
          gold: 0,
          platinum: 0,
          silver: 0,
          ta: 0
        }
      });
      this.updateUI(this.currentTab);
    }
  }, {
    key: "resetState",
    value: function resetState() {
      this.setState({
        paged: {
          gold: 0,
          platinum: 0,
          silver: 0,
          ta: 0
        }
      });
    }
  }, {
    key: "setState",
    value: function setState(newState) {
      this.state = Object.assign({}, this.state, newState);
    }
  }, {
    key: "cleanUI",
    value: function cleanUI(tab) {
      if (tab == TABS.CHANNEL_PARTNERS) {
        this.goldContainer.empty();
        this.platinumContainer.empty();
        this.silverContainer.empty();
      } else if (TABS.TA_PARTNERS) {
        var leftContainer = this.TAPartnersContainer.find('>.left');
        var centerContainer = this.TAPartnersContainer.find('>.center');
        var rightContainer = this.TAPartnersContainer.find('>.right');
        leftContainer.empty();
        centerContainer.empty();
        rightContainer.empty();
      }
    }
  }, {
    key: "hideSection",
    value: function hideSection(level) {
      $(".".concat(level, "-partners-section")).hide();
    }
  }, {
    key: "showSection",
    value: function showSection(level) {
      $(".".concat(level, "-partners-section")).show();
    }
  }, {
    key: "updateUI",
    value: function updateUI(tab) {
      var _this4 = this;

      this.setVersion();
      this.cleanUI(tab);
      var levels = ['gold', 'platinum', 'silver'];
      var selectedLevel = this.state.filter.selectedLevel;

      if (tab == TABS.TA_PARTNERS) {
        levels = ['ta'];
        selectedLevel = levels[0];
      }

      if (selectedLevel) {
        levels.forEach(function (level) {
          if (selectedLevel == level) {
            _this4.loadPage(level);

            _this4.showSection(level);
          } else {
            _this4.hideSection(level);
          }
        });
      } else {
        levels.forEach(function (level) {
          _this4.loadPage(level);

          _this4.showSection(level);
        });
      }
    }
  }]);

  return FindAPartnerDashboard;
}();

exports["default"] = FindAPartnerDashboard;
var HTMLTemplate = {
  getNoDataTemplate: function getNoDataTemplate() {
    return "\n      <span class=\"col-12 no-data-message\">\n        ".concat((0, _translateService.translate)('error_messages.no_partner_found', 'No Partners Found'), "\n      </span>\n    ");
  },
  getGoldTemplate: function getGoldTemplate(partner) {
    return "\n        <div class=\"col-12 col-sm-4 d-flex grid-col\">\n          <div class=\"level-box\">\n            <div class=\"logo-holder\">\n              <img class=\"card-img align-middle lazyload\" data-src=\"".concat(partner.image_path, "\" alt=\"").concat(partner.name, " logo\">\n            </div>\n            <a class=\"link-arrow\" target=\"_blank\" rel=\"nofollow\"  gtm-track event-action=\"click\" event-category=\"Find a partner page\" event-label=\"").concat(partner.name, "\" href=\"").concat(partner.website, "\">\n              ").concat((0, _translateService.translate)('links.visit_website', 'Visit website'), "\n            </a>\n          </div>\n        </div>\n        ");
  },
  getPlatinumTemplate: function getPlatinumTemplate(partner) {
    return "\n        <div class=\"col-12 col-sm-4 d-flex grid-col\">\n          <div class=\"level-box\">\n            <div class=\"logo-holder\">\n              <img class=\"card-img align-middle lazyload\" data-src=\"".concat(partner.image_path, "\" alt=\"").concat(partner.name, " logo\">\n            </div>\n            <a class=\"link-arrow\" target=\"_blank\" rel=\"nofollow\"  gtm-track event-action=\"Click\" event-category=\"Find a Partner Listing\" event-label=\"").concat(partner.name, "\" href=\"").concat(partner.website, "\">\n              ").concat((0, _translateService.translate)('links.visit_website', 'Visit website'), "\n            </a>\n          </div>\n        </div>\n        ");
  },
  getSilverTemplate: function getSilverTemplate(partner) {
    return "\n        <div class=\"col-12 col-sm-4 d-flex grid-col\">\n          <div class=\"level-box no-logo\">\n            <div class=\"logo-holder\">\n                <h3 title=\"".concat(partner.name, "\">").concat(partner.name, "</h3>\n            </div>\n            <a class=\"link-arrow\" target=\"_blank\" rel=\"nofollow\"  gtm-track event-action=\"click\" event-category=\"Find a partner page\" event-label=\"").concat(partner.name, "\" href=\"").concat(partner.website, "\">\n              ").concat((0, _translateService.translate)('links.visit_website', 'Visit website'), "\n            </a>\n          </div>\n        </div>\n        ");
  },
  getTATemplate: function getTATemplate(partner) {
    var cardId = parseInt(Math.random() * 1000);
    var isCertifiedSolution = partner.is_certified_solution || false;
    var learn_more_link = partner.partner_link ? partner.partner_link : partner.solution_brief;
    var certifiedSolutionImg = '/wp-content/themes/impv-partners/dist/imgs/imperva-certified-icon.svg';
    return "\n          <div class=\"partner-card expended-card\">\n            <div class=\"show-more-btn\" data-toggle=\"collapse\" data-target=\"#show-more-content-".concat(cardId, "\">\n                <i class=\"show-more-icon expand-icon\"></i>\n                <i class=\"show-more-icon d-none collapse-icon\"></i>\n            </div>\n            <div class=\"js-card-img card-img-container card-img-div\">\n              <div class=\"card-img\">\n                <img class=\"align-rigth lazyload\" data-src=\"").concat(partner.image_path, "\" alt=\"").concat(partner.name, " logo\">\n              </div>\n            </div>\n            <div class=\"cert-img-div right-logo\">\n            ").concat(isCertifiedSolution ? "<img class=\"card-img align-left lazyload\" data-src=\"".concat(certifiedSolutionImg, "\" alt=\"Imperva Certified Solution logo\">") : '', "\n            </div>\n            <div class=\"card-description collapse\" id=\"show-more-content-").concat(cardId, "\">\n              <div class=\"js-description ta-description\">\n              ").concat(partner.description, "\n              </div>\n              <div class=\"ta-links\">\n                ").concat(learn_more_link ? "<a class=\"btn gst-blue-btn\" target=\"_blank\" gtm-track event-action=\"Click\" event-category=\"Find a TAP Listing\" event-label=\"Learn more - ".concat(partner.name, "\" href=\"").concat(learn_more_link, "\"> ").concat((0, _translateService.translate)('links.learn_more', 'Learn more'), "</a>") : '', "\n                <a class=\"link-arrow\" target=\"_blank\" rel=\"nofollow\" gtm-track event-action=\"Click\" event-category=\"Find a TAP Listing\" event-label=\"").concat(partner.name, "\" href=\"").concat(partner.website, "\">").concat((0, _translateService.translate)('links.visit_website', 'Visit website'), "</a>\n              </div>\n            </div>\n          </div>\n        ");
  }
};

},{"../services/partners-service":9,"./filters":7,"impv/src/js/main/detect-screen-mode":21,"impv/src/js/services/translate-service":25}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FindAPartnerFilters =
/*#__PURE__*/
function () {
  function FindAPartnerFilters(container) {
    _classCallCheck(this, FindAPartnerFilters);

    _defineProperty(this, "state", {
      selectedCategory: '',
      selectedLevel: '',
      selectedCountry: '',
      selectedRegion: '',
      search: '',
      taSearch: ''
    });

    this.container = container;
    this.categoryFilter = $('#category-filter', this.container);
    this.levelFilter = $('#level-filter', this.container);
    this.countryFilter = $('#country-filter', this.container);
    this.regionFilter = $('#region-filter', this.container);
    this.searchFilterInput = $('#serach-partner', this.container);
    this.searchFilterBtn = $('#search-btn', this.container);
    this.searchClearFilterBtn = $('#clear-search-btn', this.container);
    this.searchTAFilterInput = $('#serach-ta-partner', this.container);
    this.searchTAFilterBtn = $('#search-ta-btn', this.container);
    this.init();
  }

  _createClass(FindAPartnerFilters, [{
    key: "init",
    value: function init() {
      this.registerEvent();
    }
  }, {
    key: "setState",
    value: function setState(newState) {
      this.state = Object.assign({}, this.state, newState);
      this.updateUI(newState);
    }
  }, {
    key: "registerEvent",
    value: function registerEvent() {
      var _this = this;

      this.categoryFilter.on('select_changed', function (event, _ref) {
        var item$ = _ref.item$;

        _this.filterCategory(_this.categoryFilter, item$.data('value'));
      });
      this.levelFilter.on('select_changed', function (event, _ref2) {
        var item$ = _ref2.item$;

        _this.filterLevel(_this.levelFilter, item$.data('value'));
      });
      this.countryFilter.on('select_changed', function (event, _ref3) {
        var item$ = _ref3.item$;

        _this.filterCountry(_this.countryFilter, item$.data('value'));
      });
      this.regionFilter.on('select_changed', function (event, _ref4) {
        var item$ = _ref4.item$;

        _this.filterRegion(_this.regionFilter, item$.data('value'));
      });
      this.searchFilterBtn.on('click', function (e) {
        return _this.filterSearch(_this.searchFilterInput);
      });
      this.searchFilterInput.on('change', function (e) {
        return _this.filterSearch(_this.searchFilterInput);
      });
      this.searchClearFilterBtn.on('click', function (e) {
        return (
          /** TODO: fix the bug if user click more then once in same time (show duplicate results) */
          _this.clearSearch(_this.searchFilterInput)
        );
      });
      this.keyUpEventTimer = null;
      this.searchFilterInput.on('keyup', function (e) {
        clearTimeout(_this.keyUpEventTimer);
        _this.keyUpEventTimer = setTimeout(function () {
          _this.filterSearch(_this.searchFilterInput);
        }, 250);
      });
      this.searchTAFilterBtn.on('click', function (e) {
        return _this.filterTASearch(_this.searchTAFilterInput);
      });
      this.searchTAFilterInput.on('change', function (e) {
        return _this.filterTASearch(_this.searchTAFilterInput);
      });
      this.keyUpEventTimer = null;
      this.searchTAFilterInput.on('keyup', function (e) {
        clearTimeout(_this.keyUpEventTimer);
        _this.keyUpEventTimer = setTimeout(function () {
          _this.filterTASearch(_this.searchTAFilterInput);
        }, 250);
      });
    }
  }, {
    key: "filterCategory",
    value: function filterCategory(selectElem, category) {
      this.setState({
        selectedCategory: category
      });
      this.doFilter();
    }
  }, {
    key: "filterLevel",
    value: function filterLevel(selectElem, level) {
      this.setState({
        selectedLevel: level
      });
      this.doFilter();
    }
  }, {
    key: "filterCountry",
    value: function filterCountry(selectElem, countryId) {
      this.setState({
        selectedCountry: countryId
      });
      this.doFilter();
    }
  }, {
    key: "filterRegion",
    value: function filterRegion(selectElem, region) {
      this.setState({
        selectedRegion: region,
        selectedCountry: ''
      });
      this.doFilter();
    }
  }, {
    key: "filterSearch",
    value: function filterSearch(searchInput) {
      var search = searchInput.val();
      this.setState({
        selectedCategory: '',
        selectedLevel: '',
        selectedCountry: '',
        selectedRegion: '',
        search: search
      });
      this.clearFilter(this.categoryFilter);
      this.clearFilter(this.levelFilter);
      this.clearFilter(this.countryFilter);
      this.clearFilter(this.regionFilter);
      this.doFilter();
    }
  }, {
    key: "filterTASearch",
    value: function filterTASearch(searchInput) {
      var search = searchInput.val();
      this.setState({
        selectedCategory: '',
        taSearch: search
      });
      this.clearFilter(this.CategoryFilter);
      this.doFilter();
    }
  }, {
    key: "clearFilter",
    value: function clearFilter(selectElement) {
      var selectAllItem = $('.dropdown-item[data-select-all="true"]:first', selectElement);

      if (selectAllItem) {
        selectAllItem.click();
      } else {
        var firstElem = $('.dropdown-item:not(.filtered):first', selectElement);

        if (firstElem) {
          firstElem.click();
        }
      }
    }
  }, {
    key: "clearSearch",
    value: function clearSearch(searchInput) {
      searchInput.val('');
      this.setState({
        search: ''
      });
      this.doFilter();
    }
  }, {
    key: "onFilter",
    value: function onFilter(cb) {
      if (cb && typeof cb == 'function') {
        this.onFilterCbFns = this.onFilterCbFns || [];
        this.onFilterCbFns.push(cb);
      }
    }
  }, {
    key: "doFilter",
    value: function doFilter() {
      var _this2 = this;

      if (this.onFilterCbFns) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(function () {
          _this2.onFilterCbFns.forEach(function (cb) {
            cb({
              selectedCategory: _this2.state.selectedCategory,
              selectedLevel: _this2.state.selectedLevel,
              selectedCountry: _this2.state.selectedCountry,
              selectedRegion: _this2.state.selectedRegion,
              search: _this2.state.search,
              taSearch: _this2.state.taSearch
            });
          });
        }, 500);
      }
    }
  }, {
    key: "updateUI",
    value: function updateUI(state) {
      var selectedRegion = state.selectedRegion;

      if (selectedRegion !== undefined) {
        if (selectedRegion) {
          $(".dropdown-item", this.countryFilter).each(function (_, e) {
            var e$ = $(e);

            if (e$.data('region') !== selectedRegion && !e$.data('select-all')) {
              e$.addClass('filtered');
            } else {
              e$.removeClass('filtered');
            }
          });
        } else {
          $('.dropdown-item.filtered', this.countryFilter).removeClass('filtered');
        }

        if (this.prevSelectedRegion != selectedRegion) {
          this.prevSelectedRegion = selectedRegion;
          this.clearFilter(this.countryFilter);
        }
      }
    }
  }]);

  return FindAPartnerFilters;
}();

exports["default"] = FindAPartnerFilters;

},{}],8:[function(require,module,exports){
(function (global){
"use strict";

var _sameHeightCell = _interopRequireDefault(require("./components/same-height-cell"));

var _rowHoverHelper = _interopRequireDefault(require("./components/row-hover-helper"));

require("./components/jquery-tabs");

var _dropdownSelect = _interopRequireDefault(require("impv/src/js/components/dropdown-select"));

var _dashboard = _interopRequireDefault(require("./find-a-partner/dashboard-2023"));

var _marketoForm = _interopRequireDefault(require("impv/src/js/components/marketo-form"));

require("impv-products/src/js/product-template-newer-design");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

document.addEventListener('form2init', marketoFormActions);

function marketoFormActions() {
  $(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _marketoForm["default"].findById($('form[data-form-id="3161"]').attr('data-form-id')).then(function (form) {
              form.onValidate(function () {
                var PartnerType = $('select[name="PartnerType"] option:selected').text();
                var revenue = $('select[name="revenue"]').val();
                var year_est = $('select[name="YearEstablished"] option:selected').text();
                var locations = $('select[name="NumberOfLocations"] option:selected').text();
                var ImpervaPartnerReason = $('input[name="ImpervaPartnerReason"]').val();
                var Markets_Served = $('[name="MarketsServed"] option:selected').text();
                var Countries_Doing = $('[name="CountriesDoingBusiness"] option:selected').text();
                var notes = 'Partner Type......: ' + PartnerType + '\n' + 'Markets Served......: ' + Markets_Served + '\n' + 'Annual Revenue......: ' + revenue + '\n' + 'Number of Branches......: ' + locations + '\n' + 'Year Established......: ' + year_est + '\n' + 'Doing Business In......: ' + Countries_Doing + '\n' + 'Why are you interested in being an Imperva partner?......: ' + ImpervaPartnerReason;
                form.updateFieldValue($('input[name="partnerAlertConcatString"]'), notes);
              });
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
}

jQuery(function () {
  initSameHeightCell();
  initSameHeight();
  initSlick();
  initSlickCarousel();
  initStickyScrollBlock();
  initCustomHover();
  initAddClasses();
  initRowHover();
  initTabs();
}); // align blocks height

function initSameHeight() {
  jQuery('.info-boxes').sameHeight({
    elements: '.strip-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.proof-point',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.above-rule',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.header-wrapper',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.explain-section').sameHeight({
    elements: '.content-box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.how-imperva-can-help').sameHeight({
    elements: '.box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.content-panels').sameHeight({
    elements: '.panel-title',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.gpi-panel').sameHeight({
    elements: 'h3.quote',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('#resources-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('#blog-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
}

function initSlick() {
  SlickWithIndicator.jqueryInit('.related-row-1', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 1,
      slidesToShow: 1,
      arrow: false,
      dots: true,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        // DC: settings for breakpoint value and down, initial settings used for breakpoint value and up
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          dots: false
        }
      }]
    }
  }); // DC: note responsive removal of slider requires page refresh (or new page load)

  ResponsiveHelper.addRange({
    '0..767': {
      on: function on() {
        SlickWithIndicator.jqueryInit('.related-row-2', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
        SlickWithIndicator.jqueryInit('.related-row-3', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        /* do nothing */
      }
    }
  });
  SlickWithIndicator.jqueryInit('.panels-row', {
    slick: '.panels-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      pauseOnHover: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });
}

$(function () {
  var container = $('.find-a-partner-page');
  var findAPartnerDashboard = new _dashboard["default"](container);
  findAPartnerDashboard.init();

  _dropdownSelect["default"].register();

  $(function (_) {
    $(document).on('click', '.expended-card', function (event) {
      if (screen.width < 1023.98) {
        $('.expended-card .show-more-icon.expand-icon').removeClass('d-none');
        $('.expended-card .show-more-icon.collapse-icon').addClass('d-none');
        $('.expended-card .card-description').collapse('hide');
        $('.card-description', event.currentTarget).collapse('show');
        var isCollapse = $('.show-more-btn', event.currentTarget).is('.collapsed');

        if (!isCollapse) {
          $('.show-more-icon', event.currentTarget).toggleClass('d-none');
        }
      }
    });
  });
}); // add class on click

function initAddClasses() {
  jQuery('.icon-tooltip').clickClass({
    classAdd: 'opened'
  });
  jQuery('.search-opener').clickClass({
    classAdd: 'active',
    addToParent: 'search-bar'
  });
  jQuery('.search-opener').on('click', function () {
    jQuery('.hero-search .search-input').focus();
  });
} // add classes on hover/touch


function initCustomHover() {
  jQuery('.icon-tooltip').touchHover({
    hoverClass: 'opened'
  });
}

function initRowHover() {
  var tables = document.querySelectorAll('.table-section .table-body');
  var apiList = [];
  ResponsiveHelper.addRange({
    '1024..': {
      on: function on() {
        _toConsumableArray(tables).forEach(function (table) {
          apiList.push(new _rowHoverHelper["default"](table));
        });
      },
      off: function off() {
        apiList.forEach(function (api) {
          api.destroy();
          api = null;
        });
      }
    }
  });
}

function initSameHeightCell() {
  var tables = document.querySelectorAll('.table-section .table-body');

  _toConsumableArray(tables).forEach(function (table) {
    new _sameHeightCell["default"](table);
  });
} // slick init


function initSlickCarousel() {
  ResponsiveHelper.addRange({
    '..1199': {
      on: function on() {
        jQuery('.plans-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          variableWidth: true
        });
        jQuery('.table-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-for').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles1').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles2').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          draggable: false,
          swipe: false,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.plans-slider').slick('unslick');
        jQuery('.table-slider').slick('unslick');
        jQuery('.slider-for').slick('unslick');
        jQuery('.slider-titles1').slick('unslick');
        jQuery('.slider-titles2').slick('unslick');
      }
    }
  });
  ResponsiveHelper.addRange({
    '768..1199': {
      on: function on() {
        jQuery('.measure-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.measure-slider').slick('unslick');
      }
    }
  });
} // initialize sticky blocks on scroll


function initStickyScrollBlock() {
  var tabsHolder = jQuery('.page-content');
  var changingClass = 'tabs-changing';
  jQuery('.thead1').stickyScrollBlock({
    container: '#table',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });
  jQuery('.thead2').stickyScrollBlock({
    container: '#table2',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });
  jQuery('.filters-bar').stickyScrollBlock({
    container: '.wrapper',
    showAfterScrolled: false,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });

  var ontabschangeFn = function ontabschangeFn() {
    tabsHolder.addClass(changingClass);
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(function (api) {
          api.onResize();
          tabsHolder.removeClass(changingClass);
        }, 300, api);
      }
    });
  };

  var refreshSize = function refreshSize() {
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        api.onResize();
      }
    });
  };

  document.addEventListener('ontabschange', ontabschangeFn);
  document.addEventListener('affixHeaderHeightChanged', refreshSize);
}

function initTabs() {
  var holder = document.querySelector('.switcher-list');
  var changeEvt = new Event('ontabschange');
  var switchedByInput = false;
  jQuery(holder).tabset({
    tabLinks: 'a',
    addToParent: true,
    autoHeight: true,
    checkHash: true,
    onChange: function onChange(activeLink) {
      if (activeLink) {
        var id = activeLink.attr('href').replace('#', ''); // trigger input's checked state

        triggerInputs(id);
      }

      document.dispatchEvent(changeEvt); // scroll to table if tabs were swithced by inputs

      if (switchedByInput) {
        var activeTab = this.getActiveTab();
        switchedByInput = false;

        if (activeTab.length) {
          scrollToTable(activeTab);
        }
      }
    }
  });
  var api = jQuery(holder).data('Tabset');
  var inputs = document.querySelectorAll('.switch input[data-target]');
  var attrName = 'data-checked-by-tab';

  _toConsumableArray(inputs).forEach(function (input) {
    input.addEventListener('change', onChange);
  });

  function onChange(e) {
    var target = e.target;
    var checkedByLink = target.getAttribute(attrName);
    var id = target.getAttribute('data-target');

    if (!checkedByLink && id) {
      var linkIdx = getLinkIndex(id);

      if (linkIdx !== null) {
        switchedByInput = true;
        api.activeTabIndex = linkIdx;
        api.switchTabs();
      }
    }
  }

  function triggerInputs(id) {
    if (id) {
      var _inputs = document.querySelectorAll("input[data-target=\"".concat(id, "\"]"));

      _toConsumableArray(_inputs).forEach(function (input) {
        input.checked = true;
        input.setAttribute(attrName, true);
        clearTimeout(input.checkedTimer);
        input.checkedTimer = setTimeout(function (input) {
          input.removeAttribute(attrName);
        }, 500, input);
      });
    }
  }

  function scrollToTable(holder) {
    var scrollTarget = holder.find('.table-section');

    if (scrollTarget.length) {
      scrollTarget[0].scrollIntoView(true);
    }
  }

  function getLinkIndex(id) {
    var result = null;

    if (holder) {
      var links = holder.querySelectorAll('a');

      _toConsumableArray(links).forEach(function (link, i) {
        if (link.getAttribute('href') === "#".concat(id)) {
          result = i;
        }
      });
    }

    return result;
  }
}
/*
 * Add class plugin
 */


jQuery.fn.clickClass = function (opt) {
  var options = jQuery.extend({
    classAdd: 'add-class',
    addToParent: false,
    event: 'click'
  }, opt);
  return this.each(function () {
    var classItem = jQuery(this);

    if (options.addToParent) {
      if (typeof options.addToParent === 'boolean') {
        classItem = classItem.parent();
      } else {
        classItem = classItem.parents('.' + options.addToParent);
      }
    }

    jQuery(this).bind(options.event, function (e) {
      classItem.toggleClass(options.classAdd);
      e.preventDefault();
    });
  });
};
/*
 * Mobile hover plugin
 */


(function ($) {
  var doc = jQuery(document); // detect device type

  var isTouchDevice = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
      isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent); // define events

  var eventOn = isTouchDevice && 'touchstart' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerdown' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerDown' || 'mouseenter',
      eventOff = isTouchDevice && 'touchend' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerup' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerUp' || 'mouseleave';
  isTouchDevice = /Windows Phone/.test(navigator.userAgent) || 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

  function toggleClass(opt, e) {
    var el = jQuery(e.currentTarget);

    if (!isTouchDevice) {
      el.one(eventOff, function () {
        jQuery(this).removeClass(opt.hoverClass);
      });
    } else {
      if (!el.hasClass(opt.hoverClass)) {
        jQuery(this).off('click.hover', function (e) {
          e.preventDefault();
        });
        setTimeout(function () {
          doc.on(eventOn + '.hover', function (e) {
            var target = jQuery(e.target);

            if (!target.is(el) && !target.closest(el).length) {
              el.removeClass(opt.hoverClass);
              jQuery(this).off('click.hover');
              doc.off(eventOn + '.hover');
            }
          });
        });
      }
    }

    if (!el.hasClass(opt.hoverClass)) {
      if (e) e.preventDefault();
      el.addClass(opt.hoverClass);
    }
  } // jQuery plugin


  $.fn.touchHover = function (opt) {
    var options = $.extend({
      hoverClass: 'hover'
    }, opt);
    this.on(eventOn, toggleClass.bind(this, options));
    return this;
  };
})(jQuery);
/*
 * Responsive Layout helper
 */


window.ResponsiveHelper = function ($) {
  // init variables
  var handlers = [],
      prevWinWidth,
      win = $(window),
      nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = win.width();

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }

  win.bind('load resize orientationchange', resizeHandler); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}(jQuery);
/*
 * jQuery sticky box plugin
 */


(function ($, $win) {
  'use strict';

  function StickyScrollBlock($stickyBox, options) {
    this.options = options;
    this.$stickyBox = $stickyBox;
    this.init();
  }

  var StickyScrollBlockPrototype = {
    init: function init() {
      this.findElements();
      this.attachEvents();
      this.makeCallback('onInit');
    },
    findElements: function findElements() {
      // find parent container in which will be box move
      this.$container = this.$stickyBox.closest(this.options.container); // define box wrap flag

      this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight; // define box move flag

      this.moveInContainer = !!this.$container.length; // wrapping box to set place in content

      if (this.isWrap) {
        this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
      } //define block to add active class


      this.parentForActive = this.getParentForActive();
      this.isInit = true;
    },
    attachEvents: function attachEvents() {
      var self = this; // bind events

      this.onResize = function () {
        if (!self.isInit) return;
        self.resetState();
        self.recalculateOffsets();
        self.checkStickyPermission();
        self.scrollHandler();
      };

      this.onScroll = function () {
        self.scrollHandler();
      }; // initial handler call


      this.onResize(); // handle events

      $win.on('load resize orientationchange', this.onResize).on('scroll', this.onScroll);
    },
    defineExtraTop: function defineExtraTop() {
      // define box's extra top dimension
      var extraTop;

      if (typeof this.options.extraTop === 'number') {
        extraTop = this.options.extraTop;
      } else if (typeof this.options.extraTop === 'function') {
        extraTop = this.options.extraTop();
      }

      this.extraTop = this.options.positionType === 'absolute' ? extraTop : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
    },
    checkStickyPermission: function checkStickyPermission() {
      // check the permission to set sticky
      this.isStickyEnabled = this.moveInContainer ? this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom : true;
    },
    getParentForActive: function getParentForActive() {
      if (this.isWrap) {
        return this.$stickyBoxWrap;
      }

      if (this.$container.length) {
        return this.$container;
      }

      return this.$stickyBox;
    },
    getWrapClass: function getWrapClass() {
      // get set of container classes
      try {
        return this.$stickyBox.attr('class').split(' ').map(function (name) {
          return 'sticky-wrap-' + name;
        }).join(' ');
      } catch (err) {
        return 'sticky-wrap';
      }
    },
    resetState: function resetState() {
      // reset dimensions and state
      this.stickyFlag = false;
      this.$stickyBox.css({
        '-webkit-transition': '',
        '-webkit-transform': '',
        transition: '',
        transform: '',
        position: '',
        width: '',
        left: '',
        top: ''
      }).removeClass(this.options.activeClass);

      if (this.isWrap) {
        this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
      }

      if (this.moveInContainer) {
        this.$container.removeClass(this.options.activeClass);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      // define box and container dimensions
      this.winParams = this.getWindowParams();
      this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());
      this.defineExtraTop();
    },
    getBoxOffsets: function getBoxOffsets() {
      var boxOffset = this.$stickyBox.offset();
      var boxPosition = this.$stickyBox.position();
      return {
        // sticky box offsets
        boxOffsetLeft: boxOffset.left,
        boxOffsetTop: boxOffset.top,
        // sticky box positions
        boxTopPosition: boxPosition.top,
        boxLeftPosition: boxPosition.left,
        // sticky box width/height
        boxFullHeight: this.$stickyBox.outerHeight(true),
        boxHeight: this.$stickyBox.outerHeight(),
        boxWidth: this.$stickyBox.outerWidth()
      };
    },
    getContainerOffsets: function getContainerOffsets() {
      var containerOffset = this.moveInContainer ? this.$container.offset() : null;
      return containerOffset ? {
        // container offsets
        containerOffsetLeft: containerOffset.left,
        containerOffsetTop: containerOffset.top,
        // container height
        containerHeight: this.$container.outerHeight()
      } : {};
    },
    getWindowParams: function getWindowParams() {
      return {
        height: window.innerHeight || document.documentElement.clientHeight
      };
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      this.isInit = false; // remove event handlers and styles

      $win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
      this.resetState();
      this.$stickyBox.removeData('StickyScrollBlock');

      if (this.isWrap) {
        this.$stickyBox.unwrap();
      }

      this.makeCallback('onDestroy');
    }
  };
  var stickyMethods = {
    fixed: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop - (this.options.showAfterScrolled ? this.extraTop : 0) - (this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            position: this.options.positionType
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.setDynamicPosition();
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.stickyFlag = false;
          this.resetState();
          this.makeCallback('fixedOff');
        }
      },
      setDynamicPosition: function setDynamicPosition() {
        this.$stickyBox.css({
          top: this.getTopPosition(),
          left: this.data.boxOffsetLeft - $win.scrollLeft()
        });
      },
      getTopPosition: function getTopPosition() {
        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          return Math.min(this.extraTop, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop);
        } else {
          return this.extraTop;
        }
      }
    },
    absolute: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            transition: 'transform ' + this.options.animSpeed + 's ease',
            '-webkit-transition': 'transform ' + this.options.animSpeed + 's ease'
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.clearTimer();
        this.timer = setTimeout(function () {
          this.setDynamicPosition();
        }.bind(this), this.options.animDelay * 1000);
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.clearTimer();
          this.stickyFlag = false;
          this.timer = setTimeout(function () {
            this.setDynamicPosition();
            setTimeout(function () {
              this.resetState();
            }.bind(this), this.options.animSpeed * 1000);
          }.bind(this), this.options.animDelay * 1000);
          this.makeCallback('fixedOff');
        }
      },
      clearTimer: function clearTimer() {
        clearTimeout(this.timer);
      },
      setDynamicPosition: function setDynamicPosition() {
        var topPosition = Math.max(0, this.getTopPosition());
        this.$stickyBox.css({
          transform: 'translateY(' + topPosition + 'px)',
          '-webkit-transform': 'translateY(' + topPosition + 'px)'
        });
      },
      getTopPosition: function getTopPosition() {
        var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          var diffOffset = Math.abs(Math.min(0, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop - this.extraTop));
          return currTopPosition - diffOffset;
        } else {
          return currTopPosition;
        }
      }
    }
  }; // jQuery plugin interface

  $.fn.stickyScrollBlock = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      container: null,
      positionType: 'fixed',
      // 'fixed' or 'absolute'
      activeClass: 'fixed-position',
      setBoxHeight: true,
      showAfterScrolled: false,
      extraTop: 0,
      extraBottom: 0,
      animDelay: 0.1,
      animSpeed: 0.2
    }, opt);
    return this.each(function () {
      var $stickyBox = jQuery(this);
      var instance = $stickyBox.data('StickyScrollBlock');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
        $stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  }; // module exports


  window.StickyScrollBlock = StickyScrollBlock;
})(jQuery, jQuery(window));
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/
 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */


(function (i) {
  'use strict';

  'function' == typeof define && define.amd ? define(['jquery'], i) : 'undefined' != typeof exports ? module.exports = i((typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)) : i(jQuery);
})(function (i) {
  'use strict';

  var e = window.Slick || {};
  e = function () {
    function e(e, o) {
      var s,
          n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(e),
        appendDots: i(e),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: 'slick-dots',
        draggable: !0,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = 'hidden', n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = 'visibilitychange', n.windowWidth = 0, n.windowTimer = null, s = i(e).data('slick') || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, 'undefined' != typeof document.mozHidden ? (n.hidden = 'mozHidden', n.visibilityChange = 'mozvisibilitychange') : 'undefined' != typeof document.webkitHidden && (n.hidden = 'webkitHidden', n.visibilityChange = 'webkitvisibilitychange'), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    }

    var t = 0;
    return e;
  }(), e.prototype.activateADA = function () {
    var i = this;
    i.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      tabindex: '0'
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ('boolean' == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), 'number' == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;
    s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = 'translate(' + i + 'px, 0px)', s.$slideTrack.css(o)) : (o[s.animType] = 'translate(0px,' + i + 'px)', s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = 'translate3d(' + e + 'px, 0px, 0px)' : o[s.animType] = 'translate3d(0px,' + e + 'px, 0px)', s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this,
        o = t.getNavTarget();
    null !== o && 'object' == _typeof(o) && o.each(function () {
      var t = i(this).slick('getSlick');
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};
    e.options.fade === !1 ? t[e.transitionType] = e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase : t[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass('slick-arrow'), e.$nextArrow = i(e.options.nextArrow).addClass('slick-arrow'), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true')) : e.$prevArrow.add(e.$nextArrow).addClass('slick-hidden').attr({
      'aria-disabled': 'true',
      tabindex: '-1'
    }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;

    if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
      for (o.$slider.addClass('slick-dotted'), t = i('<ul />').addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i('<li />').append(o.options.customPaging.call(this, o, e)));
      }

      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find('li').first().addClass('slick-active');
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ':not(.slick-cloned)').addClass('slick-slide'), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e).data('originalStyling', i(t).attr('style') || '');
    }), e.$slider.addClass('slick-slider'), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css('opacity', 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass('draggable');
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;

    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement('div');

        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement('div');

          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }

          d.appendChild(a);
        }

        o.appendChild(d);
      }

      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + '%',
        display: 'inline-block'
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();

    if ('window' === r.respondTo ? n = a : 'slider' === r.respondTo ? n = d : 'min' === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;

      for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }

      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger('breakpoint', [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);

    switch (l.is('a') && e.preventDefault(), l.is('li') || (l = l.closest('li')), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case 'previous':
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;

      case 'next':
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;

      case 'index':
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger('focus');
        break;

      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e,
        t,
        o = this;
    if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var s in e) {
      if (i < e[s]) {
        i = t;
        break;
      }

      t = e[s];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i('li', e.$dots).off('click.slick', e.changeSlide).off('mouseenter.slick', i.proxy(e.interrupt, e, !0)).off('mouseleave.slick', i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off('keydown.slick', e.keyHandler)), e.$slider.off('focus.slick blur.slick'), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide), e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off('keydown.slick', e.keyHandler), e.$nextArrow && e.$nextArrow.off('keydown.slick', e.keyHandler))), e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler), e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler), e.$list.off('touchend.slick mouseup.slick', e.swipeHandler), e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler), e.$list.off('click.slick', e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off('click.slick', e.selectHandler), i(window).off('orientationchange.slick.slick-' + e.instanceUid, e.orientationChange), i(window).off('resize.slick.slick-' + e.instanceUid, e.resize), i('[draggable!=true]', e.$slideTrack).off('dragstart', e.preventDefault), i(window).off('load.slick.slick-' + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.off('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;
    e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr('style'), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    var e = this;
    e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i('.slick-cloned', t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
      i(this).attr('style', i(this).data('originalStyling'));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass('slick-slider'), t.$slider.removeClass('slick-initialized'), t.$slider.removeClass('slick-dotted'), t.unslicked = !0, e || t.$slider.trigger('destroy', [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};
    t[e.transitionType] = '', e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    t.cssTransitions === !1 ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    e.cssTransitions === !1 ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (t) {
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && o.is(':focus') && (e.focussed = !0, e.autoPlay());
      }, 0);
    }).on('blur.slick', '*', function (t) {
      i(this);
      e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay());
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    var i = this;
    return i.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;
    if (i.options.infinite === !0) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (i.options.centerMode === !0) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    var e = this;
    return e.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];

    for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }

    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o,
        s,
        n = this;
    return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find('.slick-slide').each(function (e, s) {
      var r, l, d;
      if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1;
    }), e = Math.abs(i(t).attr('data-slick-index') - n.currentSlide) || 1) : n.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    var t = this;
    t.changeSlide({
      data: {
        message: 'index',
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass('slick-initialized') || (i(t.$slider).addClass('slick-initialized'), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger('init', [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });
    e.$slides.add(e.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      tabindex: '-1'
    }).find('a, input, button, select').attr({
      tabindex: '-1'
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find('.slick-cloned')).each(function (t) {
      var s = o.indexOf(t);

      if (i(this).attr({
        role: 'tabpanel',
        id: 'slick-slide' + e.instanceUid + t,
        tabindex: -1
      }), s !== -1) {
        var n = 'slick-slide-control' + e.instanceUid + s;
        i('#' + n).length && i(this).attr({
          'aria-describedby': n
        });
      }
    }), e.$dots.attr('role', 'tablist').find('li').each(function (s) {
      var n = o[s];
      i(this).attr({
        role: 'presentation'
      }), i(this).find('button').first().attr({
        role: 'tab',
        id: 'slick-slide-control' + e.instanceUid + s,
        'aria-controls': 'slick-slide' + e.instanceUid + n,
        'aria-label': s + 1 + ' of ' + t,
        'aria-selected': null,
        tabindex: '-1'
      });
    }).eq(e.currentSlide).find('button').attr({
      'aria-selected': 'true',
      tabindex: '0'
    }).end());

    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.options.focusOnChange ? e.$slides.eq(s).attr({
        tabindex: '0'
      }) : e.$slides.eq(s).removeAttr('tabindex');
    }

    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off('click.slick').on('click.slick', {
      message: 'previous'
    }, i.changeSlide), i.$nextArrow.off('click.slick').on('click.slick', {
      message: 'next'
    }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on('keydown.slick', i.keyHandler), i.$nextArrow.on('keydown.slick', i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i('li', e.$dots).on('click.slick', {
      message: 'index'
    }, e.changeSlide), e.options.accessibility === !0 && e.$dots.on('keydown.slick', e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i('li', e.$dots).on('mouseenter.slick', i.proxy(e.interrupt, e, !0)).on('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.on('mouseleave.slick', i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, e.swipeHandler), e.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, e.swipeHandler), e.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('click.slick', e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), i(window).on('orientationchange.slick.slick-' + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on('resize.slick.slick-' + e.instanceUid, i.proxy(e.resize, e)), i('[draggable!=true]', e.$slideTrack).on('dragstart', e.preventDefault), i(window).on('load.slick.slick-' + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match('TEXTAREA|INPUT|SELECT') || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'next' : 'previous'
      }
    }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'previous' : 'next'
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i('img[data-lazy]', e).each(function () {
        var e = i(this),
            t = i(this).attr('data-lazy'),
            o = i(this).attr('data-srcset'),
            s = i(this).attr('data-sizes') || r.$slider.attr('data-sizes'),
            n = document.createElement('img');
        n.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr('srcset', o), s && e.attr('sizes', s)), e.attr('src', t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            }), r.$slider.trigger('lazyLoaded', [r, e, t]);
          });
        }, n.onerror = function () {
          e.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), r.$slider.trigger('lazyLoadError', [r, e, t]);
        }, n.src = t;
      });
    }

    var t,
        o,
        s,
        n,
        r = this;
    if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find('.slick-slide').slice(s, n), 'anticipated' === r.options.lazyLoad) for (var l = s - 1, d = n, a = r.$slider.find('.slick-slide'), c = 0; c < r.options.slidesToScroll; c++) {
      l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
    }
    e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find('.slick-slide'), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find('.slick-cloned').slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find('.slick-cloned').slice(r.options.slidesToShow * -1), e(o));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass('slick-loading'), i.initUI(), 'progressive' === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'next'
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;

    if (!t.unslicked && (t.$slider.trigger('afterChange', [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
      var o = i(t.$slides.get(t.currentSlide));
      o.attr('tabindex', 0).focus();
    }
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'previous'
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i('img[data-lazy]', l.$slider);
    d.length ? (t = d.first(), o = t.attr('data-lazy'), s = t.attr('data-srcset'), n = t.attr('data-sizes') || l.$slider.attr('data-sizes'), r = document.createElement('img'), r.onload = function () {
      s && (t.attr('srcset', s), n && t.attr('sizes', n)), t.attr('src', o).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading'), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger('lazyLoaded', [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), l.$slider.trigger('lazyLoadError', [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger('allImagesLoaded', [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: 'index',
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;

    if ('array' === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || 'window';

      for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }

          s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }

      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass('slick-slide'), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger('reInit', [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    return 'boolean' == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit());
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};
    o.options.rtl === !0 && (i = -i), e = 'left' == o.positionProp ? Math.ceil(i) + 'px' : '0px', t = 'top' == o.positionProp ? Math.ceil(i) + 'px' : '0px', s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = 'translate(' + e + ', ' + t + ')', o.$slideTrack.css(s)) : (s[o.animType] = 'translate3d(' + e + ', ' + t + ', 0px)', o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
      padding: '0px ' + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
      padding: i.options.centerPadding + ' 0px'
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children('.slick-slide').length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children('.slick-slide').length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    i.options.variableWidth === !1 && i.$slideTrack.children('.slick-slide').width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
        position: 'relative',
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: 'relative',
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css('height', e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
    if ('object' === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = 'multiple') : 'string' === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], 'responsive' === arguments[0] && 'array' === i.type(arguments[1]) ? n = 'responsive' : 'undefined' != typeof arguments[1] && (n = 'single')), 'single' === n) r.options[o] = s;else if ('multiple' === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ('responsive' === n) for (t in s) {
      if ('array' !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }

        r.options.responsive.push(s[t]);
      }
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger('setPosition', [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;
    i.positionProp = i.options.vertical === !0 ? 'top' : 'left', 'top' === i.positionProp ? i.$slider.addClass('slick-vertical') : i.$slider.removeClass('slick-vertical'), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ('number' == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = 'OTransform', i.transformType = '-o-transform', i.transitionType = 'OTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = 'MozTransform', i.transformType = '-moz-transform', i.transitionType = 'MozTransition', void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = 'webkitTransform', i.transformType = '-webkit-transform', i.transitionType = 'webkitTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = 'msTransform', i.transformType = '-ms-transform', i.transitionType = 'msTransition', void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = 'transform', i.transformType = 'transform', i.transitionType = 'transition'), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;

    if (t = n.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true'), n.$slides.eq(i).addClass('slick-current'), n.options.centerMode === !0) {
      var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass('slick-active').attr('aria-hidden', 'false') : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass('slick-active').attr('aria-hidden', 'false')), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass('slick-center') : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass('slick-center')), n.$slides.eq(i).addClass('slick-center');
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false') : t.length <= n.options.slidesToShow ? t.addClass('slick-active').attr('aria-hidden', 'false') : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass('slick-active').attr('aria-hidden', 'false') : t.slice(o, o + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false'));

    'ondemand' !== n.options.lazyLoad && 'anticipated' !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;

    if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t - s.slideCount).prependTo(s.$slideTrack).addClass('slick-cloned');
      }

      for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t + s.slideCount).appendTo(s.$slideTrack).addClass('slick-cloned');
      }

      s.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
        i(this).attr('id', '');
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is('.slick-slide') ? i(e.target) : i(e.target).parents('.slick-slide'),
        s = parseInt(o.attr('data-slick-index'));
    return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
    if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger('beforeChange', [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick('getSlick'), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
      a.postSlide(s);
    })) : a.postSlide(s), void a.animateHeight()) : void (t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function () {
      a.postSlide(s);
    }) : a.postSlide(s)));
  }, e.prototype.startLoad = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass('slick-loading');
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? 'left' : 'right' : o <= 360 && o >= 315 ? s.options.rtl === !1 ? 'left' : 'right' : o >= 135 && o <= 225 ? s.options.rtl === !1 ? 'right' : 'left' : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? 'down' : 'up' : 'vertical';
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;

    if (o.touchObject.edgeHit === !0 && o.$slider.trigger('edge', [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case 'left':
        case 'down':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }

      'vertical' != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger('swipe', [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(e.options.swipe === !1 || 'ontouchend' in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf('mouse') !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case 'start':
        e.swipeStart(i);
        break;

      case 'move':
        e.swipeMove(i);
        break;

      case 'end':
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && 'right' === t || l.currentSlide >= l.getDotCount() && 'left' === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;
    return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void (t.dragging = !0));
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i('.slick-cloned', e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger('unslick', [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i,
        e = this;
    i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), 0 === e.currentSlide ? (e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find('li').removeClass('slick-active').end(), i.$dots.find('li').eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass('slick-active'));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;

    for (i = 0; i < r; i++) {
      if ('object' == _typeof(s) || 'undefined' == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), 'undefined' != typeof t) return t;
    }

    return o;
  };
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./components/jquery-tabs":2,"./components/row-hover-helper":4,"./components/same-height-cell":5,"./find-a-partner/dashboard-2023":6,"impv-products/src/js/product-template-newer-design":15,"impv/src/js/components/dropdown-select":17,"impv/src/js/components/marketo-form":18}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sessionStorageService = _interopRequireDefault(require("impv/src/js/services/session-storage-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var USE_CACHE = true;

var PartnerService =
/*#__PURE__*/
function () {
  function PartnerService() {
    _classCallCheck(this, PartnerService);

    this.baseUrl = '/partners/wp-json/api/v1/';
    this.partnersUrl = "".concat(this.baseUrl, "partners");
    this.taPartnersUrl = "".concat(this.baseUrl, "ta-partners");
    this.sessionStorageService = _sessionStorageService["default"];
    this.useCache = USE_CACHE;
  }

  _createClass(PartnerService, [{
    key: "buildUrl",
    value: function buildUrl(url, paramsObj) {
      if (!paramsObj) {
        return url;
      }

      var paramsStr = ''; // eslint-disable-next-line guard-for-in

      for (var key in paramsObj) {
        if (paramsStr != '') {
          paramsStr += '&';
        }

        paramsStr += key + '=' + encodeURIComponent(paramsObj[key]);
      }

      return url + '?' + paramsStr;
    }
  }, {
    key: "feachData",
    value: function feachData(url, options, version) {
      var _this = this;

      /** TODO: get isLastPage? flag from the API */
      return new Promise(function (resolve, reject) {
        $.get(_this.buildUrl(url, options)).done(function (data) {
          resolve(data);
        }).fail(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getCache",
    value: function getCache(keyObject) {
      var key = this.sessionStorageService.generateKey(keyObject);
      return this.sessionStorageService.getItem(key);
    }
  }, {
    key: "setCache",
    value: function setCache(keyObject, value) {
      var key = this.sessionStorageService.generateKey(keyObject);
      return this.sessionStorageService.setItem(key, value);
    }
  }, {
    key: "getPartnerByFilters",
    value: function getPartnerByFilters(filters) {
      var _this2 = this;

      var paged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var posts_per_page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var version = arguments.length > 3 ? arguments[3] : undefined;

      var options = _objectSpread({
        paged: paged,
        posts_per_page: posts_per_page
      }, filters);

      var useCache = this.useCache && !filters.search && !filters.country && !filters.region;
      var cacheKey = this.sessionStorageService.generateKey(['PartnerService:getPartnerByFilters', options]);
      var cache = useCache ? this.getCache(cacheKey) : false;

      if (cache) {
        return Promise.resolve({
          partners: cache,
          version: version
        });
      } else {
        var partnersUrl = this.partnersUrl;
        var level = options.level;

        if (level === 'ta') {
          delete options['level'];
          partnersUrl = this.taPartnersUrl;
        }

        return this.feachData(partnersUrl, options).then(function (partners) {
          if (useCache) {
            _this2.setCache(cacheKey, partners);
          }

          return {
            partners: partners,
            version: version
          };
        });
      }
    }
  }, {
    key: "getPartnerByLevel",
    value: function getPartnerByLevel(level) {
      var paged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var posts_per_page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var version = arguments.length > 3 ? arguments[3] : undefined;
      var options = {
        paged: paged,
        level: level,
        posts_per_page: posts_per_page
      };
      return this.feachData(this.partnersUrl, options, this.version).then(function (partners) {
        return {
          partners: partners,
          version: version
        };
      });
    }
  }, {
    key: "getPartnerByCountry",
    value: function getPartnerByCountry(level, country) {
      var paged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var posts_per_page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
      var version = arguments.length > 4 ? arguments[4] : undefined;
      var options = {
        paged: paged,
        level: level,
        country: country,
        posts_per_page: posts_per_page
      };
      return this.feachData(this.partnersUrl, options, this.version).then(function (partners) {
        return {
          partners: partners,
          version: version
        };
      });
    }
  }, {
    key: "getPartnerByRegion",
    value: function getPartnerByRegion(level, region) {
      var paged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var posts_per_page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
      var version = arguments.length > 4 ? arguments[4] : undefined;
      var options = {
        paged: paged,
        level: level,
        region: region,
        posts_per_page: posts_per_page
      };
      return this.feachData(this.partnersUrl, options, this.version).then(function (partners) {
        return {
          partners: partners,
          version: version
        };
      });
    }
  }]);

  return PartnerService;
}();

exports["default"] = PartnerService;

},{"impv/src/js/services/session-storage-service":24}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var makeRowFromColumns = function makeRowFromColumns(columns) {
  var cellSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.cell';
  var rows = [];

  if (columns && cellSelector) {
    _toConsumableArray(columns).forEach(function (col) {
      var cells = col.querySelectorAll(cellSelector);

      _toConsumableArray(cells).forEach(function (cell, i) {
        if (typeof rows[i] === 'undefined') {
          rows[i] = [];
        }

        rows[i].push(cell);
      });
    });
  }

  return rows;
};

var _default = makeRowFromColumns;
exports["default"] = _default;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _makeRowsFromColumns = _interopRequireDefault(require("./make-rows-from-columns"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RowHoverHelper =
/*#__PURE__*/
function () {
  function RowHoverHelper(holder, opts) {
    _classCallCheck(this, RowHoverHelper);

    if (holder) {
      this.opts = Object.assign({
        holderSelector: '.table-body',
        hoverClass: 'highlited',
        columns: '.table-cell',
        cellsClass: 'cell'
      }, opts);
      this.holder = holder;
      this.init();
    }
  }

  _createClass(RowHoverHelper, [{
    key: "init",
    value: function init() {
      this.rows = [];
      this.findElements();
      this.updateRows();
      this.attachEvents();
      this.isInited = true;
    }
  }, {
    key: "findElements",
    value: function findElements() {
      this.columns = this.holder.querySelectorAll(this.opts.columns);
      this.allCells = this.holder.querySelectorAll(".".concat(this.opts.cellsClass));
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.onMouseOver = function (e) {
        var t = e.target;
        var cell = null;
        var parent = t.closest(".".concat(_this.opts.cellsClass));

        if (t.classList.contains(_this.opts.cellsClass)) {
          cell = t;
        } else if (parent) {
          cell = parent;
        }

        if (cell) {
          _this.makeHighlight(cell);
        }
      };

      this.onMouseOut = function (e) {
        var currentTarget = e.currentTarget,
            relatedTarget = e.relatedTarget;

        if (!relatedTarget || relatedTarget !== currentTarget && !relatedTarget.closest(_this.opts.holderSelector)) {
          _this.removeHighlight();
        }
      };

      this.holder.addEventListener('mouseover', this.onMouseOver);
      this.holder.addEventListener('mouseout', this.onMouseOut);
    }
  }, {
    key: "makeHighlight",
    value: function makeHighlight(activeCell) {
      var _this2 = this;

      if (activeCell) {
        this.rows.forEach(function (row) {
          row.forEach(function (cell) {
            if (row.indexOf(activeCell) > -1) {
              cell.classList.add(_this2.opts.hoverClass);
            } else {
              cell.classList.remove(_this2.opts.hoverClass);
            }
          });
        });
      }
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      var _this3 = this;

      _toConsumableArray(this.allCells).forEach(function (cell) {
        cell.classList.remove(_this3.opts.hoverClass);
      });
    }
  }, {
    key: "updateRows",
    value: function updateRows() {
      this.rows = (0, _makeRowsFromColumns["default"])(this.columns, ".".concat(this.opts.cellsClass)) || [];
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isInited) {
        this.holder.removeEventListener('mouseover', this.onMouseOver);
        this.holder.removeEventListener('mouseout', this.onMouseOut);
        this.removeHighlight();
      }
    }
  }]);

  return RowHoverHelper;
}();

var _default = RowHoverHelper;
exports["default"] = _default;

},{"./make-rows-from-columns":10}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SlickWithIndicator =
/*#__PURE__*/
function () {
  function SlickWithIndicator(holder) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SlickWithIndicator);

    this.options = Object.assign({
      slick: '.slider',
      indicator: '.slides-indicator',
      slickOpts: {}
    }, opts);

    if (holder) {
      this.holder = holder;
      this.init();
    }
  }

  _createClass(SlickWithIndicator, [{
    key: "init",
    value: function init() {
      this.findElems();
      this.attachEvents();
    }
  }, {
    key: "findElems",
    value: function findElems() {
      this.$slickSlider = jQuery(this.holder.querySelector(this.options.slick));
      this.indicator = this.holder.querySelector(this.options.indicator);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;

      this.initTimer = null;

      this.onSlickInit = function (e, s) {
        // set timeout fixes this issue
        // https://github.com/kenwheeler/slick/issues/1802
        clearTimeout(_this.initTimer);
        _this.initTimer = setTimeout(function () {
          var currentSlide = s.currentSlide;

          if (_this.indicator) {
            _this.makeIndicator({
              current: currentSlide,
              step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
            });
          }
        }, 0);
      };

      this.onSlickBeforeChange = function (e, s, cur, next) {
        if (_this.indicator) {
          _this.makeIndicator({
            current: next,
            step: _this.$slickSlider.slick('slickGetOption', 'slidesToScroll')
          });
        }
      };

      this.$slickSlider.on('init', this.onSlickInit).slick(this.options.slickOpts).on('beforeChange', this.onSlickBeforeChange);
    }
  }, {
    key: "setProps",
    value: function setProps(elem) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (elem) {
        props.forEach(function (d) {
          var prop = d.prop,
              val = d.val;
          elem.style.setProperty(prop, val);
        });
      }
    }
  }, {
    key: "calcProps",
    value: function calcProps(_ref) {
      var current = _ref.current,
          step = _ref.step;
      var totalSteps = this.getDotCount();
      var currentStep = Math.floor(current / step);
      return {
        width: "".concat(1 / totalSteps * 100, "%"),
        left: "".concat(currentStep / totalSteps * 100, "%")
      };
    }
  }, {
    key: "buildProps",
    value: function buildProps() {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return [{
        prop: '--indicator-width',
        val: width
      }, {
        prop: '--indicator-left',
        val: left
      }];
    }
  }, {
    key: "makeIndicator",
    value: function makeIndicator() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        current: 1,
        step: 1
      };

      if (this.indicator) {
        // calc width and left
        var _this$calcProps = this.calcProps(opts),
            width = _this$calcProps.width,
            left = _this$calcProps.left; // build array with props


        var props = this.buildProps(width, left); // apply props to indicator

        this.setProps(this.indicator, props);
      }
    }
  }, {
    key: "getDotCount",
    value: function getDotCount() {
      var _ = this.$slickSlider.slick('getSlick');

      var breakPoint = 0;
      var counter = 0;
      var pagerQty = 0;

      if (_.options.infinite === true) {
        if (_.slideCount <= _.options.slidesToShow) {
          ++pagerQty;
        } else {
          while (breakPoint < _.slideCount) {
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
          }
        }
      } else if (_.options.centerMode === true) {
        pagerQty = _.slideCount;
      } else if (!_.options.asNavFor) {
        pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }

      return pagerQty;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.initTimer);
      this.$slickSlider.off('init', this.onSlickInit).off('beforeChange', this.onSlickBeforeChange).slick('unslick');
    }
  }], [{
    key: "jqueryInit",
    value: function jqueryInit(elOrSelector) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      jQuery(elOrSelector).each(function (i, el) {
        jQuery(el).data('SlickWithIndicator', new SlickWithIndicator(el, opts));
      });
    }
  }, {
    key: "jqueryDestroy",
    value: function jqueryDestroy(elOrSelector) {
      jQuery(elOrSelector).each(function (i, el) {
        var $el = jQuery(el);
        var data = $el.data('SlickWithIndicator');

        if (data) {
          data.destroy();
          $el.removeData('SlickWithIndicator');
        }
      });
    }
  }]);

  return SlickWithIndicator;
}();

exports["default"] = SlickWithIndicator;

},{}],13:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

window.addEventListener('DOMContentLoaded', function () {
  var onYouTubeIframeAPIReadyCallbacks = [];
  var ytIsReady = false;
  YTdeferred();

  window.onYouTubeIframeAPIReady = function () {
    onYouTubeIframeAPIReadyCallbacks.forEach(function (cb) {
      cb();
    });
    ytIsReady = true;
  };

  function YTdeferred() {
    if (window.hideYTActivated) return;

    _toConsumableArray(document.querySelectorAll('.hytPlayerWrap iframe')).forEach(function (iframe) {
      var modal = iframe.closest('.modal');
      var $m = $(modal);

      if (modal) {
        modal.classList.add('yt-deferred-video-modal');
        $m.on('shown.bs.modal', function () {
          if (iframe.getAttribute('data-created')) {
            play(iframe);
          } else {
            iframe.setAttribute('data-created', true);
            buildPlayer(iframe);
          }
        });
        $m.on('hidden.bs.modal', function () {
          stop(iframe);
        });
      }
    });

    window.hideYTActivated = true;

    function buildPlayer(iframe) {
      if (!document.getElementById('youtube-js-script')) {
        createScript();
      }

      initYT(iframe);
      setSrc(iframe);
    }

    function setSrc(iframe) {
      var videoSrc = iframe.getAttribute('vidurl');
      var srcForYoutube = videoSrc + '?enablejsapi=1&rel=0';

      var onIframeLoad = function onIframeLoad(e) {
        var modal = e.target.closest('.modal');

        if (modal) {
          modal.classList.add('player-loaded');
        }
      };

      if (videoSrc.indexOf('vimeo') === -1) {
        iframe.addEventListener('load', onIframeLoad);
        iframe.setAttribute('src', srcForYoutube);
      }
    }

    function initYT(iframe) {
      var playerWrap = iframe.closest('.hytPlayerWrap');

      var onPlayerStateChange = function onPlayerStateChange(event) {
        if (playerWrap) {
          if (event.data == YT.PlayerState.ENDED) {
            playerWrap.classList.add('ended');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playerWrap.classList.add('paused');
          } else if (event.data == YT.PlayerState.PLAYING) {
            playerWrap.classList.remove('ended');
            playerWrap.classList.remove('paused');
          }
        }
      };

      var onPlayerReady = function onPlayerReady(e) {
        var target = e.target;
        var iframe = target.h;
        var modal = iframe.closest('.modal');

        if (modal) {
          if (modal.classList.contains('show')) {
            target.playVideo();
          }
        }
      };

      var initFn = function initFn() {
        var player = new YT.Player(iframe, {
          events: {
            onStateChange: onPlayerStateChange,
            onReady: onPlayerReady
          }
        });

        if (playerWrap) {
          playerWrap.addEventListener('click', function (e) {
            if (e.target.className === 'close') {
              return;
            }

            var playerState = player.getPlayerState();

            if (playerState == YT.PlayerState.ENDED) {
              player.seekTo(0);
            } else if (playerState == YT.PlayerState.PAUSED) {
              player.playVideo();
            }
          });
        }
      };

      if (ytIsReady) {
        initFn();
      } else {
        onYouTubeIframeAPIReadyCallbacks.push(initFn);
      }
    }

    function play(iframe) {
      iframe.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"playVideo\",\"args\":\"\"}", '*');
    }

    function stop(iframe) {
      iframe.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"stopVideo\",\"args\":\"\"}", '*');
    }

    function createScript() {
      var scriptYT = document.createElement('script');
      var firstScriptTag = document.getElementsByTagName('script')[0];
      scriptYT.setAttribute('id', 'youtube-js-script');
      scriptYT.setAttribute('src', 'https://www.youtube.com/iframe_api');
      firstScriptTag.parentNode.insertBefore(scriptYT, firstScriptTag);
    }
  }
});

},{}],14:[function(require,module,exports){
"use strict";

/*!
 * jQuery serialshuffle
 * https://github.com/kevinmeunier/jquery-serialshuffle
 *
 * Copyright 2022 Meunier Kévin
 * https://www.meunierkevin.com
 *
 * Released under the MIT license
 *
 *  DC: edited to use url for images (not file name)
 */
(function ($) {
  'use strict'; // Removing a element in an array based on the value

  Array.prototype.remove = function () {
    var what,
        a = arguments,
        L = a.length,
        ax;

    while (L && this.length) {
      what = a[--L];

      while ((ax = this.indexOf(what)) !== -1) {
        this.splice(ax, 1);
      }
    }

    return this;
  };

  $.fn.serialshuffle = function (options) {
    var settings = $.extend({}, $.fn.serialshuffle.defaults, options);
    var base = this;
    var lastrandom;

    var _random;

    $.extend(this, {
      init: function init() {
        // Browsing the available lists
        this.each(function () {
          var $list = $(this);
          var data = {
            max: $list.children().length,
            lastrandom: undefined,
            arrBefore: settings.shuffle,
            arrCurrent: [],
            arrAfter: []
          }; // Storage of the currently displayed images

          $list.find('img').each(function () {
            // const filename = base.getFilename($(this));
            var filename = $(this).attr('src'); // DC: edit to use full url

            if (filename !== null) {
              data.arrCurrent.push(filename);
            }
          }); // Initialisation

          setInterval(function () {
            base.shuffle($list, data);
          }, settings.speed);
        });
      },
      random: function random(data) {
        while (_random === data.lastrandom) {
          _random = Math.floor(Math.random() * data.max);
        }

        data.lastrandom = _random;
        return _random;
      },
      shuffle: function shuffle($list, data) {
        // Restarting the loop
        if (!data.arrBefore.length) {
          data.arrBefore = data.arrAfter;
          data.arrAfter = [];
        } // Setup


        var randIndex = base.random(data);
        var $target = $list.children().eq(randIndex);
        var prevFilename = base.getFilename($target.find('img'));
        var nextFilename = data.arrBefore[Math.floor(Math.random() * data.arrBefore.length)]; // Hide the previous logo

        $target.find('img').fadeOut(1000, function () {
          $(this).remove();
        }); // Show the new logo

        $('<span class="sub-animate"><img src="' + settings.folder + nextFilename + '" alt=""></span>').appendTo($target).animate({
          opacity: 1
        }, 1000, function () {
          $(this).children().unwrap();
        }); // Reinitialisation

        data.arrBefore.remove(nextFilename);
        data.arrCurrent.remove(prevFilename);
        data.arrCurrent.push(nextFilename);
        data.arrAfter.push(prevFilename);
      },
      getFilename: function getFilename($element) {
        // return $element.attr('src').replace(/^.*[\\\/]/, ''); // DC: return file name
        return $element.attr('src'); // DC: return full url
      }
    });
    this.init();
    return this;
  };

  $.fn.serialshuffle.defaults = {
    folder: '',
    stack: [],
    speed: 2000
  };
})(jQuery);

},{}],15:[function(require,module,exports){
(function (global){
"use strict";

var _rowHoverHelper = _interopRequireDefault(require("./components/row-hover-helper"));

var _slickWithIndicator = _interopRequireDefault(require("./components/slick-with-indicator"));

require("impv/src/js/components/stycky-pagination.js");

require("./components/youtube-deferred");

require("./jquery-plugins/jquery-serialshuffle.js");

require("impv-support/src/js/components/smooth-scroll");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// import './components/jquery-tabs';
jQuery(function () {
  initInViewport();
  initPosition();
  InitTabsHeight();
  initSameHeight();
  initSlick();
  initSlickCarousel();
  initCustomHover();
  initAddClasses();
  initRowHover();
  initTabs();
  initStickyScrollBlock();
  initAnchorNavigation();
  initToggle(); // initShiftRelatedResource();

  initValuePropHover();
  initInnerScroll();
  initFAQAccordion();
  initEnlargeModal();
  initRichTabsHover();
  initShowMore();
});
$(window).on('load', function () {
  initRichTabs();
});
$(function () {
  $('.modal').each(function () {
    var src = $(this).find('iframe').attr('src');
    $(this).on('click', function () {
      $(this).find('iframe').attr('src', '');
      $(this).find('iframe').attr('src', src);
    });
  });
  $('a').has('img').addClass('not-link');
  $('a[class^=btn]').addClass('not-link');
  $('.author-name-anchor').mouseenter(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-avatar-anchor[href="' + $(e.currentTarget).attr('href') + '"]').find('.author-avatar').addClass('hover-element');
  }).mouseleave(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-avatar-anchor[href="' + $(e.currentTarget).attr('href') + '"]').find('.author-avatar').removeClass('hover-element');
  });
  $('.author-avatar-anchor').mouseenter(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-name-anchor[href="' + $(e.currentTarget).attr('href') + '"]').addClass('hover-element');
  }).mouseleave(function (e) {
    $(e.currentTarget).parents('.author-and-date').find('.author-name-anchor[href="' + $(e.currentTarget).attr('href') + '"]').removeClass('hover-element');
  });
}); // DC: /util/responsive-helper.js deals with window resize, but it does not have access to these functions

$(window).on('resize', function () {
  initRichTabsResize();
}); // DC: image enlarge modal in portfolio panels (could be extended for other panels)

function initEnlargeModal() {
  var container = document.getElementById('portfolio-accordion');
  var modal = document.getElementById('enlarge-modal');
  var modalImg = document.getElementById('modal-img');
  var imgIds = [];
  var imgDivs = document.getElementsByClassName('image-enlarge');

  for (var x = 0; x < imgDivs.length; x++) {
    var id = imgDivs[x].id;
    imgIds.push(id);
  }

  imgIds.forEach(function (id) {
    console.log(id);
    var imgId = document.getElementById(id); // DC: the webp picture function does not add in ID tag :(
    // this makes it more difficult to get the img src
    // it is the only <img> inside the only .image-container div in the imgDiv object

    var pictures = imgId.getElementsByClassName('image-container');
    var imgs = pictures[0].getElementsByTagName('img');
    var imgSrc = imgs[0].dataset.src; // image click

    imgId.addEventListener('click', function () {
      modal.classList.remove('closed');
      modal.classList.add('open');
      modalImg.src = imgSrc;
    });
  }); // When the user clicks on modal, close with animation - no need for loop, it's universal

  if (modal !== null) {
    modal.onclick = function () {
      modal.classList.remove('open');
      modal.classList.add('closed');
    };
  }
} // DC: rich panels show more - could be reused


function initShowMore() {
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  });
  $('.tab-box').each(function () {
    var panelId = $(this).data('panel-id');
    var tabId = $(this).data('tab-id');
    $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').on('click', function () {
      $('#panel-' + panelId + '-tab-' + tabId + ' .tab-content').toggleClass('show-mob');
      $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').toggleClass('opened');

      if ($('#panel-' + panelId + '-tab-' + tabId + ' .tab-content').hasClass('show-mob')) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').html('Show less');
      } else {
        $('#panel-' + panelId + '-tab-' + tabId + ' .show-more').html('Show more');
      }
    });
  });
}

function createBoxHeightAttr(pid, tid) {
  var boxElem = $('#panel-' + pid + '-tab-' + tid),
      boxesRow = $('#panel-' + pid + '-boxes-row'),
      boxHeight = Math.round(boxElem.outerHeight());

  if ($(window).width() > 767) {
    boxElem.attr('data-height', boxHeight);

    if (boxElem.hasClass('active-box')) {
      boxesRow.height(boxHeight);
    }
  } else {
    boxesRow.removeAttr('style');
  }
} // DC: load content into alternative div at breakpoints, to allow different designs
// DC: Figma has design at 1200px, the window.width is not entirely accurate, so using a lesser value than 1200 for logic


function initRichTabs() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-box').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id');
      createBoxHeightAttr(panelId, tabId); // DC: large desktop

      if ($(window).width() >= 1150) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro').contents().appendTo('#panel-' + panelId + '-button-' + tabId + ' .intro');
      }
    });
  });
} // DC: for use on window resize, check for div content and move if required


function initRichTabsResize() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-box').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id'); // Create height data attribute for animation

      createBoxHeightAttr(panelId, tabId); // DC: large desktop

      if ($(window).width() < 1150) {
        $('#panel-' + panelId + '-button-' + tabId + ' .intro').contents().appendTo('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro');
      } else if ($(window).width() >= 1150) {
        $('#panel-' + panelId + '-tab-' + tabId + ' .tab-intro').contents().appendTo('#panel-' + panelId + '-button-' + tabId + ' .intro');
      }
    });
  });
} // DC: richer tabs switch content on button hover


function initRichTabsHover() {
  // DC: allow multi panels on page
  var panelIds = [];
  $('.richer-tabs-section').each(function () {
    var id = $(this).attr('id');
    panelIds.push(id);
  }); // DC: work on each panel individually

  $.each(panelIds, function (index, value) {
    $('.tab-holder').each(function () {
      var panelId = $(this).data('panel-id');
      var tabId = $(this).data('tab-id'); // Create height data attribute for animation

      createBoxHeightAttr(panelId, tabId);
      $('#panel-' + panelId + '-button-' + tabId).on('mouseenter', function () {
        $('#panel-' + panelId + '-button-row .tab-link').removeClass('active-tab');
        $('#panel-' + panelId + '-holder-' + tabId + ' .tab-link').addClass('active-tab');
        $('#panel-' + panelId + '-boxes-row .tab-box').removeClass('active-box');
        $('#panel-' + panelId + '-tab-' + tabId + '.tab-box').addClass('active-box'); // Utilize height data attribute for animation

        if ($(window).width() > 767) {
          var boxesRow = $('#panel-' + panelId + '-boxes-row'),
              boxesRowPanel = $('#panel-' + panelId + '-tab-' + tabId);
          boxesRow.height(boxesRowPanel.attr('data-height'));
        }
      });
    });
  });
} //DC: inner scroll


function initInnerScroll() {
  var previousScroll = 0;
  var panelIds = []; // DC: panel IDs may not be sequential, get from panel data attr

  $('.inner-scroll-panel').each(function () {
    var data = $(this).data('sequence');
    panelIds.push(data);
  });
  $(window).on('scroll', function () {
    var currentScroll = $(this).scrollTop(); // DC: process each panel ID

    $.each(panelIds, function (index, value) {
      var panelId = '#inner-scroll-panel-' + value; // DC: no. of scroll sections = no. of image holders

      var sections = $(panelId + ' #img-col-id-' + value + ' .img-holder').length;

      for (var i = 1; i <= sections; i++) {
        if (currentScroll > previousScroll) {
          // DC: scroll down
          if (i < sections) {
            // DC: only proceed if this is not the last section
            if ($(window).scrollTop() >= $(panelId + ' #text-section-' + i).offset().top + $(panelId + ' #text-section-' + i).outerHeight() - window.innerHeight) {
              // DC: proceed only in this div - do not proceed when reach next div
              var element = $(panelId + ' #content-container-' + i);

              if ($(window).scrollTop() > element.offset().top + element.height()) {
                // DC: trigger on scroll to bottom of text container (as it is about to disappear off screen)
                $(panelId + ' #img-holder-' + (i + 1)).attr('class', 'img-holder on-screen');
                $(panelId + ' #img-holder-' + i).attr('class', 'img-holder off-screen');
                $(panelId + ' #progress-item-' + i).attr('class', 'progress-item inactive');
                $(panelId + ' #progress-item-' + (i + 1)).attr('class', 'progress-item active');
              }
            }
          }
        } else {
          // DC: scroll up
          if (i > 1) {
            // DC: dynamic change div section above - omit first section, as no section above
            var divTop = $(panelId + ' #content-container-' + (i - 1)).offset().top;
            var divBottom = divTop + $(panelId + ' #content-container-' + (i - 1)).outerHeight();

            if ($(window).scrollTop() >= divTop && $(window).scrollTop() <= divBottom) {
              // DC: make ALL other sections off-screen and inactive progress bar
              // this is to allow the inner navigation quick scroll to function correctly
              // the old method of systematically changed the previous section on scroll up could not process quick enough
              var allImg = $(panelId + ' .img-holder').map(function () {
                $(this).attr('class', 'img-holder off-screen');
              }).get(),
                  allProg = $(panelId + ' .progress-item').map(function () {
                $(this).attr('class', 'progress-item inactive');
              }).get();
              $(panelId + ' #img-holder-' + (i - 1)).attr('class', 'img-holder on-screen');
              $(panelId + ' #progress-item-' + (i - 1)).attr('class', 'progress-item active');
            }
          }
        }
      }
    });
    previousScroll = currentScroll;
  });
} // DC: add .dotted class where necessary on desktop+ devices (this will truncate text)


function initPossibleDotted() {
  // DC: window.width is not exact, so use 1000px to ensure class is added for desktop+ (1024px)
  $('.possible-dotted').addClass('css-dotted');
} // for toggling Boxes Panel block


function initToggle() {
  $('.js-toggle').on('click', function () {
    // show extra boxes
    if ($(this).hasClass('show')) {
      $(this).removeClass('show').addClass('hide');
      $('.js-overflow').removeClass('hide');
    } // hide extra boxes
    else {
        $(this).addClass('show').removeClass('hide');
        $('.js-overflow').addClass('hide overflow-hide');
      }
  });
  /* additional classes for more/less boxes (overflow) */

  if ($('.js-overflow').length > 0) {
    var overflow_height = $('.js-overflow').outerHeight() + 30;
    $('.js-overflow').attr('style', "height: ".concat(overflow_height, "px")).addClass('hide overflow-hide');
  } // add addtional class after transition for outerglow css


  $('.js-overflow').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
    if (!$(this).hasClass('hide')) {
      $(this).removeClass('overflow-hide');
    }
  });
  $(window).on('resize', function () {
    // reset overflow to show everything in order to determine correct height
    if ($('.js-overflow').hasClass('hide')) {
      $('.js-overflow').removeClass('hide overflow-hide'); // show more/less button

      $('.js-toggle').removeClass('show').addClass('hide');
    } // determine new height


    $('.js-overflow').removeAttr('style');
    var overflow_height = $('.js-overflow').outerHeight() + 30;
    $('.js-overflow').attr('style', "height: ".concat(overflow_height, "px")); // close overflow

    $('.js-overflow').addClass('hide overflow-hide'); // show more/less button

    $('.js-toggle').addClass('show').removeClass('hide');
  });
} // Value Prop Hover


function initValuePropHover() {
  // Click events for mobile/tablet, mouseover for desktop
  var responsiveEvent = window.innerWidth < 1199.98 ? 'click' : 'mouseover';
  $('.js-hover-cta').on(responsiveEvent, function () {
    // reset all cards
    $('.js-hover-card').removeClass('hover'); // hover only this card

    var card_id = $(this).attr('data-card'),
        card_elem = $('#' + card_id);
    card_elem.addClass('hover');
  });
  $('.js-hover-card-close').on('click', function () {
    $('.js-hover-card').removeClass('hover');
  });
  $('.js-hover-out').on('mouseover', function () {
    $('.js-hover-card').removeClass('hover');
  });
} // align blocks height


function initSameHeight() {
  jQuery('.info-boxes').sameHeight({
    elements: '.strip-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.proof-point',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.above-rule',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.info-boxes').sameHeight({
    elements: '.header-wrapper',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.explain-section').sameHeight({
    elements: '.content-box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('.how-imperva-can-help').sameHeight({
    elements: '.box h3',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.content-panels').sameHeight({
    elements: '.panel-title',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('.gpi-panel').sameHeight({
    elements: 'h3.quote',
    flexible: true,
    multiLine: true,
    biggestHeight: false
  });
  jQuery('#resources-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  });
  jQuery('#blog-slider').sameHeight({
    elements: '.tile-holder',
    flexible: true,
    multiLine: true,
    biggestHeight: true
  }); // DC: now match card sizes which are in different sliders for mobile (they appear as 1 list)

  jQuery('.resources-wrapper').sameHeight({
    elements: '.same-height-mob',
    flexible: true,
    multiLine: true,
    biggestHeight: true,
    breakpoint: 768
  });
}

function initSlick() {
  _slickWithIndicator["default"].jqueryInit('.related-row', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 3,
      slidesToShow: 3,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 3
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });

  _slickWithIndicator["default"].jqueryInit('.related-row-1', {
    slick: '.related-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToScroll: 1,
      slidesToShow: 1,
      arrow: false,
      dots: true,
      rows: 0,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      variableWidth: true,
      responsive: [{
        // DC: settings for breakpoint value and down, initial settings used for breakpoint value and up
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          dots: false
        }
      }]
    }
  }); // DC: note responsive removal of slider requires page refresh (or new page load)


  ResponsiveHelper.addRange({
    '0..767': {
      on: function on() {
        _slickWithIndicator["default"].jqueryInit('.related-row-2', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });

        _slickWithIndicator["default"].jqueryInit('.related-row-3', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        /* do nothing */
      }
    },
    '768': {
      on: function on() {
        _slickWithIndicator["default"].jqueryInit('.related-row-3.more-than-three', {
          slick: '.related-slider',
          indicator: '.slides-indicator',
          slickOpts: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrow: true,
            dots: false,
            rows: 0,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            infinite: false,
            variableWidth: true
          }
        });
      },
      off: function off() {
        /* do nothing */
      }
    }
  });

  _slickWithIndicator["default"].jqueryInit('.panels-row', {
    slick: '.panels-slider',
    indicator: '.slides-indicator',
    slickOpts: {
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      infinite: false,
      pauseOnHover: false,
      variableWidth: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    }
  });
} // slick init


function initSlickCarousel() {
  ResponsiveHelper.addRange({
    '..1199': {
      on: function on() {
        jQuery('.plans-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          variableWidth: true
        });
        jQuery('.table-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-for').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          pauseOnHover: false,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles1').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
        jQuery('.slider-titles2').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          draggable: false,
          swipe: false,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.plans-slider').slick('unslick');
        jQuery('.table-slider').slick('unslick');
        jQuery('.slider-for').slick('unslick');
        jQuery('.slider-titles1').slick('unslick');
        jQuery('.slider-titles2').slick('unslick');
      }
    }
  });
  ResponsiveHelper.addRange({
    '768..1199': {
      on: function on() {
        jQuery('.measure-slider').slick({
          slidesToScroll: 1,
          rows: 0,
          arrows: false,
          infinite: false,
          focusOnSelect: true,
          variableWidth: true,
          asNavFor: '.slider-pagination'
        });
      },
      off: function off() {
        jQuery('.measure-slider').slick('unslick');
      }
    }
  });
  jQuery('.study-slider').slick({
    slidesToScroll: 1,
    rows: 0,
    prevArrow: '<button class="slick-prev"></button>',
    nextArrow: '<button class="slick-next"></button>',
    autoplaySpeed: 5000,
    draggable: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false
  });
}

function initFAQAccordion() {
  if (jQuery('.faq-panel').length > 0 && jQuery('.faq-tabset li').length > 0) {
    var FAQli = jQuery('.js-faq-tabset > li'),
        FAQAnswer = FAQli.find('.answer');
    FAQli.each(function (index) {
      var item = jQuery(this),
          question = item.find('.question'),
          answer = item.find('.answer'),
          itemHeight = answer.height(); // get height of answer elements

      answer.attr('data-height', itemHeight); // only set the first answer visible

      if (index === 0) {
        answer.height(itemHeight);
        item.addClass('active');
      } else {
        answer.height(0);
      } // set click event handler


      question.on('click', function (e) {
        e.preventDefault;
        var thisQuestion = jQuery(this),
            thisQuestionActive = thisQuestion.parent().hasClass('active'); // Clear everything

        FAQli.removeClass('active');
        FAQAnswer.height(0); // 0 height minus padding
        // active flag check to close item that was open

        if (!thisQuestionActive) {
          // Activate and open this item
          thisQuestion.parent().addClass('active');
          var answerHeight = thisQuestion.parent().find('.answer').attr('data-height');
          thisQuestion.parent().find('.answer').height(answerHeight); // Piwik tracking

          _paq.push(['trackEvent', 'FAQ panel', 'Click', thisQuestion.text()]);
        }
      });
    }); // reset attributes if user resizes window

    jQuery(window).on('resize', function () {
      FAQAnswer.each(function (index) {
        var item = jQuery(this);
        item.removeAttr('style');
        var itemHeight = item.height();
        item.attr('data-height', itemHeight);
        var parentActive = item.parent().hasClass('active');
        if (!parentActive) item.height(0);
      });
    });
  }
}

function initTabs() {
  var holder = document.querySelector('.switcher-list');
  var changeEvt = new Event('ontabschange');
  var switchedByInput = false;
  jQuery(holder).tabset({
    tabLinks: 'a',
    addToParent: true,
    autoHeight: true,
    checkHash: true,
    onChange: function onChange(activeLink) {
      if (activeLink) {
        var id = activeLink.attr('href').replace('#', ''); // trigger input's checked state

        triggerInputs(id);
      }

      document.dispatchEvent(changeEvt); // scroll to table if tabs were swithced by inputs

      if (switchedByInput) {
        var activeTab = this.getActiveTab();
        switchedByInput = false;

        if (activeTab.length) {
          scrollToTable(activeTab);
        }
      }
    }
  });
  jQuery('.portfolio-tabset').tabset({
    tabLinks: 'a',
    addToParent: true,
    defaultTab: true,
    tabUnderlineClass: 'js-underline-slide'
  });
  var api = jQuery(holder).data('Tabset');
  var inputs = document.querySelectorAll('.switch input[data-target]');
  var attrName = 'data-checked-by-tab';

  _toConsumableArray(inputs).forEach(function (input) {
    input.addEventListener('change', onChange);
  });

  function onChange(e) {
    var target = e.target;
    var checkedByLink = target.getAttribute(attrName);
    var id = target.getAttribute('data-target');

    if (!checkedByLink && id) {
      var linkIdx = getLinkIndex(id);

      if (linkIdx !== null) {
        switchedByInput = true;
        api.activeTabIndex = linkIdx;
        api.switchTabs();
      }
    }
  }

  function triggerInputs(id) {
    if (id) {
      var _inputs = document.querySelectorAll("input[data-target=\"".concat(id, "\"]"));

      _toConsumableArray(_inputs).forEach(function (input) {
        input.checked = true;
        input.setAttribute(attrName, true);
        clearTimeout(input.checkedTimer);
        input.checkedTimer = setTimeout(function (input) {
          input.removeAttribute(attrName);
        }, 500, input);
      });
    }
  }

  function scrollToTable(holder) {
    var scrollTarget = holder.find('.table-section');

    if (scrollTarget.length) {
      scrollTarget[0].scrollIntoView(true);
    }
  }

  function getLinkIndex(id) {
    var result = null;

    if (holder) {
      var links = holder.querySelectorAll('a');

      _toConsumableArray(links).forEach(function (link, i) {
        if (link.getAttribute('href') === "#".concat(id)) {
          result = i;
        }
      });
    }

    return result;
  }
} // add class on click


function initAddClasses() {
  jQuery('.icon-tooltip').clickClass({
    classAdd: 'opened'
  });
  jQuery('.search-opener').clickClass({
    classAdd: 'active',
    addToParent: 'search-bar'
  });
  jQuery('.search-opener').on('click', function () {
    jQuery('.hero-search .search-input').focus();
  });
} // add classes on hover/touch


function initCustomHover() {
  jQuery('.icon-tooltip').touchHover({
    hoverClass: 'opened'
  });
}

function initRowHover() {
  var tables = document.querySelectorAll('.table-section .table-body');
  var apiList = [];
  ResponsiveHelper.addRange({
    '1024..': {
      on: function on() {
        _toConsumableArray(tables).forEach(function (table) {
          apiList.push(new _rowHoverHelper["default"](table));
        });
      },
      off: function off() {
        apiList.forEach(function (api) {
          api.destroy();
          api = null;
        });
      }
    }
  });
} // initialize sticky blocks on scroll


function initStickyScrollBlock() {
  var tabsHolder = jQuery('.page-content');
  var changingClass = 'tabs-changing';
  jQuery('.thead1').stickyScrollBlock({
    container: '#table',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });
  jQuery('.thead2').stickyScrollBlock({
    container: '#table2',
    showAfterScrolled: true,
    extraTop: function extraTop() {
      var totalHeight = 0;
      jQuery('#header').each(function () {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });

  var ontabschangeFn = function ontabschangeFn() {
    tabsHolder.addClass(changingClass);
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(function (api) {
          api.onResize();
          tabsHolder.removeClass(changingClass);
        }, 300, api);
      }
    });
  };

  var refreshSize = function refreshSize() {
    jQuery('.sticky-wrap-table-head .table-head').each(function () {
      var $el = jQuery(this);
      var api = $el.data('StickyScrollBlock');

      if (api) {
        api.onResize();
      }
    });
  };

  document.addEventListener('ontabschange', ontabschangeFn);
  document.addEventListener('affixHeaderHeightChanged', refreshSize);
} // Inner anchor navigation


function initAnchorNavigation() {
  if ($('.js-anchor-navigation').length > 0) {
    new SmoothScroll({
      anchorLinks: '.js-anchor-navigation > a',
      extraOffset: 60,
      activeClasses: 'child',
      anchorActiveClass: 'active',
      wheelBehavior: 'none'
    });
  }
}
/*
 * Responsive Layout helper
 */


window.ResponsiveHelper = function ($) {
  // init variables
  var handlers = [],
      prevWinWidth,
      win = $(window),
      nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = win.width();

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      $.each(handlers, function (index, rangeObject) {
        // disable current active area if needed
        $.each(rangeObject.data, function (property, item) {
          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        $.each(rangeObject.data, function (property, item) {
          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
      var tabSelected = $('.portfolio-tabset li.active'),
          tabSelectedUnderline = $('.portfolio-tabset li.js-underline-slide');

      if (winWidth > 1024 && tabSelected.length > 0 && tabSelectedUnderline.length > 0) {
        $('.portfolio-tabset').each(function (index) {
          var thisTabSelected = $(this).find('li.active'),
              thisTabSelectedUnderline = $(this).find('li.js-underline-slide');
          var tabPadding = winWidth > 1200 ? 30 : winWidth > 1024 ? 10 : 0,
              tabSelectedLeft = thisTabSelected.position().left + tabPadding,
              tabSelectedWidth = thisTabSelected.width();
          thisTabSelectedUnderline.css({
            left: tabSelectedLeft,
            width: tabSelectedWidth
          });
        });
      }
    }
  }

  win.bind('load resize orientationchange', resizeHandler); // test range

  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      $.each(ranges, function (property, data) {
        result.data[property] = {
          range: parseRange(property),
          enableCallback: data.on,
          disableCallback: data.off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}(jQuery);

function initPosition() {
  var itemList = document.querySelector('.measure-list');

  if (!itemList || itemList.classList.contains('light')) {
    return;
  }

  var elemeHeight = itemList.clientHeight;
  var timer;
  gutterHandler();
  window.addEventListener('resize', gutterHandler, false);

  function gutterHandler() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      itemList.style.paddingBottom = elemeHeight + 'px';
    }, 500);
  }
}

function InitTabsHeight() {
  var currentSection = document.querySelectorAll('.custom-tabs');

  if (!currentSection.length) {
    return;
  }

  var itemsArr = _toConsumableArray(currentSection);

  itemsArr.forEach(function (item) {
    var mainHolder = item;
    var elemeHeight = mainHolder.querySelector('.heading').clientHeight;
    var contentTabs = mainHolder.querySelector('.tab-content');
    var tabs = contentTabs.querySelectorAll('.text-col');
    var colImage = contentTabs.querySelectorAll('.centered .col-image');
    var maxTabsHeight = 0;
    var timer = null;
    var mdBreakPoint = 1024;
    heightHandler();
    window.addEventListener('resize', heightHandler, false);

    function heightHandler() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (window.innerWidth >= mdBreakPoint) {
          setTabsHeight();
          setColImageHeight();
        }
      }, 500);
    }

    function setTabsHeight() {
      for (var i = 0; i < tabs.length; i++) {
        if (maxTabsHeight < tabs[i].clientHeight) {
          maxTabsHeight = tabs[i].clientHeight;
        }
      }

      contentTabs.style.minHeight = maxTabsHeight + 'px';
    }

    function setColImageHeight() {
      for (var i = 0; i < colImage.length; i++) {
        colImage[i].style.marginTop = -elemeHeight + 'px';
        colImage[i].style.height = contentTabs.clientHeight + elemeHeight + 'px';
      }
    }
  });
}

function initInViewport() {
  jQuery('.viewport-section').itemInViewport({
    visibleMode: 2
  });
  jQuery('.viewport-section-full').itemInViewport({
    visibleMode: 1
  });
  jQuery('.viewport-section-always').itemInViewport({
    visibleMode: 2
  });
}
/*
 * jQuery In Viewport plugin
 */


(function ($, $win) {
  'use strict';

  var ScrollDetector = function () {
    var data = {};
    return {
      init: function init() {
        var self = this;
        this.addHolder('win', $win);
        $win.on('load.blockInViewport resize.blockInViewport orientationchange.blockInViewport', function () {
          $.each(data, function (holderKey, holderData) {
            self.calcHolderSize(holderData);
            $.each(holderData.items, function (itemKey, itemData) {
              self.calcItemSize(itemKey, itemData);
            });
          });
        });
      },
      addHolder: function addHolder(holderKey, $holder) {
        var self = this;
        var holderData = {
          holder: $holder,
          items: {},
          props: {
            height: 0,
            scroll: 0
          }
        };
        data[holderKey] = holderData;
        $holder.on('scroll.blockInViewport', function () {
          self.calcHolderScroll(holderData);
          $.each(holderData.items, function (itemKey, itemData) {
            self.calcItemScroll(itemKey, itemData);
          });
        });
        this.calcHolderSize(data[holderKey]);
      },
      calcHolderSize: function calcHolderSize(holderData) {
        var holderOffset = window.self !== holderData.holder[0] ? holderData.holder.offset() : 0;
        holderData.props.height = holderData.holder.get(0) === window ? window.innerHeight || document.documentElement.clientHeight : holderData.holder.outerHeight();
        holderData.props.offset = holderOffset ? holderOffset.top : 0;
        this.calcHolderScroll(holderData);
      },
      calcItemSize: function calcItemSize(itemKey, itemData) {
        itemData.offset = itemData.$el.offset().top - itemData.holderProps.props.offset;
        itemData.height = itemData.$el.outerHeight();
        this.calcItemScroll(itemKey, itemData);
      },
      calcHolderScroll: function calcHolderScroll(holderData) {
        holderData.props.scroll = holderData.holder.scrollTop();
      },
      calcItemScroll: function calcItemScroll(itemKey, itemData) {
        var itemInViewPortFromUp;
        var itemInViewPortFromDown;
        var itemOutViewPort;
        var holderProps = itemData.holderProps.props;

        switch (itemData.options.visibleMode) {
          case 1:
            itemInViewPortFromDown = itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemData.offset > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          case 2:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + itemData.height / 2 < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height / 2 > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          case 3:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;

          default:
            itemInViewPortFromDown = itemInViewPortFromDown || itemData.offset < holderProps.scroll + holderProps.height / 2 || itemData.offset + Math.min(itemData.options.visibleMode, itemData.height) < holderProps.scroll + holderProps.height;
            itemInViewPortFromUp = itemInViewPortFromUp || itemData.offset + itemData.height - Math.min(itemData.options.visibleMode, itemData.height) > holderProps.scroll || itemData.offset + itemData.height > holderProps.scroll + holderProps.height / 2;
            break;
        }

        if (itemInViewPortFromUp && itemInViewPortFromDown) {
          if (!itemData.state) {
            itemData.state = true;
            itemData.$el.addClass(itemData.options.activeClass).trigger('in-viewport', true);

            if (itemData.options.once || $.isFunction(itemData.options.onShow) && itemData.options.onShow(itemData)) {
              delete itemData.holderProps.items[itemKey];
            }
          }
        } else {
          itemOutViewPort = itemData.offset < holderProps.scroll + holderProps.height && itemData.offset + itemData.height > holderProps.scroll;

          if ((itemData.state || isNaN(itemData.state)) && !itemOutViewPort) {
            itemData.state = false;
            itemData.$el.removeClass(itemData.options.activeClass).trigger('in-viewport', false);
          }
        }
      },
      addItem: function addItem(el, options) {
        var itemKey = 'item' + this.getRandomValue();
        var newItem = {
          $el: $(el),
          options: options
        };
        var holderKeyDataName = 'in-viewport-holder';
        var $holder = newItem.$el.closest(options.holder);
        var holderKey = $holder.data(holderKeyDataName);

        if (!$holder.length) {
          holderKey = 'win';
        } else if (!holderKey) {
          holderKey = 'holder' + this.getRandomValue();
          $holder.data(holderKeyDataName, holderKey);
          this.addHolder(holderKey, $holder);
        }

        newItem.holderProps = data[holderKey];
        data[holderKey].items[itemKey] = newItem;
        this.calcItemSize(itemKey, newItem);
      },
      getRandomValue: function getRandomValue() {
        return (Math.random() * 100000).toFixed(0);
      },
      destroy: function destroy() {
        $win.off('.blockInViewport');
        $.each(data, function (key, value) {
          value.holder.off('.blockInViewport');
          $.each(value.items, function (key, value) {
            value.$el.removeClass(value.options.activeClass);
            value.$el.get(0).itemInViewportAdded = null;
          });
        });
        data = {};
      }
    };
  }();

  ScrollDetector.init();

  $.fn.itemInViewport = function (options) {
    options = $.extend({
      activeClass: 'in-viewport',
      once: true,
      holder: '',
      visibleMode: 1 // 1 - full block, 2 - half block, 3 - immediate, 4... - custom

    }, options);
    return this.each(function () {
      if (this.itemInViewportAdded) {
        return;
      }

      this.itemInViewportAdded = true;
      ScrollDetector.addItem(this, options);
    });
  };
})(jQuery, jQuery(window));

$(function () {
  // $(document).ready(() => {
  //   setTimeout(function() {
  //     updateExplainSection();
  //     // updateValueProposition();
  //   }, 1000);
  // });
  // $(window).resize(() => {
  //   updateExplainSection();
  //   updateValueProposition();
  // });
  //workaround to align the height of the description in explain-section's tiles with the position of the longest/highest title
  // const updateExplainSection = () => {
  //   if ($(document).width() > 767) {
  //     let initHeight = 0;
  //     $('.explain-section').each((_, el) => {
  //       initHeight = 0;
  //       $(el)
  //         .find('.content-box')
  //         .each((_, box) => {
  //           initHeight =
  //             $(box)
  //               .find('h3')
  //               .height() > initHeight
  //               ? $(box)
  //                   .find('h3')
  //                   .height()
  //               : initHeight;
  //         });
  //       $(el)
  //         .find('.content-box')
  //         .find('h3')
  //         .height(initHeight);
  //     });
  //   }
  // };
  //workaround to align the padding bottom of Value proposition section boxes in cases where one of the Metric descriptions has more rows then the other
  // const updateValueProposition = () => {
  //   if ($(document).width() >= 1440 || $(document).width() < 1200) {
  //     $('.info-boxes').each((_, el) => {
  //       let initPadding = 32;
  //       $(el)
  //         .find('.info-box')
  //         .each((_, box) => {
  //           initPadding =
  //             $(box)
  //               .find('.text')
  //               .height() > initPadding
  //               ? $(box)
  //                   .find('.text')
  //                   .height()
  //               : initPadding;
  //         });
  //       const $infoBoxElem = $(el).find('.info-box');
  //       $infoBoxElem.find('.text').height(initPadding);
  //       if (
  //         $(document).width() >= 1440 ||
  //         (initPadding > 62 && $(document).width() <= 1024)
  //       ) {
  //         $infoBoxElem
  //           .find('hr')
  //           .css(
  //             'bottom',
  //             parseInt($infoBoxElem.find('hr').css('bottom'), 10) + 32 + 'px'
  //           );
  //       }
  //     });
  //   }
  // };
  var $faqsCollapse = $('.faqs-collapse');
  $faqsCollapse.on('show.bs.collapse', function (_ref) {
    var currentTarget = _ref.currentTarget;
    $(currentTarget).parent('.box').addClass('box-open').removeClass('box-close');
  });
  $faqsCollapse.on('hide.bs.collapse', function (_ref2) {
    var currentTarget = _ref2.currentTarget;
    $(currentTarget).parent('.box').addClass('box-close').removeClass('box-open');
  });
  $('.db-listing-section .show-all-btn').on('click', function (_ref3) {
    var currentTarget = _ref3.currentTarget;
    $('.db-listing-section .box').parent().show();
    $(currentTarget).hide();
  });
});
document.addEventListener('DOMContentLoaded', function () {
  initPossibleDotted(); // DC: this only works when called here

  jQuery('.dotted').dotdotdot({
    ellipsis: "\u2026 ",
    height: null,
    keep: '.read-more',
    tolerance: 0,
    truncate: 'word',
    watch: 'true'
  });
});

(function (root, factory) {
  // if (typeof define === 'function' && define.amd) {
  // 	define(['jquery'], factory);
  // } else if (typeof exports === 'object') {
  // 	module.exports = factory(require('jquery'));
  // } else {
  // 	root.jquery_dotdotdot_js = factory(root.jQuery);
  // }
  factory(jQuery);
})(void 0, function (jQuery) {
  /*
   *	jQuery dotdotdot 3.2.2
   *	@requires jQuery 1.7.0 or later
   *
   *	dotdotdot.frebsite.nl
   *
   *	Copyright (c) Fred Heusschen
   *	www.frebsite.nl
   *
   *	License: CC-BY-NC-4.0
   *	http://creativecommons.org/licenses/by-nc/4.0/
   */
  !function (t) {
    'use strict';

    function e() {
      h = t(window), s = {}, o = {}, r = {}, t.each([s, o, r], function (t, e) {
        e.add = function (t) {
          t = t.split(' ');

          for (var i = 0, n = t.length; i < n; i++) {
            e[t[i]] = e.ddd(t[i]);
          }
        };
      }), s.ddd = function (t) {
        return 'ddd-' + t;
      }, s.add('truncated keep'), o.ddd = function (t) {
        return 'ddd-' + t;
      }, r.ddd = function (t) {
        return t + '.ddd';
      }, r.add('resize'), e = function e() {};
    }

    var i = 'dotdotdot',
        n = '3.2.2';

    if (!(t[i] && t[i].version > n)) {
      t[i] = function (t, e) {
        this.$dot = t, this.api = ['getInstance', 'truncate', 'restore', 'destroy', 'watch', 'unwatch'], this.opts = e;
        var n = this.$dot.data(i);
        return n && n.destroy(), this.init(), this.truncate(), this.opts.watch && this.watch(), this;
      }, t[i].version = n, t[i].uniqueId = 0, t[i].defaults = {
        ellipsis: '… ',
        callback: function callback(t) {},
        truncate: 'word',
        tolerance: 0,
        keep: null,
        watch: 'window',
        height: null
      }, t[i].prototype = {
        init: function init() {
          this.watchTimeout = null, this.watchInterval = null, this.uniqueId = t[i].uniqueId++, this.originalStyle = this.$dot.attr('style') || '', this.originalContent = this._getOriginalContent(), 'break-word' !== this.$dot.css('word-wrap') && this.$dot.css('word-wrap', 'break-word'), 'nowrap' === this.$dot.css('white-space') && this.$dot.css('white-space', 'normal'), null === this.opts.height && (this.opts.height = this._getMaxHeight()), 'string' == typeof this.opts.ellipsis && (this.opts.ellipsis = document.createTextNode(this.opts.ellipsis));
        },
        getInstance: function getInstance() {
          return this;
        },
        truncate: function truncate() {
          this.$inner = this.$dot.wrapInner('<div />').children().css({
            display: 'block',
            height: 'auto',
            width: 'auto',
            border: 'none',
            padding: 0,
            margin: 0
          }), this.$inner.empty().append(this.originalContent.clone(!0)), this.maxHeight = this._getMaxHeight();
          var t = !1;
          return this._fits() || (t = !0, this._truncateToNode(this.$inner[0])), this.$dot[t ? 'addClass' : 'removeClass'](s.truncated), this.$inner.replaceWith(this.$inner.contents()), this.$inner = null, this.opts.callback.call(this.$dot[0], t), t;
        },
        restore: function restore() {
          this.unwatch(), this.$dot.empty().append(this.originalContent).attr('style', this.originalStyle).removeClass(s.truncated);
        },
        destroy: function destroy() {
          this.restore(), this.$dot.data(i, null);
        },
        watch: function watch() {
          var t = this;
          this.unwatch();
          var e = {};
          'window' == this.opts.watch ? h.on(r.resize + t.uniqueId, function (i) {
            t.watchTimeout && clearTimeout(t.watchTimeout), t.watchTimeout = setTimeout(function () {
              e = t._watchSizes(e, h, 'width', 'height');
            }, 100);
          }) : this.watchInterval = setInterval(function () {
            e = t._watchSizes(e, t.$dot, 'innerWidth', 'innerHeight');
          }, 500);
        },
        unwatch: function unwatch() {
          h.off(r.resize + this.uniqueId), this.watchInterval && clearInterval(this.watchInterval), this.watchTimeout && clearTimeout(this.watchTimeout);
        },
        _api: function _api() {
          var e = this,
              i = {};
          return t.each(this.api, function (t) {
            var n = this;

            i[n] = function () {
              var t = e[n].apply(e, arguments);
              return 'undefined' == typeof t ? i : t;
            };
          }), i;
        },
        _truncateToNode: function _truncateToNode(e) {
          var i = [],
              n = [];

          if (t(e).contents().each(function () {
            var e = t(this);

            if (!e.hasClass(s.keep)) {
              var o = document.createComment('');
              e.replaceWith(o), n.push(this), i.push(o);
            }
          }), n.length) {
            for (var o = 0; o < n.length; o++) {
              t(i[o]).replaceWith(n[o]), t(n[o]).append(this.opts.ellipsis);

              var r = this._fits();

              if (t(this.opts.ellipsis, n[o]).remove(), !r) {
                if ('node' == this.opts.truncate && o > 1) return void t(n[o - 2]).remove();
                break;
              }
            }

            for (var h = o; h < i.length; h++) {
              t(i[h]).remove();
            }

            var a = n[Math.max(0, Math.min(o, n.length - 1))];

            if (1 == a.nodeType) {
              var d = t('<' + a.nodeName + ' />');
              d.append(this.opts.ellipsis), t(a).replaceWith(d), this._fits() ? d.replaceWith(a) : (d.remove(), a = n[Math.max(0, o - 1)]);
            }

            1 == a.nodeType ? this._truncateToNode(a) : this._truncateToWord(a);
          }
        },
        _truncateToWord: function _truncateToWord(t) {
          for (var e = t, i = this, n = this.__getTextContent(e), s = n.indexOf(' ') !== -1 ? ' ' : '　', o = n.split(s), r = '', h = o.length; h >= 0; h--) {
            if (r = o.slice(0, h).join(s), i.__setTextContent(e, i._addEllipsis(r)), i._fits()) {
              'letter' == i.opts.truncate && (i.__setTextContent(e, o.slice(0, h + 1).join(s)), i._truncateToLetter(e));
              break;
            }
          }
        },
        _truncateToLetter: function _truncateToLetter(t) {
          for (var e = this, i = this.__getTextContent(t), n = i.split(''), s = '', o = n.length; o >= 0 && (s = n.slice(0, o).join(''), !s.length || (e.__setTextContent(t, e._addEllipsis(s)), !e._fits())); o--) {
            ;
          }
        },
        _fits: function _fits() {
          return this.$inner.innerHeight() <= this.maxHeight + this.opts.tolerance;
        },
        _addEllipsis: function _addEllipsis(e) {
          for (var i = [' ', '　', ',', ';', '.', '!', '?']; t.inArray(e.slice(-1), i) > -1;) {
            e = e.slice(0, -1);
          }

          return e += this.__getTextContent(this.opts.ellipsis);
        },
        _getOriginalContent: function _getOriginalContent() {
          var e = this;
          return this.$dot.find('script, style').addClass(s.keep), this.opts.keep && this.$dot.find(this.opts.keep).addClass(s.keep), this.$dot.find('*').not('.' + s.keep).add(this.$dot).contents().each(function () {
            var i = this,
                n = t(this);

            if (3 == i.nodeType) {
              if ('' == t.trim(e.__getTextContent(i))) {
                if (n.parent().is('table, thead, tbody, tfoot, tr, dl, ul, ol, video')) return void n.remove();
                if (n.prev().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (n.next().is('div, p, table, td, td, dt, dd, li')) return void n.remove();
                if (!n.prev().length) return void n.remove();
                if (!n.next().length) return void n.remove();
              }
            } else 8 == i.nodeType && n.remove();
          }), this.$dot.contents();
        },
        _getMaxHeight: function _getMaxHeight() {
          if ('number' == typeof this.opts.height) return this.opts.height;

          for (var t = ['maxHeight', 'height'], e = 0, i = 0; i < t.length; i++) {
            if (e = window.getComputedStyle(this.$dot[0])[t[i]], 'px' == e.slice(-2)) {
              e = parseFloat(e);
              break;
            }
          }

          var t = [];

          switch (this.$dot.css('boxSizing')) {
            case 'border-box':
              t.push('borderTopWidth'), t.push('borderBottomWidth');

            case 'padding-box':
              t.push('paddingTop'), t.push('paddingBottom');
          }

          for (var i = 0; i < t.length; i++) {
            var n = window.getComputedStyle(this.$dot[0])[t[i]];
            'px' == n.slice(-2) && (e -= parseFloat(n));
          }

          return Math.max(e, 0);
        },
        _watchSizes: function _watchSizes(t, e, i, n) {
          if (this.$dot.is(':visible')) {
            var s = {
              width: e[i](),
              height: e[n]()
            };
            return t.width == s.width && t.height == s.height || this.truncate(), s;
          }

          return t;
        },
        __getTextContent: function __getTextContent(t) {
          for (var e = ['nodeValue', 'textContent', 'innerText'], i = 0; i < e.length; i++) {
            if ('string' == typeof t[e[i]]) return t[e[i]];
          }

          return '';
        },
        __setTextContent: function __setTextContent(t, e) {
          for (var i = ['nodeValue', 'textContent', 'innerText'], n = 0; n < i.length; n++) {
            t[i[n]] = e;
          }
        }
      }, t.fn[i] = function (n) {
        return e(), n = t.extend(!0, {}, t[i].defaults, n), this.each(function () {
          t(this).data(i, new t[i](t(this), n)._api());
        });
      };
      var s, o, r, h;
    }
  }(jQuery);
  return true;
});
/*
 * jQuery SameHeight plugin
 */


(function ($) {
  $.fn.sameHeight = function (opt) {
    var options = $.extend({
      skipClass: 'same-height-ignore',
      leftEdgeClass: 'same-height-left',
      rightEdgeClass: 'same-height-right',
      elements: '>*',
      flexible: false,
      multiLine: false,
      useMinHeight: false,
      biggestHeight: false
    }, opt);
    return this.each(function () {
      var holder = $(this),
          postResizeTimer,
          ignoreResize;
      var elements = holder.find(options.elements).not('.' + options.skipClass);
      if (!elements.length) return; // resize handler

      function doResize() {
        elements.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', '');

        if (options.multiLine) {
          // resize elements row by row
          resizeElementsByRows(elements, options);
        } else {
          // resize elements by holder
          resizeElements(elements, holder, options);
        }
      }

      doResize(); // handle flexible layout / font resize

      var delayedResizeHandler = function delayedResizeHandler() {
        if (!ignoreResize) {
          ignoreResize = true;
          doResize();
          clearTimeout(postResizeTimer);
          postResizeTimer = setTimeout(function () {
            doResize();
            setTimeout(function () {
              ignoreResize = false;
            }, 10);
          }, 100);
        }
      }; // handle flexible/responsive layout


      if (options.flexible) {
        $(window).bind('resize orientationchange fontresize', delayedResizeHandler);
      } // handle complete page load including images and fonts


      $(window).bind('load', delayedResizeHandler);
    });
  }; // detect css min-height support


  var supportMinHeight = typeof document.documentElement.style.maxHeight !== 'undefined'; // get elements by rows

  function resizeElementsByRows(boxes, options) {
    var currentRow = $(),
        maxHeight,
        maxCalcHeight = 0,
        firstOffset = boxes.eq(0).offset().top;
    boxes.each(function (ind) {
      var curItem = $(this);

      if (curItem.offset().top === firstOffset) {
        currentRow = currentRow.add(this);
      } else {
        maxHeight = getMaxHeight(currentRow);
        maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
        currentRow = curItem;
        firstOffset = curItem.offset().top;
      }
    });

    if (currentRow.length) {
      maxHeight = getMaxHeight(currentRow);
      maxCalcHeight = Math.max(maxCalcHeight, resizeElements(currentRow, maxHeight, options));
    }

    if (options.biggestHeight) {
      boxes.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', maxCalcHeight);
    }
  } // calculate max element height


  function getMaxHeight(boxes) {
    var maxHeight = 0;
    boxes.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });
    return maxHeight;
  } // resize helper function


  function resizeElements(boxes, parent, options) {
    var calcHeight;
    var parentHeight = typeof parent === 'number' ? parent : parent.height();
    boxes.removeClass(options.leftEdgeClass).removeClass(options.rightEdgeClass).each(function (i) {
      var element = $(this);
      var depthDiffHeight = 0;
      var isBorderBox = element.css('boxSizing') === 'border-box' || element.css('-moz-box-sizing') === 'border-box' || element.css('-webkit-box-sizing') === 'border-box';

      if (typeof parent !== 'number') {
        element.parents().each(function () {
          var tmpParent = $(this);

          if (parent.is(this)) {
            return false;
          } else {
            depthDiffHeight += tmpParent.outerHeight() - tmpParent.height();
          }
        });
      }

      calcHeight = parentHeight - depthDiffHeight;
      calcHeight -= isBorderBox ? 0 : element.outerHeight() - element.height();

      if (calcHeight > 0) {
        element.css(options.useMinHeight && supportMinHeight ? 'minHeight' : 'height', calcHeight);
      }
    });
    boxes.filter(':first').addClass(options.leftEdgeClass);
    boxes.filter(':last').addClass(options.rightEdgeClass);
    return calcHeight;
  }
})(jQuery);
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/
 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */


(function (i) {
  'use strict';

  'function' == typeof define && define.amd ? define(['jquery'], i) : 'undefined' != typeof exports ? module.exports = i((typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null)) : i(jQuery);
})(function (i) {
  'use strict';

  var e = window.Slick || {};
  e = function () {
    function e(e, o) {
      var s,
          n = this;
      n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(e),
        appendDots: i(e),
        arrows: !0,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        },
        dots: !1,
        dotsClass: 'slick-dots',
        draggable: !0,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3
      }, n.initials = {
        animating: !1,
        dragging: !1,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: !1,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: !1,
        slideOffset: 0,
        swipeLeft: null,
        swiping: !1,
        $list: null,
        touchObject: {},
        transformsEnabled: !1,
        unslicked: !1
      }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = 'hidden', n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(e), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = 'visibilitychange', n.windowWidth = 0, n.windowTimer = null, s = i(e).data('slick') || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, 'undefined' != typeof document.mozHidden ? (n.hidden = 'mozHidden', n.visibilityChange = 'mozvisibilitychange') : 'undefined' != typeof document.webkitHidden && (n.hidden = 'webkitHidden', n.visibilityChange = 'webkitvisibilitychange'), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = t++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    }

    var t = 0;
    return e;
  }(), e.prototype.activateADA = function () {
    var i = this;
    i.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      tabindex: '0'
    });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;
    if ('boolean' == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;
    s.unload(), 'number' == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.animate({
        height: e
      }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;
    s.animateHeight(), s.options.rtl === !0 && s.options.vertical === !1 && (e = -e), s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
      left: e
    }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
      top: e
    }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft), i({
      animStart: s.currentLeft
    }).animate({
      animStart: e
    }, {
      duration: s.options.speed,
      easing: s.options.easing,
      step: function step(i) {
        i = Math.ceil(i), s.options.vertical === !1 ? (o[s.animType] = 'translate(' + i + 'px, 0px)', s.$slideTrack.css(o)) : (o[s.animType] = 'translate(0px,' + i + 'px)', s.$slideTrack.css(o));
      },
      complete: function complete() {
        t && t.call();
      }
    })) : (s.applyTransition(), e = Math.ceil(e), s.options.vertical === !1 ? o[s.animType] = 'translate3d(' + e + 'px, 0px, 0px)' : o[s.animType] = 'translate3d(0px,' + e + 'px, 0px)', s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;
    return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this,
        o = t.getNavTarget();
    null !== o && 'object' == _typeof(o) && o.each(function () {
      var t = i(this).slick('getSlick');
      t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};
    e.options.fade === !1 ? t[e.transitionType] = e.transformType + ' ' + e.options.speed + 'ms ' + e.options.cssEase : t[e.transitionType] = 'opacity ' + e.options.speed + 'ms ' + e.options.cssEase, e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;
    i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;
    i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
    i.paused || i.interrupted || i.focussed || (i.options.infinite === !1 && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;
    e.options.arrows === !0 && (e.$prevArrow = i(e.options.prevArrow).addClass('slick-arrow'), e.$nextArrow = i(e.options.nextArrow).addClass('slick-arrow'), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex'), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), e.options.infinite !== !0 && e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true')) : e.$prevArrow.add(e.$nextArrow).addClass('slick-hidden').attr({
      'aria-disabled': 'true',
      tabindex: '-1'
    }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;

    if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
      for (o.$slider.addClass('slick-dotted'), t = i('<ul />').addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i('<li />').append(o.options.customPaging.call(this, o, e)));
      }

      o.$dots = t.appendTo(o.options.appendDots), o.$dots.find('li').first().addClass('slick-active');
    }
  }, e.prototype.buildOut = function () {
    var e = this;
    e.$slides = e.$slider.children(e.options.slide + ':not(.slick-cloned)').addClass('slick-slide'), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr('data-slick-index', e).data('originalStyling', i(t).attr('style') || '');
    }), e.$slider.addClass('slick-slider'), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css('opacity', 0), e.options.centerMode !== !0 && e.options.swipeToSlide !== !0 || (e.options.slidesToScroll = 1), i('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.options.draggable === !0 && e.$list.addClass('draggable');
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;

    if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 0) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement('div');

        for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement('div');

          for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);
            n.get(c) && a.appendChild(n.get(c));
          }

          d.appendChild(a);
        }

        o.appendChild(d);
      }

      l.$slider.empty().append(o), l.$slider.children().children().children().css({
        width: 100 / l.options.slidesPerRow + '%',
        display: 'inline-block'
      });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();

    if ('window' === r.respondTo ? n = a : 'slider' === r.respondTo ? n = d : 'min' === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;

      for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (r.originalSettings.mobileFirst === !1 ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }

      null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, 'unslick' === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, e === !0 && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || l === !1 || r.$slider.trigger('breakpoint', [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);

    switch (l.is('a') && e.preventDefault(), l.is('li') || (l = l.closest('li')), n = r.slideCount % r.options.slidesToScroll !== 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
      case 'previous':
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
        break;

      case 'next':
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
        break;

      case 'index':
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
        r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger('focus');
        break;

      default:
        return;
    }
  }, e.prototype.checkNavigable = function (i) {
    var e,
        t,
        o = this;
    if (e = o.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var s in e) {
      if (i < e[s]) {
        i = t;
        break;
      }

      t = e[s];
    }
    return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;
    e.options.dots && null !== e.$dots && (i('li', e.$dots).off('click.slick', e.changeSlide).off('mouseenter.slick', i.proxy(e.interrupt, e, !0)).off('mouseleave.slick', i.proxy(e.interrupt, e, !1)), e.options.accessibility === !0 && e.$dots.off('keydown.slick', e.keyHandler)), e.$slider.off('focus.slick blur.slick'), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide), e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide), e.options.accessibility === !0 && (e.$prevArrow && e.$prevArrow.off('keydown.slick', e.keyHandler), e.$nextArrow && e.$nextArrow.off('keydown.slick', e.keyHandler))), e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler), e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler), e.$list.off('touchend.slick mouseup.slick', e.swipeHandler), e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler), e.$list.off('click.slick', e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), e.options.accessibility === !0 && e.$list.off('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().off('click.slick', e.selectHandler), i(window).off('orientationchange.slick.slick-' + e.instanceUid, e.orientationChange), i(window).off('resize.slick.slick-' + e.instanceUid, e.resize), i('[draggable!=true]', e.$slideTrack).off('dragstart', e.preventDefault), i(window).off('load.slick.slick-' + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;
    e.$list.off('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.off('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;
    e.options.rows > 0 && (i = e.$slides.children().children(), i.removeAttr('style'), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    var e = this;
    e.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;
    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i('.slick-cloned', t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', ''), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
      i(this).attr('style', i(this).data('originalStyling'));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass('slick-slider'), t.$slider.removeClass('slick-initialized'), t.$slider.removeClass('slick-dotted'), t.unslicked = !0, e || t.$slider.trigger('destroy', [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};
    t[e.transitionType] = '', e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;
    t.cssTransitions === !1 ? (t.$slides.eq(i).css({
      zIndex: t.options.zIndex
    }), t.$slides.eq(i).animate({
      opacity: 1
    }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
      opacity: 1,
      zIndex: t.options.zIndex
    }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;
    e.cssTransitions === !1 ? e.$slides.eq(i).animate({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
      opacity: 0,
      zIndex: e.options.zIndex - 2
    }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;
    null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;
    e.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (t) {
      var o = i(this);
      setTimeout(function () {
        e.options.pauseOnFocus && o.is(':focus') && (e.focussed = !0, e.autoPlay());
      }, 0);
    }).on('blur.slick', '*', function (t) {
      i(this);
      e.options.pauseOnFocus && (e.focussed = !1, e.autoPlay());
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    var i = this;
    return i.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;
    if (i.options.infinite === !0) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (i.options.centerMode === !0) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
    return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;
    return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), n.options.infinite === !0 ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, n.options.vertical === !0 && n.options.centerMode === !0 && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll !== 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : n.options.centerMode === !0 && n.options.infinite === !0 ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : n.options.centerMode === !0 && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = n.options.vertical === !1 ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, n.options.variableWidth === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, n.options.centerMode === !0 && (o = n.slideCount <= n.options.slidesToShow || n.options.infinite === !1 ? n.$slideTrack.children('.slick-slide').eq(i) : n.$slideTrack.children('.slick-slide').eq(i + n.options.slidesToShow + 1), e = n.options.rtl === !0 ? o[0] ? (n.$slideTrack.width() - o[0].offsetLeft - o.width()) * -1 : 0 : o[0] ? o[0].offsetLeft * -1 : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    var e = this;
    return e.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];

    for (e.options.infinite === !1 ? i = e.slideCount : (t = e.options.slidesToScroll * -1, o = e.options.slidesToScroll * -1, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }

    return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o,
        s,
        n = this;
    return s = n.options.centerMode === !0 ? Math.floor(n.$list.width() / 2) : 0, o = n.swipeLeft * -1 + s, n.options.swipeToSlide === !0 ? (n.$slideTrack.find('.slick-slide').each(function (e, s) {
      var r, l, d;
      if (r = i(s).outerWidth(), l = s.offsetLeft, n.options.centerMode !== !0 && (l += r / 2), d = l + r, o < d) return t = s, !1;
    }), e = Math.abs(i(t).attr('data-slick-index') - n.currentSlide) || 1) : n.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    var t = this;
    t.changeSlide({
      data: {
        message: 'index',
        index: parseInt(i)
      }
    }, e);
  }, e.prototype.init = function (e) {
    var t = this;
    i(t.$slider).hasClass('slick-initialized') || (i(t.$slider).addClass('slick-initialized'), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger('init', [t]), t.options.accessibility === !0 && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });
    e.$slides.add(e.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      tabindex: '-1'
    }).find('a, input, button, select').attr({
      tabindex: '-1'
    }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find('.slick-cloned')).each(function (t) {
      var s = o.indexOf(t);

      if (i(this).attr({
        role: 'tabpanel',
        id: 'slick-slide' + e.instanceUid + t,
        tabindex: -1
      }), s !== -1) {
        var n = 'slick-slide-control' + e.instanceUid + s;
        i('#' + n).length && i(this).attr({
          'aria-describedby': n
        });
      }
    }), e.$dots.attr('role', 'tablist').find('li').each(function (s) {
      var n = o[s];
      i(this).attr({
        role: 'presentation'
      }), i(this).find('button').first().attr({
        role: 'tab',
        id: 'slick-slide-control' + e.instanceUid + s,
        'aria-controls': 'slick-slide' + e.instanceUid + n,
        'aria-label': s + 1 + ' of ' + t,
        'aria-selected': null,
        tabindex: '-1'
      });
    }).eq(e.currentSlide).find('button').attr({
      'aria-selected': 'true',
      tabindex: '0'
    }).end());

    for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.options.focusOnChange ? e.$slides.eq(s).attr({
        tabindex: '0'
      }) : e.$slides.eq(s).removeAttr('tabindex');
    }

    e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off('click.slick').on('click.slick', {
      message: 'previous'
    }, i.changeSlide), i.$nextArrow.off('click.slick').on('click.slick', {
      message: 'next'
    }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on('keydown.slick', i.keyHandler), i.$nextArrow.on('keydown.slick', i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;
    e.options.dots === !0 && e.slideCount > e.options.slidesToShow && (i('li', e.$dots).on('click.slick', {
      message: 'index'
    }, e.changeSlide), e.options.accessibility === !0 && e.$dots.on('keydown.slick', e.keyHandler)), e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.slideCount > e.options.slidesToShow && i('li', e.$dots).on('mouseenter.slick', i.proxy(e.interrupt, e, !0)).on('mouseleave.slick', i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;
    e.options.pauseOnHover && (e.$list.on('mouseenter.slick', i.proxy(e.interrupt, e, !0)), e.$list.on('mouseleave.slick', i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;
    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, e.swipeHandler), e.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, e.swipeHandler), e.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, e.swipeHandler), e.$list.on('click.slick', e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), e.options.accessibility === !0 && e.$list.on('keydown.slick', e.keyHandler), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), i(window).on('orientationchange.slick.slick-' + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on('resize.slick.slick-' + e.instanceUid, i.proxy(e.resize, e)), i('[draggable!=true]', e.$slideTrack).on('dragstart', e.preventDefault), i(window).on('load.slick.slick-' + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;
    i.target.tagName.match('TEXTAREA|INPUT|SELECT') || (37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'next' : 'previous'
      }
    }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
      data: {
        message: e.options.rtl === !0 ? 'previous' : 'next'
      }
    }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i('img[data-lazy]', e).each(function () {
        var e = i(this),
            t = i(this).attr('data-lazy'),
            o = i(this).attr('data-srcset'),
            s = i(this).attr('data-sizes') || r.$slider.attr('data-sizes'),
            n = document.createElement('img');
        n.onload = function () {
          e.animate({
            opacity: 0
          }, 100, function () {
            o && (e.attr('srcset', o), s && e.attr('sizes', s)), e.attr('src', t).animate({
              opacity: 1
            }, 200, function () {
              e.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            }), r.$slider.trigger('lazyLoaded', [r, e, t]);
          });
        }, n.onerror = function () {
          e.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), r.$slider.trigger('lazyLoadError', [r, e, t]);
        }, n.src = t;
      });
    }

    var t,
        o,
        s,
        n,
        r = this;
    if (r.options.centerMode === !0 ? r.options.infinite === !0 ? (s = r.currentSlide + (r.options.slidesToShow / 2 + 1), n = s + r.options.slidesToShow + 2) : (s = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), n = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide) : (s = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, n = Math.ceil(s + r.options.slidesToShow), r.options.fade === !0 && (s > 0 && s--, n <= r.slideCount && n++)), t = r.$slider.find('.slick-slide').slice(s, n), 'anticipated' === r.options.lazyLoad) for (var l = s - 1, d = n, a = r.$slider.find('.slick-slide'), c = 0; c < r.options.slidesToScroll; c++) {
      l < 0 && (l = r.slideCount - 1), t = t.add(a.eq(l)), t = t.add(a.eq(d)), l--, d++;
    }
    e(t), r.slideCount <= r.options.slidesToShow ? (o = r.$slider.find('.slick-slide'), e(o)) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? (o = r.$slider.find('.slick-cloned').slice(0, r.options.slidesToShow), e(o)) : 0 === r.currentSlide && (o = r.$slider.find('.slick-cloned').slice(r.options.slidesToShow * -1), e(o));
  }, e.prototype.loadSlider = function () {
    var i = this;
    i.setPosition(), i.$slideTrack.css({
      opacity: 1
    }), i.$slider.removeClass('slick-loading'), i.initUI(), 'progressive' === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'next'
      }
    });
  }, e.prototype.orientationChange = function () {
    var i = this;
    i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;
    i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;
    i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;

    if (!t.unslicked && (t.$slider.trigger('afterChange', [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && (t.initADA(), t.options.focusOnChange))) {
      var o = i(t.$slides.get(t.currentSlide));
      o.attr('tabindex', 0).focus();
    }
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    var i = this;
    i.changeSlide({
      data: {
        message: 'previous'
      }
    });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;
    var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i('img[data-lazy]', l.$slider);
    d.length ? (t = d.first(), o = t.attr('data-lazy'), s = t.attr('data-srcset'), n = t.attr('data-sizes') || l.$slider.attr('data-sizes'), r = document.createElement('img'), r.onload = function () {
      s && (t.attr('srcset', s), n && t.attr('sizes', n)), t.attr('src', o).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading'), l.options.adaptiveHeight === !0 && l.setPosition(), l.$slider.trigger('lazyLoaded', [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error'), l.$slider.trigger('lazyLoadError', [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger('allImagesLoaded', [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;
    o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
      currentSlide: t
    }), s.init(), e || s.changeSlide({
      data: {
        message: 'index',
        index: t
      }
    }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;

    if ('array' === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || 'window';

      for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }

          s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }

      s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;
    e.$slides = e.$slideTrack.children(e.options.slide).addClass('slick-slide'), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on('click.slick', e.selectHandler), e.setSlideClasses('number' == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger('reInit', [e]);
  }, e.prototype.resize = function () {
    var e = this;
    i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;
    return 'boolean' == typeof i ? (e = i, i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i, !(o.slideCount < 1 || i < 0 || i > o.slideCount - 1) && (o.unload(), t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, void o.reinit());
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};
    o.options.rtl === !0 && (i = -i), e = 'left' == o.positionProp ? Math.ceil(i) + 'px' : '0px', t = 'top' == o.positionProp ? Math.ceil(i) + 'px' : '0px', s[o.positionProp] = i, o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {}, o.cssTransitions === !1 ? (s[o.animType] = 'translate(' + e + ', ' + t + ')', o.$slideTrack.css(s)) : (s[o.animType] = 'translate3d(' + e + ', ' + t + ', 0px)', o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;
    i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
      padding: '0px ' + i.options.centerPadding
    }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
      padding: i.options.centerPadding + ' 0px'
    })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children('.slick-slide').length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children('.slick-slide').length)));
    var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
    i.options.variableWidth === !1 && i.$slideTrack.children('.slick-slide').width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;
    t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, t.options.rtl === !0 ? i(s).css({
        position: 'relative',
        right: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      }) : i(s).css({
        position: 'relative',
        left: e,
        top: 0,
        zIndex: t.options.zIndex - 2,
        opacity: 0
      });
    }), t.$slides.eq(t.currentSlide).css({
      zIndex: t.options.zIndex - 1,
      opacity: 1
    });
  }, e.prototype.setHeight = function () {
    var i = this;

    if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
      i.$list.css('height', e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
    if ('object' === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = 'multiple') : 'string' === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], 'responsive' === arguments[0] && 'array' === i.type(arguments[1]) ? n = 'responsive' : 'undefined' != typeof arguments[1] && (n = 'single')), 'single' === n) r.options[o] = s;else if ('multiple' === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ('responsive' === n) for (t in s) {
      if ('array' !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }

        r.options.responsive.push(s[t]);
      }
    }
    l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;
    i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger('setPosition', [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;
    i.positionProp = i.options.vertical === !0 ? 'top' : 'left', 'top' === i.positionProp ? i.$slider.addClass('slick-vertical') : i.$slider.removeClass('slick-vertical'), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && ('number' == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = 'OTransform', i.transformType = '-o-transform', i.transitionType = 'OTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = 'MozTransform', i.transformType = '-moz-transform', i.transitionType = 'MozTransition', void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = 'webkitTransform', i.transformType = '-webkit-transform', i.transitionType = 'webkitTransition', void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = 'msTransform', i.transformType = '-ms-transform', i.transitionType = 'msTransition', void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && i.animType !== !1 && (i.animType = 'transform', i.transformType = 'transform', i.transitionType = 'transition'), i.transformsEnabled = i.options.useTransform && null !== i.animType && i.animType !== !1;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;

    if (t = n.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true'), n.$slides.eq(i).addClass('slick-current'), n.options.centerMode === !0) {
      var r = n.options.slidesToShow % 2 === 0 ? 1 : 0;
      e = Math.floor(n.options.slidesToShow / 2), n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass('slick-active').attr('aria-hidden', 'false') : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass('slick-active').attr('aria-hidden', 'false')), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass('slick-center') : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass('slick-center')), n.$slides.eq(i).addClass('slick-center');
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false') : t.length <= n.options.slidesToShow ? t.addClass('slick-active').attr('aria-hidden', 'false') : (s = n.slideCount % n.options.slidesToShow, o = n.options.infinite === !0 ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass('slick-active').attr('aria-hidden', 'false') : t.slice(o, o + n.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false'));

    'ondemand' !== n.options.lazyLoad && 'anticipated' !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;

    if (s.options.fade === !0 && (s.options.centerMode = !1), s.options.infinite === !0 && s.options.fade === !1 && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t - s.slideCount).prependTo(s.$slideTrack).addClass('slick-cloned');
      }

      for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr('id', '').attr('data-slick-index', t + s.slideCount).appendTo(s.$slideTrack).addClass('slick-cloned');
      }

      s.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
        i(this).attr('id', '');
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;
    i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is('.slick-slide') ? i(e.target) : i(e.target).parents('.slick-slide'),
        s = parseInt(o.attr('data-slick-index'));
    return s || (s = 0), t.slideCount <= t.options.slidesToShow ? void t.slideHandler(s, !1, !0) : void t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
    if (e = e || !1, !(a.animating === !0 && a.options.waitForAnimate === !0 || a.options.fade === !0 && a.currentSlide === i)) return e === !1 && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, a.options.infinite === !1 && a.options.centerMode === !1 && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : a.options.infinite === !1 && a.options.centerMode === !0 && (i < 0 || i > a.slideCount - a.options.slidesToScroll) ? void (a.options.fade === !1 && (o = a.currentSlide, t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o))) : (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll !== 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll !== 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger('beforeChange', [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = a.getNavTarget(), l = l.slick('getSlick'), l.slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide)), a.updateDots(), a.updateArrows(), a.options.fade === !0 ? (t !== !0 ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
      a.postSlide(s);
    })) : a.postSlide(s), void a.animateHeight()) : void (t !== !0 && a.slideCount > a.options.slidesToShow ? a.animateSlide(d, function () {
      a.postSlide(s);
    }) : a.postSlide(s)));
  }, e.prototype.startLoad = function () {
    var i = this;
    i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass('slick-loading');
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;
    return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), o = Math.round(180 * t / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? s.options.rtl === !1 ? 'left' : 'right' : o <= 360 && o >= 315 ? s.options.rtl === !1 ? 'left' : 'right' : o >= 135 && o <= 225 ? s.options.rtl === !1 ? 'right' : 'left' : s.options.verticalSwiping === !0 ? o >= 35 && o <= 135 ? 'down' : 'up' : 'vertical';
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;
    if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
    if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;

    if (o.touchObject.edgeHit === !0 && o.$slider.trigger('edge', [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {
        case 'left':
        case 'down':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
          break;

        case 'right':
        case 'up':
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;
      }

      'vertical' != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger('swipe', [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;
    if (!(e.options.swipe === !1 || 'ontouchend' in document && e.options.swipe === !1 || e.options.draggable === !1 && i.type.indexOf('mouse') !== -1)) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, e.options.verticalSwiping === !0 && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
      case 'start':
        e.swipeStart(i);
        break;

      case 'move':
        e.swipeMove(i);
        break;

      case 'end':
        e.swipeEnd(i);
    }
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;
    return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (l.options.verticalSwiping === !0 && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), l.options.verticalSwiping === !0 && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, l.options.infinite === !1 && (0 === l.currentSlide && 'right' === t || l.currentSlide >= l.getDotCount() && 'left' === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, l.options.verticalSwiping === !0 && (l.swipeLeft = e + o * s), l.options.fade !== !0 && l.options.touchMove !== !1 && (l.animating === !0 ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;
    return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {}, !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void (t.dragging = !0));
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;
    null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;
    i('.slick-cloned', e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  }, e.prototype.unslick = function (i) {
    var e = this;
    e.$slider.trigger('unslick', [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i,
        e = this;
    i = Math.floor(e.options.slidesToShow / 2), e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false'), 0 === e.currentSlide ? (e.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true'), e.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false')));
  }, e.prototype.updateDots = function () {
    var i = this;
    null !== i.$dots && (i.$dots.find('li').removeClass('slick-active').end(), i.$dots.find('li').eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass('slick-active'));
  }, e.prototype.visibility = function () {
    var i = this;
    i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;

    for (i = 0; i < r; i++) {
      if ('object' == _typeof(s) || 'undefined' == typeof s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), 'undefined' != typeof t) return t;
    }

    return o;
  };
});
/*
 * Mobile hover plugin
 */


(function ($) {
  var doc = jQuery(document); // detect device type

  var isTouchDevice = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
      isWinPhoneDevice = /Windows Phone/.test(navigator.userAgent); // define events

  var eventOn = isTouchDevice && 'touchstart' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerdown' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerDown' || 'mouseenter',
      eventOff = isTouchDevice && 'touchend' || isWinPhoneDevice && navigator.pointerEnabled && 'pointerup' || isWinPhoneDevice && navigator.msPointerEnabled && 'MSPointerUp' || 'mouseleave';
  isTouchDevice = /Windows Phone/.test(navigator.userAgent) || 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

  function toggleClass(opt, e) {
    var el = jQuery(e.currentTarget);

    if (!isTouchDevice) {
      el.one(eventOff, function () {
        jQuery(this).removeClass(opt.hoverClass);
      });
    } else {
      if (!el.hasClass(opt.hoverClass)) {
        jQuery(this).off('click.hover', function (e) {
          e.preventDefault();
        });
        setTimeout(function () {
          doc.on(eventOn + '.hover', function (e) {
            var target = jQuery(e.target);

            if (!target.is(el) && !target.closest(el).length) {
              el.removeClass(opt.hoverClass);
              jQuery(this).off('click.hover');
              doc.off(eventOn + '.hover');
            }
          });
        });
      }
    }

    if (!el.hasClass(opt.hoverClass)) {
      if (e) e.preventDefault();
      el.addClass(opt.hoverClass);
    }
  } // jQuery plugin


  $.fn.touchHover = function (opt) {
    var options = $.extend({
      hoverClass: 'hover'
    }, opt);
    this.on(eventOn, toggleClass.bind(this, options));
    return this;
  };
})(jQuery);
/*
 * Add class plugin
 */


jQuery.fn.clickClass = function (opt) {
  var options = jQuery.extend({
    classAdd: 'add-class',
    addToParent: false,
    event: 'click'
  }, opt);
  return this.each(function () {
    var classItem = jQuery(this);

    if (options.addToParent) {
      if (typeof options.addToParent === 'boolean') {
        classItem = classItem.parent();
      } else {
        classItem = classItem.parents('.' + options.addToParent);
      }
    }

    jQuery(this).bind(options.event, function (e) {
      classItem.toggleClass(options.classAdd);
      e.preventDefault();
    });
  });
};
/*
 * jQuery sticky box plugin
 */


(function ($, $win) {
  'use strict';

  function StickyScrollBlock($stickyBox, options) {
    this.options = options;
    this.$stickyBox = $stickyBox;
    this.init();
  }

  var StickyScrollBlockPrototype = {
    init: function init() {
      this.findElements();
      this.attachEvents();
      this.makeCallback('onInit');
    },
    findElements: function findElements() {
      // find parent container in which will be box move
      this.$container = this.$stickyBox.closest(this.options.container); // define box wrap flag

      this.isWrap = this.options.positionType === 'fixed' && this.options.setBoxHeight; // define box move flag

      this.moveInContainer = !!this.$container.length; // wrapping box to set place in content

      if (this.isWrap) {
        this.$stickyBoxWrap = this.$stickyBox.wrap('<div class="' + this.getWrapClass() + '"/>').parent();
      } //define block to add active class


      this.parentForActive = this.getParentForActive();
      this.isInit = true;
    },
    attachEvents: function attachEvents() {
      var self = this; // bind events

      this.onResize = function () {
        if (!self.isInit) return;
        self.resetState();
        self.recalculateOffsets();
        self.checkStickyPermission();
        self.scrollHandler();
      };

      this.onScroll = function () {
        self.scrollHandler();
      }; // initial handler call


      this.onResize(); // handle events

      $win.on('load resize orientationchange', this.onResize).on('scroll', this.onScroll);
    },
    defineExtraTop: function defineExtraTop() {
      // define box's extra top dimension
      var extraTop;

      if (typeof this.options.extraTop === 'number') {
        extraTop = this.options.extraTop;
      } else if (typeof this.options.extraTop === 'function') {
        extraTop = this.options.extraTop();
      }

      this.extraTop = this.options.positionType === 'absolute' ? extraTop : Math.min(this.winParams.height - this.data.boxFullHeight, extraTop);
    },
    checkStickyPermission: function checkStickyPermission() {
      // check the permission to set sticky
      this.isStickyEnabled = this.moveInContainer ? this.data.containerOffsetTop + this.data.containerHeight > this.data.boxFullHeight + this.data.boxOffsetTop + this.options.extraBottom : true;
    },
    getParentForActive: function getParentForActive() {
      if (this.isWrap) {
        return this.$stickyBoxWrap;
      }

      if (this.$container.length) {
        return this.$container;
      }

      return this.$stickyBox;
    },
    getWrapClass: function getWrapClass() {
      // get set of container classes
      try {
        return this.$stickyBox.attr('class').split(' ').map(function (name) {
          return 'sticky-wrap-' + name;
        }).join(' ');
      } catch (err) {
        return 'sticky-wrap';
      }
    },
    resetState: function resetState() {
      // reset dimensions and state
      this.stickyFlag = false;
      this.$stickyBox.css({
        '-webkit-transition': '',
        '-webkit-transform': '',
        transition: '',
        transform: '',
        position: '',
        width: '',
        left: '',
        top: ''
      }).removeClass(this.options.activeClass);

      if (this.isWrap) {
        this.$stickyBoxWrap.removeClass(this.options.activeClass).removeAttr('style');
      }

      if (this.moveInContainer) {
        this.$container.removeClass(this.options.activeClass);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      // define box and container dimensions
      this.winParams = this.getWindowParams();
      this.data = $.extend(this.getBoxOffsets(), this.getContainerOffsets());
      this.defineExtraTop();
    },
    getBoxOffsets: function getBoxOffsets() {
      var boxOffset = this.$stickyBox.offset();
      var boxPosition = this.$stickyBox.position();
      return {
        // sticky box offsets
        boxOffsetLeft: boxOffset.left,
        boxOffsetTop: boxOffset.top,
        // sticky box positions
        boxTopPosition: boxPosition.top,
        boxLeftPosition: boxPosition.left,
        // sticky box width/height
        boxFullHeight: this.$stickyBox.outerHeight(true),
        boxHeight: this.$stickyBox.outerHeight(),
        boxWidth: this.$stickyBox.outerWidth()
      };
    },
    getContainerOffsets: function getContainerOffsets() {
      var containerOffset = this.moveInContainer ? this.$container.offset() : null;
      return containerOffset ? {
        // container offsets
        containerOffsetLeft: containerOffset.left,
        containerOffsetTop: containerOffset.top,
        // container height
        containerHeight: this.$container.outerHeight()
      } : {};
    },
    getWindowParams: function getWindowParams() {
      return {
        height: window.innerHeight || document.documentElement.clientHeight
      };
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      this.isInit = false; // remove event handlers and styles

      $win.off('load resize orientationchange', this.onResize).off('scroll', this.onScroll);
      this.resetState();
      this.$stickyBox.removeData('StickyScrollBlock');

      if (this.isWrap) {
        this.$stickyBox.unwrap();
      }

      this.makeCallback('onDestroy');
    }
  };
  var stickyMethods = {
    fixed: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop - (this.options.showAfterScrolled ? this.extraTop : 0) - (this.options.showAfterScrolled ? this.data.boxHeight + this.extraTop : 0) > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            position: this.options.positionType
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.setDynamicPosition();
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.stickyFlag = false;
          this.resetState();
          this.makeCallback('fixedOff');
        }
      },
      setDynamicPosition: function setDynamicPosition() {
        this.$stickyBox.css({
          top: this.getTopPosition(),
          left: this.data.boxOffsetLeft - $win.scrollLeft()
        });
      },
      getTopPosition: function getTopPosition() {
        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          return Math.min(this.extraTop, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop);
        } else {
          return this.extraTop;
        }
      }
    },
    absolute: {
      scrollHandler: function scrollHandler() {
        this.winScrollTop = $win.scrollTop();
        var isActiveSticky = this.winScrollTop > this.data.boxOffsetTop - this.extraTop;

        if (isActiveSticky) {
          this.isStickyEnabled && this.stickyOn();
        } else {
          this.stickyOff();
        }
      },
      stickyOn: function stickyOn() {
        if (!this.stickyFlag) {
          this.stickyFlag = true;
          this.parentForActive.addClass(this.options.activeClass);
          this.$stickyBox.css({
            width: this.data.boxWidth,
            transition: 'transform ' + this.options.animSpeed + 's ease',
            '-webkit-transition': 'transform ' + this.options.animSpeed + 's ease'
          });

          if (this.isWrap) {
            this.$stickyBoxWrap.css({
              height: this.data.boxFullHeight
            });
          }

          this.makeCallback('fixedOn');
        }

        this.clearTimer();
        this.timer = setTimeout(function () {
          this.setDynamicPosition();
        }.bind(this), this.options.animDelay * 1000);
      },
      stickyOff: function stickyOff() {
        if (this.stickyFlag) {
          this.clearTimer();
          this.stickyFlag = false;
          this.timer = setTimeout(function () {
            this.setDynamicPosition();
            setTimeout(function () {
              this.resetState();
            }.bind(this), this.options.animSpeed * 1000);
          }.bind(this), this.options.animDelay * 1000);
          this.makeCallback('fixedOff');
        }
      },
      clearTimer: function clearTimer() {
        clearTimeout(this.timer);
      },
      setDynamicPosition: function setDynamicPosition() {
        var topPosition = Math.max(0, this.getTopPosition());
        this.$stickyBox.css({
          transform: 'translateY(' + topPosition + 'px)',
          '-webkit-transform': 'translateY(' + topPosition + 'px)'
        });
      },
      getTopPosition: function getTopPosition() {
        var currTopPosition = this.winScrollTop - this.data.boxOffsetTop + this.extraTop;

        if (this.moveInContainer) {
          var currScrollTop = this.winScrollTop + this.data.boxHeight + this.options.extraBottom;
          var diffOffset = Math.abs(Math.min(0, this.data.containerHeight + this.data.containerOffsetTop - currScrollTop - this.extraTop));
          return currTopPosition - diffOffset;
        } else {
          return currTopPosition;
        }
      }
    }
  }; // jQuery plugin interface

  $.fn.stickyScrollBlock = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];
    var options = $.extend({
      container: null,
      positionType: 'fixed',
      // 'fixed' or 'absolute'
      activeClass: 'fixed-position',
      setBoxHeight: true,
      showAfterScrolled: false,
      extraTop: 0,
      extraBottom: 0,
      animDelay: 0.1,
      animSpeed: 0.2
    }, opt);
    return this.each(function () {
      var $stickyBox = jQuery(this);
      var instance = $stickyBox.data('StickyScrollBlock');

      if (_typeof(opt) === 'object' || typeof opt === 'undefined') {
        StickyScrollBlock.prototype = $.extend(stickyMethods[options.positionType], StickyScrollBlockPrototype);
        $stickyBox.data('StickyScrollBlock', new StickyScrollBlock($stickyBox, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  }; // module exports


  window.StickyScrollBlock = StickyScrollBlock;
})(jQuery, jQuery(window));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./components/row-hover-helper":11,"./components/slick-with-indicator":12,"./components/youtube-deferred":13,"./jquery-plugins/jquery-serialshuffle.js":14,"impv-support/src/js/components/smooth-scroll":16,"impv/src/js/components/stycky-pagination.js":19}],16:[function(require,module,exports){
"use strict";

/*
 * SmoothScroll module
 */
(function ($, exports) {
  // private variables
  var page,
      win = $(window),
      activeBlock,
      _activeWheelHandler,
      wheelEvents = 'onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel DOMMouseScroll'; // animation handlers


  function _scrollTo(offset, options, callback) {
    // initialize variables
    var scrollBlock;

    if (document.body) {
      if (typeof options === 'number') {
        options = {
          duration: options
        };
      } else {
        options = options || {};
      }

      page = page || $('html, body');
      scrollBlock = options.container || page;
    } else {
      return;
    } // treat single number as scrollTop


    if (typeof offset === 'number') {
      offset = {
        top: offset
      };
    } // handle mousewheel/trackpad while animation is active


    if (activeBlock && _activeWheelHandler) {
      activeBlock.off(wheelEvents, _activeWheelHandler);
    }

    if (options.wheelBehavior && options.wheelBehavior !== 'none') {
      _activeWheelHandler = function activeWheelHandler(e) {
        if (options.wheelBehavior === 'stop') {
          scrollBlock.off(wheelEvents, _activeWheelHandler);
          scrollBlock.stop();
        } else if (options.wheelBehavior === 'ignore') {
          e.preventDefault();
        }
      };

      activeBlock = scrollBlock.on(wheelEvents, _activeWheelHandler);
    } // start scrolling animation


    scrollBlock.stop().animate({
      scrollLeft: offset.left,
      scrollTop: offset.top
    }, options.duration, function () {
      if (_activeWheelHandler) {
        scrollBlock.off(wheelEvents, _activeWheelHandler);
      }

      if ($.isFunction(callback)) {
        callback();
      }
    });
  } // smooth scroll contstructor


  function SmoothScroll(options) {
    this.options = $.extend({
      anchorLinks: 'a[href^="#"]',
      // selector or jQuery object
      container: null,
      // specify container for scrolling (default - whole page)
      extraOffset: null,
      // function or fixed number
      activeClasses: null,
      // null, "link", "parent"
      easing: 'swing',
      // easing of scrolling
      animMode: 'duration',
      // or "speed" mode
      animDuration: 800,
      // total duration for scroll (any distance)
      animSpeed: 1500,
      // pixels per second
      anchorActiveClass: 'anchor-active',
      sectionActiveClass: 'section-active',
      wheelBehavior: 'stop',
      // "stop", "ignore" or "none"
      useNativeAnchorScrolling: false // do not handle click in devices with native smooth scrolling

    }, options);
    this.init();
  }

  SmoothScroll.prototype = {
    init: function init() {
      this.initStructure();
      this.attachEvents();
      this.isInit = true;
    },
    initStructure: function initStructure() {
      var self = this;
      this.container = this.options.container ? $(this.options.container) : $('html,body');
      this.scrollContainer = this.options.container ? this.container : win;
      this.anchorLinks = jQuery(this.options.anchorLinks).filter(function () {
        return jQuery(self.getAnchorTarget(jQuery(this))).length;
      });
    },
    getId: function getId(str) {
      try {
        return '#' + str.replace(/^.*?(#|$)/, '');
      } catch (err) {
        return null;
      }
    },
    getAnchorTarget: function getAnchorTarget(link) {
      // get target block from link href
      var targetId = this.getId($(link).attr('href'));
      return $(targetId.length > 1 ? targetId : 'html');
    },
    getTargetOffset: function getTargetOffset(block) {
      // get target offset
      var blockOffset = block.offset().top;

      if (this.options.container) {
        blockOffset -= this.container.offset().top - this.container.prop('scrollTop');
      } // handle extra offset


      if (typeof this.options.extraOffset === 'number') {
        blockOffset -= this.options.extraOffset;
      } else if (typeof this.options.extraOffset === 'function') {
        blockOffset -= this.options.extraOffset(block);
      }

      return {
        top: blockOffset
      };
    },
    attachEvents: function attachEvents() {
      var self = this; // handle active classes

      if (this.options.activeClasses && this.anchorLinks.length) {
        // cache structure
        this.anchorData = [];

        for (var i = 0; i < this.anchorLinks.length; i++) {
          var link = jQuery(this.anchorLinks[i]),
              targetBlock = self.getAnchorTarget(link),
              anchorDataItem = null;
          $.each(self.anchorData, function (index, item) {
            if (item.block[0] === targetBlock[0]) {
              anchorDataItem = item;
            }
          });

          if (anchorDataItem) {
            anchorDataItem.link = anchorDataItem.link.add(link);
          } else {
            self.anchorData.push({
              link: link,
              block: targetBlock
            });
          }
        } // add additional event handlers


        this.resizeHandler = function () {
          if (!self.isInit) return;
          self.recalculateOffsets();
        };

        this.scrollHandler = function () {
          self.refreshActiveClass();
        };

        this.recalculateOffsets();
        this.scrollContainer.on('scroll', this.scrollHandler);
        win.on('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
      } // handle click event


      this.clickHandler = function (e) {
        self.onClick(e);
      };

      if (!this.options.useNativeAnchorScrolling) {
        this.anchorLinks.on('click', this.clickHandler);
      }
    },
    recalculateOffsets: function recalculateOffsets() {
      var self = this;
      $.each(this.anchorData, function (index, data) {
        data.offset = self.getTargetOffset(data.block);
        data.height = data.block.outerHeight();
      });
      this.refreshActiveClass();
    },
    toggleActiveClass: function toggleActiveClass(anchor, block, state) {
      anchor.toggleClass(this.options.anchorActiveClass, state);
      block.toggleClass(this.options.sectionActiveClass, state);
    },
    refreshActiveClass: function refreshActiveClass() {
      var self = this,
          foundFlag = false,
          containerHeight = this.container.prop('scrollHeight'),
          viewPortHeight = this.scrollContainer.height(),
          scrollTop = this.options.container ? this.container.prop('scrollTop') : win.scrollTop(); // user function instead of default handler

      if (this.options.customScrollHandler) {
        this.options.customScrollHandler.call(this, scrollTop, this.anchorData);
        return;
      } // sort anchor data by offsets


      this.anchorData.sort(function (a, b) {
        return a.offset.top - b.offset.top;
      }); // default active class handler

      $.each(this.anchorData, function (index) {
        var reverseIndex = self.anchorData.length - index - 1,
            data = self.anchorData[reverseIndex],
            anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link;

        if (scrollTop >= containerHeight - viewPortHeight) {
          // handle last section
          if (reverseIndex === self.anchorData.length - 1) {
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        } else {
          // handle other sections
          if (!foundFlag && (scrollTop >= data.offset.top - 1 || reverseIndex === 0)) {
            foundFlag = true;
            self.toggleActiveClass(anchorElement, data.block, true);
          } else {
            self.toggleActiveClass(anchorElement, data.block, false);
          }
        }
      });
    },
    calculateScrollDuration: function calculateScrollDuration(offset) {
      var distance;

      if (this.options.animMode === 'speed') {
        distance = Math.abs(this.scrollContainer.scrollTop() - offset.top);
        return distance / this.options.animSpeed * 1000;
      } else {
        return this.options.animDuration;
      }
    },
    onClick: function onClick(e) {
      var targetBlock = this.getAnchorTarget(e.currentTarget),
          targetOffset = this.getTargetOffset(targetBlock);
      e.preventDefault();

      _scrollTo(targetOffset, {
        container: this.container,
        wheelBehavior: this.options.wheelBehavior,
        duration: this.calculateScrollDuration(targetOffset)
      });

      this.makeCallback('onBeforeScroll', e.currentTarget);
    },
    makeCallback: function makeCallback(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function destroy() {
      var self = this;
      this.isInit = false;

      if (this.options.activeClasses) {
        win.off('resize.SmoothScroll load.SmoothScroll orientationchange.SmoothScroll refreshAnchor.SmoothScroll', this.resizeHandler);
        this.scrollContainer.off('scroll', this.scrollHandler);
        $.each(this.anchorData, function (index) {
          var reverseIndex = self.anchorData.length - index - 1,
              data = self.anchorData[reverseIndex],
              anchorElement = self.options.activeClasses === 'parent' ? data.link.parent() : data.link;
          self.toggleActiveClass(anchorElement, data.block, false);
        });
      }

      this.anchorLinks.off('click', this.clickHandler);
    }
  }; // public API

  $.extend(SmoothScroll, {
    scrollTo: function scrollTo(blockOrOffset, durationOrOptions, callback) {
      _scrollTo(blockOrOffset, durationOrOptions, callback);
    }
  }); // export module

  exports.SmoothScroll = SmoothScroll;
})(jQuery, window);

},{}],17:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = require("events");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// auto focus on key press
var runOnce = 'impv_dropdown_auto_focus';

if (!(runOnce in window)) {
  $(function (_) {
    window[runOnce] = true;

    jQuery.expr[':'].startwith = function (a, i, m) {
      return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) == 0;
    };

    var timeout = null;
    var selectText = '';

    function clearSelect() {
      selectText = '';
    }

    $(document).on('keydown', '.impv-dropdown', function (event) {
      clearTimeout(timeout);
      /** clear the selected text after 1 sec */

      timeout = setTimeout(clearSelect, 1000);
      var container = $(event.currentTarget);

      var _char = String.fromCharCode(event.keyCode);

      selectText += _char;
      var selector = ".dropdown-item:visible:startwith('".concat(selectText, "')");
      $(selector, container).first().focus();
    });
  });
}

var DropDownSelect =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(DropDownSelect, _EventEmitter);

  _createClass(DropDownSelect, null, [{
    key: "register",
    value: function register(selector) {
      // register once
      if (global.DROP_DOWN_SLECT_GUARD_RUN_ONCE) {
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }

      selector = selector || '.dropdown.dropdown-select';

      if ($(selector).length > 0) {
        global.DROP_DOWN_SLECT_GUARD_RUN_ONCE = new DropDownSelect();
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }
    }
  }]);

  function DropDownSelect() {
    var _this;

    _classCallCheck(this, DropDownSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropDownSelect).call(this));

    _this.init();

    return _this;
  }

  _createClass(DropDownSelect, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      $('.impv-dropdown .dropdown-select-btn').on('click', function (e) {
        if ($(e.currentTarget).hasClass('no-options')) {
          e.preventDefault();
        } else {
          var currentBtn$ = $(e.currentTarget);
          var menuId = currentBtn$.attr('id');
          var value = currentBtn$.attr('data-value');

          if ($(document).width() <= 767) {
            setTimeout(function () {
              e.currentTarget.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
              });
            }, 10);
          }

          _this2.hideSelectedItem(menuId, value);
        }
      });
      $('.impv-dropdown .dropdown-item:not(.prev-def)').on('click', function (e) {
        e.preventDefault();
        var item$ = $(e.currentTarget);
        var parent$ = item$.parents('.dropdown-select');
        parent$.find('.dropdown-select-btn').attr('data-value', item$.attr('data-value')).attr('data-source', item$.attr('data-source')).find('.name').text(item$.text());
        parent$.trigger('select_changed', {
          parent$: parent$,
          item$: item$
        });

        _this2.emit('select_changed', parent$, item$);
      });
    }
  }, {
    key: "hideSelectedItem",
    value: function hideSelectedItem(menuId, value) {
      $(".impv-dropdown .dropdown-menu[aria-labelledby=\"".concat(menuId, "\"] .dropdown-item")).each(function (_, e) {
        e = $(e);

        if (e.attr('data-value') == value || e.hasClass('filtered')) {
          e.hide();
        } else {
          e.show();
        }
      });
    }
  }, {
    key: "chooseItem",
    value: function chooseItem(parentElem, dataSource) {
      $('.' + parentElem + ' .dropdown-item[data-source="' + dataSource + '"]').click();
    }
  }]);

  return DropDownSelect;
}(_events.EventEmitter);

exports["default"] = DropDownSelect;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"events":1}],18:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findById = exports.createForm = exports["default"] = void 0;

var _geoLocationService = require("impv/src/js/services/geo-location-service");

var _translateService = require("impv/src/js/services/translate-service");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isoCountries = {
  af: 'afghanistan',
  ax: 'aland islands',
  al: 'albania',
  dz: 'algeria',
  as: 'american samoa',
  ad: 'andorra',
  ao: 'angola',
  ai: 'anguilla',
  aq: 'antarctica',
  ag: 'antigua and barbuda',
  ar: 'argentina',
  am: 'armenia',
  aw: 'aruba',
  asc: 'ascension island',
  au: 'australia',
  at: 'austria',
  az: 'azerbaijan',
  bs: 'bahamas',
  bh: 'bahrain',
  bd: 'bangladesh',
  bb: 'barbados',
  by: 'belarus',
  be: 'belgium',
  bz: 'belize',
  bj: 'benin',
  bm: 'bermuda',
  bt: 'bhutan',
  bo: 'bolivia',
  bq: 'bonaire',
  ba: 'bosnia and herzegovina',
  bw: 'botswana',
  bv: 'bouvet island',
  br: 'brazil',
  io: 'british indian ocean territory',
  bn: 'brunei darussalam',
  bg: 'bulgaria',
  bf: 'burkina faso',
  bi: 'burundi',
  kh: 'cambodia',
  cm: 'cameroon',
  ca: 'canada',
  cv: 'cape verde',
  ky: 'cayman islands',
  cf: 'central african republic',
  td: 'chad',
  cl: 'chile',
  cn: 'china',
  cx: 'christmas island',
  cc: 'cocos (keeling) islands',
  co: 'colombia',
  km: 'comoros',
  cg: 'congo',
  cd: 'congo, dem. rep. of the',
  ck: 'cook islands',
  cr: 'costa rica',
  ci: 'ivory coast',
  hr: 'croatia',
  cu: 'cuba',
  cuw: 'curacao',
  cy: 'cyprus',
  cz: 'czech republic',
  dk: 'denmark',
  dj: 'djibouti',
  dm: 'dominica',
  "do": 'dominican republic',
  ec: 'ecuador',
  eg: 'egypt',
  sv: 'el salvador',
  gq: 'equatorial guinea',
  er: 'eritrea',
  ee: 'estonia',
  et: 'ethiopia',
  fk: 'falkland islands (malvinas)',
  fo: 'faroe islands',
  fj: 'fiji',
  fi: 'finland',
  fr: 'france',
  gf: 'french guiana',
  pf: 'french polynesia',
  tf: 'french southern territories',
  ga: 'gabon',
  gm: 'gambia',
  ge: 'georgia',
  de: 'germany',
  gh: 'ghana',
  gi: 'gibraltar',
  gr: 'greece',
  gl: 'greenland',
  gd: 'grenada',
  gp: 'guadeloupe',
  gu: 'guam',
  gt: 'guatemala',
  gg: 'guernsey',
  gn: 'guinea',
  gw: 'guinea-bissau',
  gy: 'guyana',
  ht: 'haiti',
  hm: 'heard island & mcdonald islands',
  va: 'holy see (vatican city state)',
  hn: 'honduras',
  hk: 'hong kong',
  hu: 'hungary',
  is: 'iceland',
  "in": 'india',
  id: 'indonesia',
  ir: 'iran, islamic republic of',
  iq: 'iraq',
  ie: 'ireland',
  im: 'isle of man',
  il: 'israel',
  it: 'italy',
  jm: 'jamaica',
  jp: 'japan',
  je: 'jersey',
  jo: 'jordan',
  kz: 'kazakhstan',
  ke: 'kenya',
  ki: 'kiribati',
  xk: 'kosovo',
  kw: 'kuwait',
  kg: 'kyrgyzstan',
  la: 'lao',
  lv: 'latvia',
  lb: 'lebanon',
  ls: 'lesotho',
  lr: 'liberia',
  ly: 'libyan arab jamahiriya',
  li: 'liechtenstein',
  lt: 'lithuania',
  lu: 'luxembourg',
  mo: 'macao',
  mk: 'macedonia',
  mg: 'madagascar',
  mw: 'malawi',
  my: 'malaysia',
  mv: 'maldives',
  ml: 'mali',
  mt: 'malta',
  mh: 'marshall islands',
  mq: 'martinique',
  mr: 'mauritania',
  mu: 'mauritius',
  yt: 'mayotte',
  mx: 'mexico',
  fm: 'micronesia, federated states of',
  md: 'moldova',
  mc: 'monaco',
  mn: 'mongolia',
  me: 'montenegro',
  ms: 'montserrat',
  ma: 'morocco',
  mz: 'mozambique',
  mm: 'myanmar',
  na: 'namibia',
  nr: 'nauru',
  np: 'nepal',
  nl: 'netherlands',
  an: 'netherlands antilles',
  nc: 'new caledonia',
  nz: 'new zealand',
  ni: 'nicaragua',
  ne: 'niger',
  ng: 'nigeria',
  nu: 'niue',
  nf: 'norfolk island',
  kr: 'north norea',
  mp: 'northern mariana islands',
  no: 'norway',
  om: 'oman',
  pk: 'pakistan',
  pw: 'palau',
  ps: 'palestinian territory',
  pa: 'panama',
  pg: 'papua new guinea',
  py: 'paraguay',
  pe: 'peru',
  ph: 'philippines',
  pn: 'pitcairn',
  pl: 'poland',
  pt: 'portugal',
  pr: 'puerto rico',
  qa: 'qatar',
  re: 'reunion',
  ro: 'romania',
  ru: 'russian federation',
  rw: 'rwanda',
  bl: 'saint barthelemy',
  sh: 'saint helena',
  kn: 'saint kitts and nevis',
  lc: 'saint lucia',
  mf: 'saint martin',
  pm: 'saint pierre and miquelon',
  vc: 'saint vincent and grenadines',
  ws: 'samoa',
  sm: 'san marino',
  st: 'sao tome and principe',
  sa: 'saudi arabia',
  sn: 'senegal',
  rs: 'serbia',
  sc: 'seychelles',
  sl: 'sierra leone',
  sg: 'singapore',
  sx: 'sint maartin (dutch part)',
  sk: 'slovakia',
  si: 'slovenia',
  sb: 'solomon islands',
  so: 'somalia',
  za: 'south africa',
  gs: 'south georgia and sandwich islands',
  kp: 'south korea',
  sd: 'sudan',
  es: 'spain',
  lk: 'sri lanka',
  sr: 'suriname',
  sj: 'svalbard and jan mayen',
  sz: 'swaziland',
  se: 'sweden',
  ch: 'switzerland',
  sy: 'syrian arab republic',
  tw: 'taiwan',
  tj: 'tajikistan',
  tz: 'tanzania',
  th: 'thailand',
  tl: 'timor-leste',
  tg: 'togo',
  tk: 'tokelau',
  to: 'tonga',
  tt: 'trinidad and tobago',
  tn: 'tunisia',
  tr: 'turkey',
  tm: 'turkmenistan',
  tc: 'turks and caicos islands',
  tv: 'tuvalu',
  ug: 'uganda',
  ua: 'ukraine',
  ae: 'united arab emirates',
  gb: 'united kingdom',
  us: 'united states',
  um: 'united states minor outlying islands',
  uy: 'uruguay',
  uz: 'uzbekistan',
  vu: 'vanuatu',
  ve: 'venezuela',
  vn: 'vietnam',
  vg: 'virgin islands, british',
  vi: 'virgin islands, u.s.',
  wf: 'wallis and futuna',
  eh: 'western sahara',
  ye: 'yemen',
  zm: 'zambia',
  zw: 'zimbabwe'
};
var emails = ['gamil.com', 'gmail.co', 'gmail.org', 'gmail.com', 'aol.com', 'att.net', 'comcast.net', 'facebook.com', 'gmx.com', 'googlemail.com', 'google.com', 'hotmail.com', 'hotmail.co.uk', 'mac.com', 'me.com', 'mail.com', 'msn.com', 'live.com', 'sbcglobal.net', 'verizon.net', 'yahoo.com', 'yahoo.co.uk', 'email.com', 'fastmail.fm', 'games.com ', 'gmx.net', 'hush.com', 'hushmail.com', 'icloud.com', 'iname.com', 'inbox.com', 'lavabit.com', 'love.com ', 'outlook.com', 'pobox.com', 'protonmail.ch', 'protonmail.com', 'tutanota.de', 'tutanota.com', 'tutamail.com', 'tuta.io', 'keemail.me', 'rocketmail.com ', 'safe-mail.net', 'wow.com ', 'ygm.com ', 'ymail.com ', 'zoho.com', 'yandex.com', 'bellsouth.net', 'charter.net', 'cox.net', 'earthlink.net', 'juno.com', 'btinternet.com', 'virginmedia.com', 'blueyonder.co.uk', 'freeserve.co.uk', 'live.co.uk', 'ntlworld.com', 'o2.co.uk', 'orange.net', 'sky.com', 'talktalk.co.uk', 'tiscali.co.uk', 'virgin.net', 'wanadoo.co.uk', 'bt.com', 'sina.com', 'sina.cn', 'qq.com', 'naver.com', 'hanmail.net', 'daum.net', 'nate.com', 'yahoo.co.jp', 'yahoo.co.kr', 'yahoo.co.id', 'yahoo.co.in', 'yahoo.com.sg', 'yahoo.com.ph', '163.com', 'yeah.net', '126.com', '21cn.com', 'aliyun.com', 'foxmail.com', 'hotmail.fr', 'live.fr', 'laposte.net', 'yahoo.fr', 'wanadoo.fr', 'orange.fr', 'gmx.fr', 'sfr.fr', 'neuf.fr', 'free.fr', 'gmx.de', 'hotmail.de', 'live.de', 'online.de', 't-online.de ', 'web.de', 'yahoo.de', 'libero.it', 'virgilio.it', 'hotmail.it', 'aol.it', 'tiscali.it', 'alice.it', 'live.it', 'yahoo.it', 'email.it', 'tin.it', 'poste.it', 'teletu.it', 'mail.ru', 'rambler.ru', 'yandex.ru', 'ya.ru', 'list.ru', 'hotmail.be', 'live.be', 'skynet.be', 'voo.be', 'tvcablenet.be', 'telenet.be', 'hotmail.com.ar', 'live.com.ar', 'yahoo.com.ar', 'fibertel.com.ar', 'speedy.com.ar', 'arnet.com.ar', 'yahoo.com.mx', 'live.com.mx', 'hotmail.es', 'hotmail.com.mx', 'prodigy.net.mx', 'yahoo.ca', 'hotmail.ca', 'bell.net', 'shaw.ca', 'sympatico.ca', 'rogers.com', 'yahoo.com.br', 'hotmail.com.br', 'outlook.com.br', 'uol.com.br', 'bol.com.br', 'terra.com.br', 'ig.com.br', 'itelefonica.com.br', 'r7.com', 'zipmail.com.br', 'globo.com', 'globomail.com', 'oi.com.br'];

var getCountryCodeFromName = function getCountryCodeFromName(countryName) {
  return Object.keys(isoCountries).find(function (key) {
    return isoCountries[key] === countryName;
  });
}; // TODO: move the setting to marketo config file


var MARKETO_SERVER_URL = '//go.imperva.com';
var MARKETO_APP_KEY = '727-WRL-406';
var marketoForms = global.marketoForms = global.marketoForms || {};
var siteUrl = location.protocol + '//' + location.host;

var MarketoForm =
/*#__PURE__*/
function () {
  function MarketoForm(formId) {
    var formArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var elem = arguments.length > 2 ? arguments[2] : undefined;
    var runNextFormFn = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, MarketoForm);

    this.uuid = formArgs.uuid || parseInt(Math.random() * 10000);
    this.uniqueIdPostfix = '_' + this.uuid;
    this.formId = formId;
    this.formArgs = formArgs;
    this.runNextFormFn = runNextFormFn;
    this.cbs = [];
    this.onSubmitCbs = [];
    this.onValidateCbs = [];
    this.pressOnEnterTimer = null;
    this.clickOnSubmitTimer = null;
    this.keyEnterPressed = false;
    this.submitBtnClicked = false;
    this.elem = elem;
    this.buttonText = this.getFormElem(this.form).find('.mktoButtonWrap button[type="submit"]').text();

    if (!this.elem) {
      console.error('MarketoForm:constructor missing elem param for form ID ', this.formId);
    }

    this.modifyElementsId();
    this.setupMarketoForm(formArgs);
    this.createForm();
    this.sendValidate();
    this.sendSubmit();
  }

  _createClass(MarketoForm, [{
    key: "createForm",
    value: function () {
      var _createForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.elem) {
                  $(this.elem).attr('id', "mktoForm_".concat(this.formId));
                }

                try {
                  if ('MktoForms2' in window) {
                    MktoForms2.loadForm(MARKETO_SERVER_URL, MARKETO_APP_KEY, this.formId, function (form) {
                      _this.form = form;
                      _this.formElem = _this.getFormElem(form);

                      _this.formElem.attr('id', '');

                      _this.formElem.addClass('mkto-loaded');

                      _this.isHtmlTemplate = $('.mktoTemplateBox', _this.formElem).length > 0;

                      if (_this.isHtmlTemplate) {
                        _this.setHtmlTemplate();
                      }

                      _this.fireEvent();

                      if (typeof _this.runNextFormFn === 'function') {
                        _this.runNextFormFn();
                      }

                      var formLoadedEvt = new CustomEvent('mktoFormLoaded', {
                        detail: _this.formElem.attr('data-form-id')
                      });

                      if ($(_this.formElem).length) {
                        $(_this.formElem)[0].dispatchEvent(formLoadedEvt);
                      }
                    }); // console.log(`register MktoForm id ${this.formId}`);
                  } else {
                    console.error('MktoForms2 is not define');
                  }
                } catch (error) {
                  console.error('Error in class MarketoForm', error);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createForm() {
        return _createForm.apply(this, arguments);
      }

      return createForm;
    }()
  }, {
    key: "snapShotValidation",
    value: function snapShotValidation() {
      var _this2 = this;

      this.onSuccess(function (form) {
        var dataToSend = {};
        var formElem = $(form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this2.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['name'] = (formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this2.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        dataToSend['telephone'] = formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['email'] = formElem.find("#Email".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['state'] = formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this2.uniqueIdPostfix)).val() : '';
        dataToSend['jobTitle'] = formElem.find("#Title".concat(_this2.uniqueIdPostfix)).val();
        dataToSend['company'] = formElem.find("#Company".concat(_this2.uniqueIdPostfix)).val();
        var eULAConsent = formElem.find($("[name=\"eULAConsent\"]"));
        dataToSend['eULAConsent'] = eULAConsent.prop('checked');
        dataToSend['eULAConsent_copy'] = eULAConsent.next().html();
        var countryInput = formElem.find("#Country".concat(_this2.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        dataToSend['country'] = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        $.ajax({
          type: 'POST',
          url: siteUrl + '/wp-json/imperva_snapshot/v1/register/',
          data: dataToSend,
          async: false,
          dataType: 'json',
          success: function success(data) {
            var response = $.parseJSON(data);

            if (response[0].includes('200')) {
              window.location.assign('/resources/snapshot-thank-you/');
            } else {
              window.location.assign('/resources/snapshot-problem/');
            }
          },
          error: function error() {
            window.location.assign('/resources/snapshot-problem/');
          }
        });
        return false;
      });
    }
  }, {
    key: "modifyElementsId",
    value: function modifyElementsId() {
      var _this3 = this;

      this.onLoad(function (form) {
        var formElem = _this3.getFormElem(form);

        if (formElem.length) {
          var fields = formElem.find('input, select, textarea');
          var labels = formElem.find('label');
          fields.each(function (i, el) {
            var $el = $(el);
            var id = $el.attr('id');

            if (id) {
              $el.attr('id', id + _this3.uniqueIdPostfix);
            }
          });
          labels.each(function (i, el) {
            var $el = $(el);
            var labelFor = $el.attr('for');

            if (labelFor) {
              $el.attr('for', labelFor + _this3.uniqueIdPostfix);
            }
          });
        }
      });
    }
  }, {
    key: "eCustomsValidation",
    value: function eCustomsValidation() {
      var _this4 = this;

      var thankYouUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.onSubmit(function (_form) {
        var formElem = $(_form.formElem);
        var FirstName = formElem.find("#FirstName".concat(_this4.uniqueIdPostfix)).val();
        var LastName = formElem.find("#LastName".concat(_this4.uniqueIdPostfix)).val();

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (FirstName.includes(' ') || FirstName.includes('test'))) {
          _form.setErrorMessage('FirstName', 'please enter a valid name');

          return false;
        }

        if ($('#allow_spaces').val() != '1' && _this4.formId == '2143' && (LastName.includes(' ') || LastName.includes('test'))) {
          _form.setErrorMessage('LastName', 'please enter a valid name');

          return false;
        }

        var fullName = (formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#fullNameTrendemon".concat(_this4.uniqueIdPostfix)).val() : FirstName + '-' + LastName).split(' ').join('-');
        var Phone = formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val() !== undefined ? formElem.find("#Phone".concat(_this4.uniqueIdPostfix)).val().split('-').join('') : '';
        var Email = formElem.find("#Email".concat(_this4.uniqueIdPostfix)).val();
        var State = formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() !== undefined ? '&state=' + formElem.find("#State".concat(_this4.uniqueIdPostfix)).val() : '';
        var Title = formElem.find("#Title".concat(_this4.uniqueIdPostfix)).val();
        var Company = formElem.find("#Company".concat(_this4.uniqueIdPostfix)).val().replace(' ', '%20');
        var countryInput = formElem.find("#Country".concat(_this4.uniqueIdPostfix));
        var countryName;

        if (countryInput.length) {
          countryName = countryInput.val().toLowerCase() == "cote d'ivoire" ? 'ivory coast' : countryInput.val().toLowerCase() == 'south sudan' ? 'sudan' : countryInput.val().toLowerCase();
        }

        var Country = getCountryCodeFromName(countryName) !== undefined ? getCountryCodeFromName(countryName) : countryName;
        var url = siteUrl + "/wp-json/ecustoms_screening/v1/formID/".concat(_this4.formId, "?email=").concat(Email, "&name=").concat(fullName, "&telephone=").concat(Phone, "&jobTitle=").concat(Title, "&country=").concat(Country).concat(State, "&company=").concat(Company);
        var approve = false;
        var locationAssign = false;
        $.ajax({
          url: url,
          async: false,
          dataType: 'json',
          success: function success(response) {
            if (response != null && response.approved) {
              approve = true;

              if (thankYouUrl != null) {
                locationAssign = thankYouUrl;
              }
            } else {
              if (response === null) {
                console.log('eCustoms not available');
              }

              locationAssign = '/resources/free-tools-thank-you/';
              approve = false;
            }
          }
        });
        _this4.location_assign = locationAssign;
        return approve;
      });
    }
  }, {
    key: "fireEvent",
    value: function fireEvent() {
      var _this5 = this;

      if (this.cbs) {
        this.cbs.forEach(function (cb) {
          return cb(_this5.form);
        });
      }
    }
  }, {
    key: "onLoad",
    value: function onLoad(cb) {
      if (typeof cb === 'function') {
        if (this.form) {
          cb(this.form);
        } else {
          if (!this.cbs) {
            this.cbs = [];
          }

          this.cbs.push(cb);
        }
      }

      return this;
    }
    /**
     * register for input/s events
     * @param {string} eventNames
     * the events name to register
     * cab be multy event etc. 'change, input'
     * @param {string|function} inputName
     * if inputName is string ==> register for specific input | Else: if inputName is function => register for all inputs
     * @param {?function} cb
     * the callback function for this events
     * @return {MarketoForm} to chaining functions
     */

  }, {
    key: "registerEvent",
    value: function registerEvent(eventNames, inputName, cb) {
      var _this6 = this;

      if (typeof inputName === 'function') {
        cb = inputName;
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              $(formElem).on(eventName, "input, textarea, select", cb);
            });
          }
        });
      } else if (inputName && typeof cb === 'function') {
        this.onLoad(function (form) {
          var formElem = _this6.getFormElem(form);

          if (eventNames) {
            eventNames.split(' ').filter(function (e) {
              return !!e;
            }).forEach(function (eventName) {
              // console.log(
              //   `register event ${eventName} to elem ${inputName}`,
              //   $(`input[name="${inputName}"], textarea[name="${inputName}"], select[name="${inputName}"]`, formElem).data('events')
              // );
              $(formElem).on(eventName, "input[name=\"".concat(inputName, "\"], textarea[name=\"").concat(inputName, "\"], select[name=\"").concat(inputName, "\"]"), cb);
            });
          }
        });
      }

      return this;
    }
  }, {
    key: "onSuccess",
    value: function onSuccess(cb) {
      var _this7 = this;

      if (typeof cb === 'function') {
        this.onLoad(function (form) {
          return form.onSuccess(function (values, followUpUrl) {
            var form_block = document.querySelector('.form-block');
            var form_wrap = document.querySelector('.form-section .form-wrapper');

            if (form_wrap && form_wrap.classList.contains('form-block-class')) {
              form_block.classList.add('form-block-success');
            }

            return cb(_this7, values, followUpUrl);
          });
        });
      }

      return this;
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(cb) {
      if (typeof cb === 'function') {
        this.onSubmitCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendSubmit",
    value: function sendSubmit() {
      var _this8 = this;

      this.onLoad(function (form) {
        return form.onSubmit(function (nativeValid) {
          var originalText = _this8.getButtonText(form);

          _this8.changeButtonText('Please wait', form);

          _this8.setButtonDisabled(form);

          var approvalsSubmit = [];

          _this8.onSubmitCbs.forEach(function (cb) {
            approvalsSubmit.push(cb(_this8));
          });

          if (!approvalsSubmit.includes(false) && nativeValid) {
            form.submittable(true);

            if (_this8.location_assign) {
              window.location.assign(_this8.location_assign);
            }

            return true;
          }

          _this8.changeButtonText(originalText, form);

          _this8.setButtonEnable(form);

          form.submittable(false);

          if (_this8.location_assign) {
            window.location.assign(_this8.location_assign);
          }

          return false;
        });
      });
    }
  }, {
    key: "onValidate",
    value: function onValidate(cb) {
      if (typeof cb === 'function') {
        this.onValidateCbs.push(cb);
      }

      return this;
    }
  }, {
    key: "sendValidate",
    value: function sendValidate() {
      var _this9 = this;

      this.onLoad(function (form) {
        return form.onValidate(function (nativeValid) {
          var approvalsValidate = [];

          _this9.onValidateCbs.forEach(function (cb) {
            approvalsValidate.push(cb(_this9));
          });

          if (!approvalsValidate.includes(false) && nativeValid) {
            form.submittable(true);
            return true;
          }

          form.submittable(false);
          return false;
        });
      });
    }
  }, {
    key: "setButtonText",
    value: function setButtonText(text) {
      var _this10 = this;

      this.onLoad(function (form) {
        return _this10.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').text(text);
      });
      return this;
    }
  }, {
    key: "setButtonDisabled",
    value: function setButtonDisabled(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('disabled', true);
    }
  }, {
    key: "setButtonEnable",
    value: function setButtonEnable(form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeAttr('disabled');
    }
  }, {
    key: "changeButtonText",
    value: function changeButtonText(text, form) {
      this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html(text);
    }
  }, {
    key: "getButtonText",
    value: function getButtonText(form) {
      return this.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').html();
    }
  }, {
    key: "setButtonClasses",
    value: function setButtonClasses(classes) {
      var _this11 = this;

      if (classes) {
        this.onLoad(function (form) {
          return _this11.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').removeClass('mktoButton').addClass(classes);
        });
      }

      return this;
    }
  }, {
    key: "setButtonEvents",
    value: function setButtonEvents(events) {
      var _this12 = this;

      if (events) {
        this.onLoad(function (form) {
          Object.entries(events).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            console.log(value);

            _this12.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr(key, value);
          });
        });
      }

      return this;
    }
  }, {
    key: "setButtonTarget",
    value: function setButtonTarget(target) {
      var _this13 = this;

      if (target) {
        this.onLoad(function (form) {
          return _this13.getFormElem(form).find('.mktoButtonWrap button[type="submit"]').attr('target', target);
        });
      }

      return this;
    }
  }, {
    key: "setValues",
    value: function setValues(values, cbFn) {
      this.onLoad(function (form) {
        form.setValues(values);

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "hasOption",
    value: function hasOption(name, value) {
      var formElem = this.formElem;
      if (!formElem) return false;
      var option = formElem.find("[name=\"".concat(name, "\"] option[value=\"").concat(value, "\"]"));
      return option.length > 0;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(field, value) {
      field.val(value);
    }
  }, {
    key: "setValue",
    value: function setValue(name, value, cbFn) {
      var _this14 = this;

      this.onLoad(function (form) {
        try {
          form.setValues(_defineProperty({}, name, value));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Faild to set form field value', {
            field: name,
            value: value
          });
        }

        var formElem = _this14.getFormElem(form);

        var input = $("[name=\"".concat(name, "\"]"), formElem);

        if (input && input.is('select')) {
          var option = input.find("option[value=\"".concat(value, "\"]"));

          if (option.length > 0) {
            option.attr('selected', 'selected');
          }
        }

        if (input && input.is(':visible')) {
          // fire change and blur event to trigger the validations
          input.change();
          input.blur();
        }

        if (typeof cbFn === 'function') {
          cbFn();
        }
      });
      return this;
    }
  }, {
    key: "setThankyouText",
    value: function setThankyouText(html) {
      var _this15 = this;

      if (html) {
        this.onSuccess(function () {
          var formElem = _this15.getFormElem();

          $(formElem).hide();
          var thankyouDiv = "\n          <div id=\"marketo_form_thankyou_".concat(_this15.formId, "\" class=\"marketo-form-thankyou-message\">\n            ").concat(html, "\n          </div>\n        ");
          $(formElem).parent().append(thankyouDiv);
          return false;
        });
      }
    }
  }, {
    key: "setThankyouUrl",
    value: function setThankyouUrl(url) {
      if (url) {
        this.onSuccess(function () {
          window.location.assign(url);
          return false;
        });
      }

      return this;
    }
  }, {
    key: "getFormElem",
    value: function getFormElem(form) {
      if (this.elem) {
        return $(this.elem);
      } else if (form) {
        return form.getFormElem();
      } else if (this.form) {
        return this.form.getFormElem();
      }

      return null;
    }
  }, {
    key: "getField",
    value: function getField(name) {
      var _this16 = this;

      return new Promise(function (resolve) {
        _this16.onLoad(function (form) {
          var formElem = _this16.getFormElem(form);

          var input = $("[name=\"".concat(name, "\"]"), formElem);
          resolve(input);
        });
      });
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      var _this17 = this;

      return new Promise(function (resolve) {
        _this17.getValues().then(function (vals) {
          resolve(vals[name]);
        });
      });
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this18 = this;

      return new Promise(function (resolve) {
        _this18.onLoad(function (form) {
          resolve(form.getValues());
        });
      });
    }
  }, {
    key: "setLables",
    value: function setLables(lables) {
      var _this19 = this;

      var keys = Object.keys(lables);
      keys.forEach(function (key) {
        _this19.setLable(key, lables[key]);
      });
      return this;
    }
  }, {
    key: "setAutoLables",
    value: function setAutoLables() {
      var _this20 = this;

      this.onLoad(function (form) {
        var formElem = _this20.getFormElem(form);

        var inputs = $("[name]", formElem);
        var labels = {};
        inputs && inputs.each(function (_, el) {
          if ($(el).prop('nodeName') !== 'SELECT' && $(el).attr('type') !== 'checkbox' && $(el).attr('autoLables') !== 'false') {
            var name = $(el).attr('name');
            var id = $(el).attr('id');
            var placeholder = $(el).attr('placeholder');
            var label = placeholder || name;

            if (id && label) {
              labels[id] = label;
              $(el).attr('placeholder', label === 'FirstName' ? 'First name' : label === 'LastName' ? 'Last name' : label);
            }
          }
        });

        if (labels) {
          _this20.setLables(labels);
        }
      });
      return this;
    }
  }, {
    key: "setLable",
    value: function setLable(id, text) {
      var _this21 = this;

      this.onLoad(function (form) {
        var formElem = _this21.getFormElem(form);

        var label = $("label[for=\"".concat(id, "\"]"), formElem);
        label.text(text);
      });
      return this;
    }
  }, {
    key: "hideField",
    value: function hideField(name, duration) {
      var _this22 = this;

      this.onLoad(function (form) {
        var formElem = _this22.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.hide(duration);
        }
      });
      return this;
    }
  }, {
    key: "hasField",
    value: function hasField(name) {
      return this.getField(name).then(function (input) {
        return input.length > 0;
      });
    }
  }, {
    key: "showField",
    value: function showField(name, duration) {
      var _this23 = this;

      this.onLoad(function (form) {
        var formElem = _this23.getFormElem(form);

        var fieldRow = $("[name=\"".concat(name, "\"]"), formElem).parents('.mktoFormRow:first');

        if (fieldRow) {
          fieldRow.show(duration);
        }
      });
      return this;
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(fieldName, error) {
      var _this24 = this;

      var scrollTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.onLoad(function (form) {
        var formElem = _this24.getFormElem(form);

        var input = $("[name=\"".concat(fieldName, "\"]"), formElem);
        var field = $(input).parents('.mktoFieldWrap:first');

        if (error) {
          input.removeClass('mktoValid');
          input.addClass('mktoInvalid');
          input.siblings('.mktoError').show();
          field.addClass('mktoInvalidField');
        } else {
          input.removeClass('mktoInvalid');
          field.removeClass('mktoInvalidField');
        }

        form.submittable(false);
        form.showErrorMessage(error, input ? MktoForms2.$(input.get(0)) : null); // scroll into invalid input

        if (scrollTo && !_this24.formArgs['doNotScrollOnError']) {
          var top = $(formElem).offset().top;
          var notInModal = !formElem.closest('.modal').length;

          if (notInModal) {
            var header = $('#header');
            top -= header.outerHeight();
            window.scroll({
              top: top,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      });
      return this;
    }
    /**
     * split the full name to Firstname and LastName
     * @param {string} fullName fullname input value
     * @return {{firstName, lastName}} splitedFullName
     */

  }, {
    key: "splitFullName",
    value: function splitFullName(fullName) {
      /**
       * capitalize all word in given line
       * @param {string} text
       * the line text will be capitalize
       * @example
       * input: "shalom s. tuby"
       * output: "Shalom S. Tuby"
       * @return {string} capitalize all word in given line
       */
      var capitalize = function capitalize(text) {
        return text.toLowerCase().split(' ').map(function (s) {
          return s.charAt(0).toUpperCase() + s.substring(1);
        }).join(' ');
      };

      fullName = fullName.trim();

      if (!fullName) {
        return {};
      } // remove duplicate spaces


      fullName = fullName.replace(/\s{2,}/g, ' ');
      var split = '';

      if (fullName.includes('　')) {
        split = fullName.split('　');
      } else {
        split = fullName.split(' ');
      }

      if (split.length) {
        var firstName = split[0];
        var lastName = split[1] ? split.slice(1).join(' ') : '';
        firstName = capitalize(firstName);
        lastName = capitalize(lastName);
        return {
          firstName: firstName,
          lastName: lastName
        };
      }

      return {};
    }
  }, {
    key: "sendEventOnNoCountry",
    value: function sendEventOnNoCountry() {
      var dataLayerToSend = {
        event: 'GAevent',
        eventCategory: 'country field',
        eventAction: 'view',
        eventLabel: 'request demo form'
      };

      if (!global.dataLayer) {
        global.dataLayer = [];
      }

      global.dataLayer.push(dataLayerToSend);
    }
  }, {
    key: "prePopulatedCountry",
    value: function prePopulatedCountry() {
      var _this25 = this;

      // console.log('prePopulatedCountry for ', this.formId);
      this.hideField('Country').registerEvent('change', 'Country', function (event) {
        var inputElem = $(event.target);
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          _this25.setLable('State', 'State');

          _this25.getField('State').then(function (input) {
            var parent = $(input).parents('.mktoFieldWrap:first');
            var inputType = 'select';
            parent.addClass("inputType_".concat(inputType));
          });
        }
      }); // initial country and state from geo service

      (0, _geoLocationService.getGeoLocationData)().then(function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            state = _ref3.state,
            error = _ref3.error,
            status = _ref3.status,
            country = _ref3.country,
            stateCode = _ref3.stateCode,
            postalcode = _ref3.postalcode;

        // console.log('set GEO location for ', this.formId);
        if (!error && status == _geoLocationService.FINISH_STATUS && country) {
          _this25.onLoad(function () {
            // do not trigger auto Country if the form is in HtmlTemplate mode
            if (_this25.isHtmlTemplate) return; // set the country field from the GEO service

            if (country) {
              if (_this25.hasOption('Country', country)) {
                _this25.setValue('Country', country, function () {
                  _this25.hideField('Country');

                  if (_this25.formElem.find("[name=\"State\"]").length > 0) {
                    if (stateCode || state) {
                      if (_this25.hasOption('State', stateCode)) {
                        _this25.setValue('State', stateCode, function () {
                          return _this25.hideField('State');
                        });
                      } else if (_this25.hasOption('State', state)) {
                        _this25.setValue('State', state, function () {
                          return _this25.hideField('State');
                        });
                      } else {
                        _this25.showField('State');

                        _this25.showField('Country');

                        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


                        console.error('Failed to set State from GeoLocation service');
                      }
                    }
                  }
                });
              } else {
                _this25.sendEventOnNoCountry();

                _this25.showField('Country'); // eslint-disable-next-line no-console


                console.error('Failed to set Country from GeoLocation service');
              }
            } // set the postal_code field from the GEO service


            if (postalcode && postalcode != '0000') {
              _this25.setValue('PostalCode', postalcode);
            }
          });
        } else {
          _this25.sendEventOnNoCountry();

          _this25.showField('Country');

          console.error('Failed to set Country from GeoLocation service');
        }
      }, function (err) {
        _this25.sendEventOnNoCountry(); // eslint-disable-next-line no-console


        console.error('Failed to get country from GeoLocation Service', err);

        _this25.showField('Country');
      });
    }
  }, {
    key: "setHiddenFields",
    value: function setHiddenFields(hiddenFields) {
      var _this26 = this;

      if (hiddenFields) {
        $.each(hiddenFields, function (key, value) {
          var currentKey = key == 'form_type' ? 'formType' : key;

          _this26.setValue(currentKey, value);
        });
      }
    }
  }, {
    key: "setupMarketoForm",
    value: function setupMarketoForm(args) {
      var _this27 = this;

      //add support for error messages translation, get error messages from global var with translations if it exist
      var full_name_error_message = '';
      var email_error = 'Must be valid email. example@yourdomain.com';
      var phone_error = 'Must be a phone number. 503-555-1212';
      var company_error = 'This field is required.';
      var title_error = 'This field is required.';
      var department_error = 'This field is required.';
      var mobilephone_error = 'Must be a phone number. 503-555-1212';
      var firstname_error = 'This field is required.';
      var lastname_error = 'This field is required.';

      if (typeof error_messages !== 'undefined') {
        full_name_error_message = error_messages.full_name_error_message !== undefined ? error_messages.full_name_error_message : '';
        email_error = error_messages.email_error;
        phone_error = error_messages.phone_error;
        company_error = error_messages.company_error;
        title_error = error_messages.title_error;
        department_error = error_messages.department_error;
        mobilephone_error = error_messages.mobilephone_error;
        firstname_error = error_messages.firstname_error;
        lastname_error = error_messages.lastname_error;
      }

      var FullNameErrorMessage = full_name_error_message ? full_name_error_message : (0, _translateService.translate)('marketo_form.full_name_error_message', 'First Name and Last Name required');

      if (!args['no_auto_label']) {
        this.setAutoLables();
      }

      if (args['pre_populated_country']) {
        this.prePopulatedCountry();
      }

      if (args['button_label']) {
        this.setButtonText(args['button_label']);
      }

      if (args['button_class']) {
        this.setButtonClasses(args['button_class']);
      }

      if (args['button_events']) {
        this.setButtonEvents(args['button_events']);
      }

      if (args['thankyou_url']) {
        this.thankyouPageUrl = args['thankyou_url'];
        this.setThankyouUrl(args['thankyou_url']);
      }

      if (args['hidden_fields']) {
        this.setHiddenFields(args['hidden_fields']);
      }

      if (args['validate_fullname']) {
        this.registerEvent('input', 'fullNameTrendemon', function (event) {
          var fullName = event.target.value;

          var _this27$splitFullName = _this27.splitFullName(fullName),
              firstName = _this27$splitFullName.firstName,
              lastName = _this27$splitFullName.lastName;

          _this27.setValue('FirstName', firstName);

          _this27.setValue('LastName', lastName);
        });
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var lastName = $("[name=\"LastName\"]", formElem).val();

          if (!lastName) {
            _form.setErrorMessage('fullNameTrendemon', FullNameErrorMessage);

            return false;
          }

          return true;
        }).registerEvent('blur', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee2(event) {
            var inputElem, parent, lastNameElem, lastName;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context2.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    _context2.next = 6;
                    return _this27.getField('LastName');

                  case 6:
                    lastNameElem = _context2.sent;
                    lastName = lastNameElem.val();

                    if (!lastName) {
                      setTimeout(function () {
                        inputElem.addClass('mktoInvalid');
                        inputElem.removeClass('mktoValid');
                        parent.addClass('mktoInvalidField');

                        _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
                      }, 0);
                    } else {
                      setTimeout(function () {
                        inputElem.removeClass('mktoInvalid');
                        parent.removeClass('mktoInvalidField');
                      }, 0);
                    }

                  case 9:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }()).registerEvent('focusin', 'fullNameTrendemon',
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          regeneratorRuntime.mark(function _callee3(event) {
            var inputElem, parent;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this27.getField('fullNameTrendemon');

                  case 2:
                    inputElem = _context3.sent;
                    parent = inputElem.parents('.mktoFieldWrap:first');
                    inputElem.removeClass('mktoInvalid');
                    parent.removeClass('mktoInvalidField'); //support error messages translation

                    if (typeof error_messages !== 'undefined') {
                      _this27.onLoad(function (form) {
                        form.showErrorMessage(FullNameErrorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                      });
                    }

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2) {
            return _ref5.apply(this, arguments);
          };
        }());
      }

      if (args['validate_private_email_domain']) {
        this.onSubmit(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).onValidate(function (_form) {
          var form = _form.form; // original form

          var formElem = _this27.getFormElem(form);

          var privateEmail = $("[name=\"Email\"]", formElem).val().toLowerCase();
          var emailDomain = privateEmail.split('@');

          if ($.inArray(emailDomain[1], emails) !== -1) {
            _form.setErrorMessage('Email', args['email_domain_error']);

            return false;
          }

          return true;
        }).registerEvent('blur', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee4() {
          var inputElem, email, emailDomain;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context4.sent;
                  email = inputElem.val().toLowerCase();
                  emailDomain = email.split('@');

                  if ($.inArray(emailDomain[1], emails) !== -1) {
                    setTimeout(function () {
                      inputElem.addClass('mktoInvalid');
                      inputElem.removeClass('mktoValid');

                      _this27.setErrorMessage('Email', args['email_domain_error'], false);
                    }, 0);
                  } else {
                    setTimeout(function () {
                      inputElem.removeClass('mktoInvalid');
                    }, 0);
                  }

                case 6:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))).registerEvent('focusin', 'Email',
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5() {
          var inputElem;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this27.getField('Email');

                case 2:
                  inputElem = _context5.sent;
                  inputElem.removeClass('mktoInvalid');

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })));
      }

      var validateNotEmpty = function validateNotEmpty(str) {
        return str.length;
      };

      var validateEmail = function validateEmail(str) {
        var re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return re.test(String(str).toLowerCase());
      };

      var validateNum = function validateNum(str) {
        return validateNotEmpty(str) && /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/.test(str);
      };

      var getValidatorByName = function getValidatorByName(name) {
        var meta = {
          Email: validateEmail,
          Phone: validateNum,
          Company: validateNotEmpty,
          Title: validateNotEmpty,
          MobilePhone: validateNum
        };
        return meta[name] || validateNotEmpty;
      };

      var inputsOnBlur = function inputsOnBlur(e, errorMessage) {
        var inputElem = jQuery(e.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();
        var validatorFn = getValidatorByName(inputElem.attr('name'));

        if (!validatorFn(val)) {
          setTimeout(function () {
            inputElem.addClass('mktoInvalid');
            inputElem.removeClass('mktoValid');
            parent.addClass('mktoInvalidField');

            _this27.setErrorMessage(inputElem.attr('name'), errorMessage, false);
          }, 0);
        } else {
          setTimeout(function () {
            inputElem.removeClass('mktoInvalid');
            parent.removeClass('mktoInvalidField');
          }, 0);
        }
      };

      var inputsOnFoucsIn =
      /*#__PURE__*/
      function () {
        var _ref8 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee6(e, errorMessage) {
          var inputElem, parent;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  inputElem = jQuery(e.target);
                  parent = inputElem.parents('.mktoFieldWrap:first');
                  inputElem.removeClass('mktoInvalid');
                  parent.removeClass('mktoInvalidField'); //support error messages translation

                  if (typeof error_messages !== 'undefined') {
                    _this27.onLoad(function (form) {
                      form.showErrorMessage(errorMessage, inputElem ? MktoForms2.$(inputElem.get(0)) : null);
                    });
                  }

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function inputsOnFoucsIn(_x3, _x4) {
          return _ref8.apply(this, arguments);
        };
      }();

      var inputsOnSubmit = function inputsOnSubmit(name, form, errorMessage) {
        if (typeof error_messages !== 'undefined') {
          var input = $("[name=\"".concat(name, "\"]"), form);
          var parent = input.parent();

          if (parent.hasClass('mktoFieldTouched') && parent.hasClass('mktoInvalidField')) {
            _this27.setErrorMessage(name, errorMessage, false);
          }
        }

        return true;
      };

      [['Email', args['email_invalid_error'] !== '' ? args['email_invalid_error'] : email_error], ['Phone', phone_error], ['Company', company_error], ['Title', title_error], ['Department', department_error], ['MobilePhone', mobilephone_error], ['FirstName', firstname_error], ['LastName', lastname_error]].forEach(function (field) {
        var name = field[0];
        var msg = field[1];

        _this27.registerEvent('blur', name, function (e) {
          inputsOnBlur(e, msg);
        });

        _this27.registerEvent('focusin', name, function (e) {
          inputsOnFoucsIn(e, msg);
        });

        _this27.onLoad(function (form) {
          var formElem = _this27.getFormElem(form);

          formElem.on('submit', {
            name: name,
            formElem: formElem,
            msg: msg
          }, function (e) {
            inputsOnSubmit(e.data.name, e.data.formElem, e.data.msg);
          });
        });
      }); // lets to know if submit was triggered by 'ENTER'

      var onKeyPress = function onKeyPress(e) {
        var key = e.key;

        if (key.toUpperCase().trim() === 'ENTER') {
          _this27.keyEnterPressed = true;
          clearTimeout(_this27.pressOnEnterTimer);
          _this27.pressOnEnterTimer = setTimeout(function () {
            _this27.keyEnterPressed = false;
          }, 1000);
        }
      }; // lets to know if submit was triggered by click


      var clickOnSubmitFn = function clickOnSubmitFn(e) {
        _this27.submitBtnClicked = true;
        clearTimeout(_this27.clickOnSubmitTimer);
        _this27.clickOnSubmitTimer = setTimeout(function () {
          _this27.submitBtnClicked = false;
        }, 1000);
      };

      this.onLoad(function (form) {
        var formElem = _this27.getFormElem(form);

        if (formElem.length) {
          var submitBtn = formElem.find('button[type="submit"]');
          submitBtn.on('click', clickOnSubmitFn);
        }

        document.addEventListener('keypress', onKeyPress);
      }); // remove error message for empty focused input

      this.onValidate(function (_form) {
        setTimeout(function (_form) {
          var $form = _this27.getFormElem(_form);

          var fullNameElem = $form.find('[name="fullNameTrendemon"]');
          var focusedElem = $(document.activeElement);

          var showEmptyMsg = function showEmptyMsg(name) {
            return _this27.setErrorMessage(name, '  ', false);
          }; // show empty error message when focused field is empty


          if (focusedElem.length && _this27.keyEnterPressed) {
            var focusedElemTagName = focusedElem[0].tagName.toUpperCase();
            var val = focusedElem.val();
            var valIsEmty = !val.length;

            if (valIsEmty && (focusedElemTagName === 'INPUT' || focusedElemTagName === 'SELECT' || focusedElemTagName === 'TEXTAREA')) {
              var name = focusedElem.attr('name');

              if (args['validate_fullname']) {
                if (!fullNameElem.val()) {
                  showEmptyMsg(name);
                }
              } else {
                showEmptyMsg(name);
              }

              return;
            }
          } // set error state if submit is clicked and field is empty


          if (args['validate_fullname'] && _this27.submitBtnClicked && !_this27.keyEnterPressed) {
            var lastNameElem = $form.find('[name="LastName"]');

            if (!fullNameElem.val() || !lastNameElem.val()) {
              var parent = fullNameElem.parents('.mktoFieldWrap:first');
              fullNameElem.addClass('mktoInvalid');
              fullNameElem.removeClass('mktoValid');
              parent.addClass('mktoInvalidField'); // className "mktoFieldTouched" needed for red border on the input

              parent.addClass('mktoFieldTouched');

              _this27.setErrorMessage('fullNameTrendemon', FullNameErrorMessage, false);
            }
          }

          _this27.submitBtnClicked = false;
          _this27.keyEnterPressed = false;
        }, 30, _form);
      });
      this.onLoad(function (form) {
        // set the input type on mktoFieldWrap element
        var formElem = _this27.getFormElem(form);

        if (typeof field_labels !== 'undefined') {
          $('label', formElem).each(function (i, elem) {
            var label = $(elem);

            if (typeof field_labels[label.text()] !== 'undefined') {
              label.text(field_labels[label.text()]);
            }
          });
        }

        $('input,textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = $(elem).attr('type');
          parent.addClass("inputType_".concat(inputType));

          if (typeof field_labels !== 'undefined') {
            var input = elem;

            if (typeof field_labels[input.getAttribute('placeholder')] !== 'undefined') {
              input.setAttribute('placeholder', field_labels[input.getAttribute('placeholder')]);
            }
          }
        });
        $('textarea', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'textarea';
          parent.addClass("inputType_".concat(inputType));
        });
        $('select', formElem).each(function (i, elem) {
          var parent = $(elem).parents('.mktoFieldWrap:first');
          var inputType = 'select';
          parent.addClass("inputType_".concat(inputType));

          if ($(elem).attr('autoLables') !== 'false') {
            parent.find('.mktoLabel').text(parent.find('option:first').text());
          }

          parent.find('option:first').text('Please choose');
        });
        /* Potential use for translating buttons, however a brute (overall) solution was found for Downloads in /themes/impv-resources/loop-templates/content-gated-ungated.php
        $('button', formElem).each((i, elem) => {
          const button_text = $(elem).html();
          if (typeof field_labels !== 'undefined') {
            if (field_labels[button_text] !== 'undefined') {
              $(elem).html( field_labels[button_text] );
            }
          }
        }); */
      }) // populate the input validation and focuse state to the parent div
      .registerEvent('focus blur', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        /**
         * inputElem.is(document.activeElement) is workaround to support focus on safari
         */

        if (inputElem.is(':focus') || inputElem.is(document.activeElement)) {
          parent.addClass('mktoFieldFocus');
        } else {
          parent.removeClass('mktoFieldFocus');
        }

        setTimeout(function () {
          if (inputElem.hasClass('mktoInvalid')) {
            parent.addClass('mktoInvalidField');
          } else {
            parent.removeClass('mktoInvalidField');
          }
        }, 0);
      }) // populate the input validation to the parent div
      .registerEvent('focusin keyup', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');

        if (inputElem.hasClass('mktoInvalid')) {
          parent.addClass('mktoInvalidField');
        } else {
          parent.removeClass('mktoInvalidField');
        }
      }).registerEvent('focusout', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first'); // for the first time the imput was touched

        parent.addClass('mktoFieldTouched');
      }).registerEvent('change', function (event) {
        var inputElem = $(event.target);
        var parent = inputElem.parents('.mktoFieldWrap:first');
        var val = inputElem.val();

        if (inputElem.is('select')) {
          val = ('option:selected', inputElem).val();
        }

        if (val) {
          parent.addClass('mktoFieldFill');
        } else {
          parent.removeClass('mktoFieldFill');
        }
      });
    }
  }, {
    key: "setHtmlTemplate",
    value: function setHtmlTemplate() {
      $(this.formElem).addClass('html-template');
    }
  }], [{
    key: "register",
    value: function register() {
      // find forms
      var formNodes = _toConsumableArray(document.querySelectorAll('form.marketo-form')); // create list with unique ids


      this.formIds = formNodes.reduce(function (list, form) {
        var id = form.dataset.formId;

        if (id && list.indexOf(id) === -1) {
          list.push(id);
        }

        return list;
      }, []); // init marketo forms for each ID

      this.formIds.forEach(function (formId) {
        // find forms with current id
        var idForms = _toConsumableArray(document.querySelectorAll("form.marketo-form[data-form-id=\"".concat(formId, "\"]"))); // next form with the same ID will be loaded on callback that takes MktoForms2.loadForm function


        (function loadFormHandler(idForms) {
          if (idForms.length) {
            var formEl = idForms.shift();
            var nextFormFn = loadFormHandler.bind(null, _toConsumableArray(idForms));
            var index = formNodes.indexOf(formEl);
            registerForm(index, formEl, nextFormFn);
          }
        })(idForms);
      });

      function registerForm(idx, e, runNextFormFn) {
        var formArgs = {};
        $(e).data('index', idx);

        try {
          var formArgsKey = $(e).data('form-args');

          if (formArgsKey && formArgsKey in window) {
            formArgs = window[formArgsKey];
          }
        } catch (err) {
          console.error('Faild to parse form args from element data', err);
        }

        var getFormId = function getFormId(e) {
          if (formArgs) {
            if (formArgs.form_id) {
              return formArgs.form_id;
            }
          }

          var formId = $(e).data('form-id');

          if (!formId) {
            var elId = $(e).attr('id');

            if (elId) {
              var s = elId.split('_');

              if (s.length > 1) {
                formId = s.pop();
              }
            }
          }

          return formId;
        };

        var formId = getFormId(e);
        console.info('register marketo form', formId);

        if (!formArgs.uuid) {
          formArgs.uuid = parseInt(Math.random() * 10000);
        }

        if (formId) {
          var uuid = formArgs.uuid;
          $(e).attr('data-uuid', uuid); // if someone waiting to this form - fire event

          var instance = new MarketoForm(formId, formArgs, e, runNextFormFn);

          if (typeof marketoForms[formId] === 'function') {
            var cb = marketoForms[formId];
            marketoForms[uuid] = instance;
            cb(instance);
          } else {
            marketoForms[uuid] = instance;
          }
        }
      }
    }
  }, {
    key: "findById",
    value: function findById(formId) {
      return new Promise(function (resolve) {
        var found = Object.values(marketoForms).filter(function (m) {
          return m.formId == formId;
        });

        if (found && found.length > 0) {
          resolve(found[0]);
        } else {
          marketoForms[formId] = resolve;
        }
      });
    }
  }]);

  return MarketoForm;
}();

exports["default"] = MarketoForm;

var createForm = function createForm(formId) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var elem = arguments.length > 2 ? arguments[2] : undefined;
  return new MarketoForm(formId, args, elem);
};

exports.createForm = createForm;

var findById = function findById(formId) {
  return MarketoForm.findById(formId);
};

exports.findById = findById;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"impv/src/js/services/geo-location-service":22,"impv/src/js/services/translate-service":25}],19:[function(require,module,exports){
"use strict";

(function ($) {
  $(document).ready(function () {
    $('.navigation-dot').on('click', function (e) {
      var sectionPosition = $(e.currentTarget).attr('data-anchor');
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.navigation-anchor[anchor="' + sectionPosition + '"]').offset().top - 60
      }, 1000);
    });

    function Utils() {}

    Utils.prototype = {
      constructor: Utils,
      isElementInView: function isElementInView(element, fullyInView, gridTop, gridBottom) {
        var pageTop = $(window).scrollTop() + gridTop;
        var pageBottom = pageTop + $(window).height() - gridBottom;
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
          return pageTop < elementTop && pageBottom > elementBottom;
        } else {
          return elementTop <= pageBottom && elementBottom >= pageTop;
        }
      }
    };
    var Utils = new Utils();
    var windowHeight = $(window).height(),
        top = 0.0,
        bottom = 0.5,
        gridTop = windowHeight * top,
        gridBottom = windowHeight * bottom;
    $(window).on('load scroll', function () {
      $('.navigation-anchor').each(function (_, e) {
        var isElementInView = Utils.isElementInView($(e), false, gridTop, gridBottom);

        if (isElementInView) {
          var navigationPosition = $(e).attr('anchor');
          var $currentNavigation = $('.navigation-dot[data-anchor="' + navigationPosition + '"]');
          $currentNavigation.addClass('active');
          $currentNavigation.siblings().each(function (_, e) {
            $(e).removeClass('active');
          });
        }
      });
    });
  });
})(jQuery);

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var GOOGLE_GEOCODE_CLIENT_API_KEY = window.pageGlobalData.GOOGLE_GEOCODE_CLIENT_API_KEY;
var _default = {
  API_KEY: GOOGLE_GEOCODE_CLIENT_API_KEY,
  BASE_URL: 'https://www.googleapis.com/geolocation/v1/geolocate'
};
exports["default"] = _default;

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenMode = exports["default"] = exports.DESKTOP_HD_SCREEN_MODE = exports.DESKTOP_SCREEN_MODE = exports.LAPTOP_SCREEN_MODE = exports.TABLET_SCREEN_MODE = exports.MOBILE_SCREEN_MODE = exports.screenWidthModes = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var screenWidthModes = {
  MOBILE: 767,
  TABLET: 1023,
  LAPTOP: 1199,
  DESKTOP: 1419,
  DESKTOP_HD: 1420
};
exports.screenWidthModes = screenWidthModes;
var MOBILE_SCREEN_MODE = screenWidthModes.MOBILE;
exports.MOBILE_SCREEN_MODE = MOBILE_SCREEN_MODE;
var TABLET_SCREEN_MODE = screenWidthModes.TABLET;
exports.TABLET_SCREEN_MODE = TABLET_SCREEN_MODE;
var LAPTOP_SCREEN_MODE = screenWidthModes.LAPTOP;
exports.LAPTOP_SCREEN_MODE = LAPTOP_SCREEN_MODE;
var DESKTOP_SCREEN_MODE = screenWidthModes.DESKTOP;
exports.DESKTOP_SCREEN_MODE = DESKTOP_SCREEN_MODE;
var DESKTOP_HD_SCREEN_MODE = screenWidthModes.DESKTOP_HD;
exports.DESKTOP_HD_SCREEN_MODE = DESKTOP_HD_SCREEN_MODE;

var DetectScreenMode =
/*#__PURE__*/
function () {
  function DetectScreenMode() {
    var _this = this;

    _classCallCheck(this, DetectScreenMode);

    this.registeredcb = [];
    this.delay = 200;
    this.timeout = false; // register resize event

    this.setMode($(window).width());
    $(window).on('resize', function (_) {
      return _this.resize();
    });
  }

  _createClass(DetectScreenMode, [{
    key: "resize",
    value: function resize() {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function (_) {
        var width = $(window).width();

        _this2.setMode(width);
      }, this.delay);
    }
  }, {
    key: "setMode",
    value: function setMode(screenWidth) {
      var _this3 = this;

      if (screenWidth <= screenWidthModes.MOBILE) {
        this.mode = screenWidthModes.MOBILE;
      } else if (screenWidth <= screenWidthModes.TABLET) {
        this.mode = screenWidthModes.TABLET;
      } else if (screenWidth <= screenWidthModes.LAPTOP) {
        this.mode = screenWidthModes.LAPTOP;
      } else if (screenWidth <= screenWidthModes.DESKTOP) {
        this.mode = screenWidthModes.DESKTOP;
      } else {
        this.mode = screenWidthModes.DESKTOP_HD;
      }

      if (this.oldmode != this.mode) {
        this.registeredcb.forEach(function (fn) {
          return fn(_this3.mode, _this3.oldmode);
        });
      }

      this.oldmode = this.mode;
    }
  }, {
    key: "getMode",
    value: function getMode() {
      return this.mode;
    }
  }, {
    key: "register",
    value: function register(fn) {
      if (typeof fn == 'function') {
        this.registeredcb.push(fn);
      }
    }
  }]);

  return DetectScreenMode;
}();

var instance = new DetectScreenMode();
var _default = instance;
exports["default"] = _default;

var getScreenMode = function getScreenMode() {
  return instance.getMode();
};

exports.getScreenMode = getScreenMode;

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ERROR_STATUS = exports.FINISH_STATUS = exports.IN_PROGRESS_STATUS = exports.INITIAL_STATUS = exports.getGeoLocationData = exports.GeoLocationService = void 0;

var _googleGeolocationApi = _interopRequireDefault(require("../services/google-geolocation-api"));

var _sessionStorageService = _interopRequireDefault(require("./session-storage-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// create a uniqe symble
var singleton = Symbol();
/**
 *
 * This class is service to user data (country etc.)
 *
 * @example
 * import {getGeoLocationData} from './services/geo-location-service'
 * getGeoLocationData().then((data) => {
 *  // do something...
 * })
 *
 */

var GeoLocationService =
/*#__PURE__*/
function () {
  _createClass(GeoLocationService, null, [{
    key: "instance",

    /** process status */

    /** const keys */

    /**
     * @default GEO_LOCATION_DATA
     */

    /**
     * @default GEO_LOCTION_FINISHED
     */
    // return a singleton instance
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GeoLocationService();
      }

      return this[singleton];
    }
  }]);

  function GeoLocationService() {
    _classCallCheck(this, GeoLocationService);

    this.sessionStorageService = _sessionStorageService["default"];
    this.googleGeolocationAPI = _googleGeolocationApi["default"];
    this.baseURL = '/wp-json/geoLocationData/v1/geo';
    this.state = {
      status: GeoLocationService.INITIAL
    };
    this.init();
  }

  _createClass(GeoLocationService, [{
    key: "setState",
    value: function setState(newState) {
      var state = this.state;
      this.state = _objectSpread({}, state, {}, newState);

      if (this.state.status == GeoLocationService.ERROR) {
        console.error('GeoLocationService: An error occurred while trying to get user country', this.state.error);
        this.fireEvent(this.state);
      } else if (this.state.status == GeoLocationService.FINISH) {
        var _this$state = this.state,
            country = _this$state.country,
            countryCode = _this$state.countryCode,
            _state = _this$state.state,
            stateCode = _this$state.stateCode,
            city = _this$state.city,
            postalcode = _this$state.postalcode;
        this.sessionStorageService.setItem(GeoLocationService.CACHE_KEY, {
          country: country,
          countryCode: countryCode,
          state: _state,
          stateCode: stateCode,
          city: city,
          postalcode: postalcode
        });
        this.onFinish();
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state;
    }
    /**
     *
     * @description register the user data loaded
     * this event will fire after all the process finished
     *
     * @example import {getGeoLocationData} from './services/geo-location-service';
     *  getGeoLocationData.then((data) => console.log('user data', data));
     *  or:
     *  $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, (data) => console.log('user data', data));
     * @return {Promise<object>}
     * return Promise object
     */

  }, {
    key: "fireEvent",
    value: function fireEvent(data) {
      $(document).trigger(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, data);
    }
  }, {
    key: "onFinish",
    value: function onFinish() {
      this.fireEvent(this.state);
    }
    /**
     *
     * get the user data from incapsula service
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserData",
    value: function getUserData() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // console.log(`GET ${this.baseURL}`);
        $.get(_this.baseURL).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            }
          }

          return reject('No data recived');
        }, function (err) {
          reject(err);
        });
      });
    }
    /**
     * getUserDataUsingLocation:
     *
     * get the user data from google geocodding service
     *
     * @param {{lat: string, lan: string}} latlng
     *  lan and lat location
     *
     * @return {Promise<{country:string,countryCode:string,data:string,stateCode:string,city:string,postalcode:string}>}
     * return promise with result object
     */

  }, {
    key: "getUserDataUsingLocation",
    value: function getUserDataUsingLocation(latlng) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // console.log(`POST ${this.baseURL}`, latlng);
        $.post(_this2.baseURL, latlng).then(function (res) {
          if (res && res.success && res.result) {
            var data = res.result;

            if (data.country_name) {
              return resolve({
                country: data.country_name,
                countryCode: data.country_code,
                state: data.state_name,
                stateCode: data.state_code,
                city: data.city_name,
                postalcode: data.postal_code
              });
            } else {
              return reject('No data provided, no country name was return');
            }
          } else {
            return reject('No data provided, failed');
          }
        }, function (err) {
          reject('request to server failed ' + err);
        });
      });
    }
  }, {
    key: "getLatLan",
    value: function getLatLan() {
      return this.googleGeolocationAPI.getLatLan();
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;

      this.setState({
        status: GeoLocationService.IN_PROGRESS
      }); // if the data already in cache return from cache

      var data = this.sessionStorageService.getItem(GeoLocationService.CACHE_KEY); // if the data found in cache return this data;

      if (data) {
        this.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
        return;
      } // else, start request the user data from the server
      // tring to get the user country name from incapsula service


      this.getUserData().then(function (data) {
        /**
         * if got the data finish the process and save the data to state and fire finish event
         */
        _this3.setState(_objectSpread({
          status: GeoLocationService.FINISH
        }, data));
      }, // else; try another way:
      function (err) {
        // get the lan and lat location from google service
        _this3.getLatLan().then(function (latlng) {
          // parse the lan lat location to country name unsing google geocoding service
          _this3.getUserDataUsingLocation(latlng).then(function (data) {
            // if got the data finish the process and save the data to state and fire finish event
            _this3.setState(_objectSpread({
              status: GeoLocationService.FINISH
            }, data));
          }, function (err) {
            // console.error('Faild to get user data with latlan', err);
            _this3.setState({
              status: GeoLocationService.ERROR,
              error: err
            });
          });
        }, function (err) {
          // console.error('Faild to get user data', err);
          _this3.setState({
            status: GeoLocationService.ERROR,
            error: err
          });
        });
      });
    }
  }], [{
    key: "getGeoLocationData",
    value: function getGeoLocationData() {
      var instance = GeoLocationService.instance;
      return new Promise(function (resolve, reject) {
        if (instance.getState().status == GeoLocationService.FINISH) {
          resolve(instance.getState());
        } else {
          var cbFn = function cbFn(_, data) {
            reject(data.error);
            $(document).off(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
          };

          reject('No country data found');
          $(document).on(GeoLocationService.GEO_LOCTION_FINISHED_EVENT, cbFn);
        }
      });
    }
  }]);

  return GeoLocationService;
}();

exports.GeoLocationService = GeoLocationService;

_defineProperty(GeoLocationService, "INITIAL", 'INITIAL');

_defineProperty(GeoLocationService, "IN_PROGRESS", 'IN_PROGRESS');

_defineProperty(GeoLocationService, "FINISH", 'FINISH');

_defineProperty(GeoLocationService, "ERROR", 'ERROR');

_defineProperty(GeoLocationService, "CACHE_KEY", 'GEO_LOCATION_DATA');

_defineProperty(GeoLocationService, "GEO_LOCTION_FINISHED_EVENT", 'GEO_LOCTION_FINISHED');

var getGeoLocationData = GeoLocationService.getGeoLocationData;
exports.getGeoLocationData = getGeoLocationData;
var INITIAL_STATUS = GeoLocationService.INITIAL;
exports.INITIAL_STATUS = INITIAL_STATUS;
var IN_PROGRESS_STATUS = GeoLocationService.IN_PROGRESS;
exports.IN_PROGRESS_STATUS = IN_PROGRESS_STATUS;
var FINISH_STATUS = GeoLocationService.FINISH;
exports.FINISH_STATUS = FINISH_STATUS;
var ERROR_STATUS = GeoLocationService.ERROR;
exports.ERROR_STATUS = ERROR_STATUS;
var _default = GeoLocationService.instance;
exports["default"] = _default;

},{"../services/google-geolocation-api":23,"./session-storage-service":24}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _googleApi = _interopRequireDefault(require("../config/google-api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var API_KEY = _googleApi["default"].API_KEY,
    BASE_URL = _googleApi["default"].BASE_URL; // create a uniqe symble

var singleton = Symbol();

var GoogleGeolocationAPI =
/*#__PURE__*/
function () {
  function GoogleGeolocationAPI() {
    _classCallCheck(this, GoogleGeolocationAPI);
  }

  _createClass(GoogleGeolocationAPI, [{
    key: "createRequest",
    value: function createRequest(url) {
      return new Promise(function (resolve, reject) {
        $.post(url).done(resolve).fail(reject);
      });
    } // return a promise

  }, {
    key: "getLatLan",
    value: function getLatLan() {
      var url = "".concat(BASE_URL, "?key=").concat(API_KEY);
      return this.createRequest(url).then(function (res) {
        var _res$location = res.location,
            lat = _res$location.lat,
            lng = _res$location.lng; // convert lng to lan

        return {
          lat: lat,
          lan: lng
        };
      })["catch"](function (err) {
        return console.error('Faild to request lan - lat from google api');
      });
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new GoogleGeolocationAPI();
      }

      return this[singleton];
    }
  }]);

  return GoogleGeolocationAPI;
}();

var _default = GoogleGeolocationAPI.instance;
exports["default"] = _default;

},{"../config/google-api":20}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isBrowserSupportSessionStorage = function isBrowserSupportSessionStorage() {
  return 'sessionStorage' in window;
}; // create a uniqe symble


var singleton = Symbol();

var SessionStorageService =
/*#__PURE__*/
function () {
  _createClass(SessionStorageService, null, [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new SessionStorageService();
      }

      return this[singleton];
    }
  }]);

  function SessionStorageService() {
    _classCallCheck(this, SessionStorageService);

    this.isSupported = isBrowserSupportSessionStorage();

    if (this.isSupported) {
      this.sessionStorage = window.sessionStorage;
    }
  }
  /**
   * load the value from sessionStorage
   * the value will parse to object using JSON.parse
   * @param {string} key
   * @param {object} value
   * @return {object}
   * TODO: implement expired date option, should return null if date is expired
   */


  _createClass(SessionStorageService, [{
    key: "getItem",
    value: function getItem(key) {
      try {
        if (!this.isSupported) return null;
        var value = this.sessionStorage.getItem(key);

        if (value) {
          return JSON.parse(value);
        } else {
          return null;
        }
      } catch (error) {
        console.log('An error occurred in SessionStorageService:getItem', error);
      }
    }
    /**
     * save the value in sessionStorage
     * the value will parse to string using JSON.stringify
     * @param {string} key
     * @param {object} value
     * @return {object}
     * TODO: implement expired date option,
     * should save the expired date as new item
     */

  }, {
    key: "setItem",
    value: function setItem(key, value) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.log('An error occurred in SessionStorageService:setItem', error);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.removeItem(key);
      } catch (error) {
        console.log('An error occurred in SessionStorageService:removeItem', error);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      try {
        if (!this.isSupported) return false;
        return this.sessionStorage.clear();
      } catch (error) {
        console.log('An error occurred in SessionStorageService:clear', error);
      }
    }
  }, {
    key: "generateKey",
    value: function generateKey(object) {
      var _this = this;

      if (!object) {
        return '';
      } else if (Array.isArray(object)) {
        return object.map(function (i) {
          return _this.generateKey(i);
        }).join('_');
      } else if (_typeof(object) === 'object') {
        return Object.keys(object).map(function (key) {
          return key + '_' + _this.generateKey(object[key]);
        }).join('_');
      }

      return object;
    }
  }]);

  return SessionStorageService;
}();

var _default = SessionStorageService.instance;
exports["default"] = _default;

},{}],25:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function byString(o, s) {
  try {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    s = s.replace(/^\./, ''); // strip a leading dot

    var a = s.split('.');

    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];

      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }

    return o;
  } catch (error) {
    return undefined;
  }
}

var TranslateService =
/*#__PURE__*/
function () {
  _createClass(TranslateService, null, [{
    key: "instance",
    get: function get() {
      if (!global.TranslateService) {
        global.TranslateService = new TranslateService();
      }

      return global.TranslateService;
    }
  }]);

  function TranslateService() {
    _classCallCheck(this, TranslateService);

    this.translate = this.translate.bind(this);
  }

  _createClass(TranslateService, [{
    key: "getTranlateMap",
    value: function getTranlateMap() {
      if (!this.tranlateMap) {
        this.tranlateMap = window.TranslateMap;
      }

      return this.tranlateMap;
    }
    /**
     * translate and field from Translate Option page on WP admin
     *
     * @param {string} field the field name (i.e. 'marketo_form.full_name_error_message')
     * @param {string | any} defaultValue if value is not exsist return this default value
     * @return {string} the translated text (or default value)
     *
     * @example
     *    import { translate } from 'impv/src/js/services/translate-service';
     *    translate('section.field_name', 'some_default_value_str');
     * 
     */

  }, {
    key: "translate",
    value: function translate() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tranlateMap = this.getTranlateMap();

      if (!field || !tranlateMap) {
        return defaultValue;
      } else {
        return byString(tranlateMap, field) || defaultValue;
      }
    }
  }]);

  return TranslateService;
}();

var _default = TranslateService.instance;
exports["default"] = _default;
var translate = TranslateService.instance.translate;
exports.translate = translate;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[8]);
